(function () {
  var DAY_NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  window.selectedAddOnIds = window.selectedAddOnIds || [];
  window.selectedAddOnGuests = window.selectedAddOnGuests || {};
  window.selectedAddOnDates = window.selectedAddOnDates || {};
  window.selectedAddOnTimeSlots = window.selectedAddOnTimeSlots || {};

  var API_BASE = 'https://ejuno.skylinxtech.co';

  function addonCanBookSeparately(addon) {
    return !!(addon && addon.canBookSeparately !== false);
  }

  function selectedDates() {
    return typeof window.getCdpSelectedDates === 'function' ? window.getCdpSelectedDates() : (window.selectedDates || []);
  }

  function authHeader() {
    var token = localStorage.getItem('authToken') || '';
    if (!token) return null;
    return token.indexOf('Bearer ') === 0 ? token : 'Bearer ' + token;
  }

  function getInternalProductId() {
    var pd = window.productDetails || (typeof productDetails !== 'undefined' ? productDetails : null) || {};
    return pd._id || pd.productId || null;
  }

  function normalizeDateStr(value) {
    if (!value) return '';
    return String(value).slice(0, 10);
  }

  function sanitizeAddonItem(item) {
    var next = {
      addonId: String(item.addonId),
      datesOfBooking: Array.isArray(item.datesOfBooking) ? item.datesOfBooking.slice() : []
    };
    if (item.noOfPersons != null) next.noOfPersons = item.noOfPersons;
    if (item.timeSlot && item.timeSlot.startTime) {
      next.timeSlot = { startTime: item.timeSlot.startTime, endTime: item.timeSlot.endTime };
    }
    return next;
  }

  /** API field is always `selectedAddOns` (capital O). Strip legacy `selectedAddons`. */
  function getSelectedAddonsFromData(data) {
    if (!data) return [];
    return data.selectedAddOns || data.selectedAddons || [];
  }

  function ensureSelectedAddOnsApiKey(data) {
    if (!data || typeof data !== 'object') return data;
    var items = getSelectedAddonsFromData(data);
    if (items.length) data.selectedAddOns = items;
    else delete data.selectedAddOns;
    delete data.selectedAddons;
    return data;
  }

  function moneyFmt(n) {
    return typeof formatMoney === 'function' ? formatMoney(n) : (Number(n) || 0).toFixed(2);
  }

  function curSym() {
    return typeof getCurrencySymbol === 'function' ? getCurrencySymbol() : '$';
  }

  function resolveSelectedVariant(pd) {
    var details = pd || window.productDetails || (typeof productDetails !== 'undefined' ? productDetails : null);
    if (!details || !Array.isArray(details.variants) || !details.variants.length) return null;
    var variantId = null;
    try {
      var urlParams = new URLSearchParams(window.location.search);
      variantId = urlParams.get('variant');
      if (!variantId) {
        var pathParts = window.location.pathname.split('/');
        var variantIndex = pathParts.indexOf('variant');
        if (variantIndex !== -1 && pathParts[variantIndex + 1]) variantId = pathParts[variantIndex + 1];
      }
    } catch (e) {}
    if (!variantId && typeof getVariantFromUrl === 'function') variantId = getVariantFromUrl();
    return variantId
      ? details.variants.find(function (v) { return v.id == variantId || v.variantId == variantId; }) || details.variants[0]
      : details.variants[0];
  }

  function getAddonById(id) {
    var variant = resolveSelectedVariant();
    if (!variant || !Array.isArray(variant.addOns)) return null;
    return variant.addOns.find(function (a) { return String(a._id) === String(id); }) || null;
  }

  function isBundleAddOn(a) { return String((a && a.priceType) || '').toLowerCase() === 'bundle'; }
  function isFixedAddOn(a) { return String((a && a.priceType) || '').toLowerCase() === 'fixed'; }
  function addonAllowsMultipleDates(addon) { return !addon || addon.allowMultipleBookingsPerDay !== false; }
  function addonRequiresTimeSlot(addon) { return !!(addon && Array.isArray(addon.timeSlots) && addon.timeSlots.length); }

  function getUniqueAddonTimeSlots(addon) {
    if (!addon || !Array.isArray(addon.timeSlots)) return [];
    var seen = {};
    return addon.timeSlots.filter(function (slot) {
      if (!slot || !slot.startTime || !slot.endTime) return false;
      var key = slot.startTime + '|' + slot.endTime;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function getAddonSlotKey(slot) {
    if (!slot || !slot.startTime || !slot.endTime) return '';
    return slot.startTime + '|' + slot.endTime;
  }

  function getAddonSlotCapacity(addon, slot) {
    if (slot && slot.capacity != null && !isNaN(Number(slot.capacity))) {
      var slotCap = Number(slot.capacity);
      if (slotCap >= 1) return slotCap;
    }
    if (addon && addon.maxBookingsPerSlot != null && !isNaN(Number(addon.maxBookingsPerSlot))) {
      var maxCap = Number(addon.maxBookingsPerSlot);
      if (maxCap >= 1) return maxCap;
    }
    return 1;
  }

  function getAddonPreStandaloneReservations(addon) {
    if (!addon || !Array.isArray(addon.preStandaloneReservations)) return [];
    return addon.preStandaloneReservations;
  }

  /**
   * Remaining capacity for a date (+ optional time slot) from addon.preStandaloneReservations.
   * No entry => full capacity. Entry with remainingCapacity => use that value.
   */
  function getSlotRemainingCapacity(addon, selectedDate, slot) {
    var ds = normalizeDateStr(selectedDate);
    if (!ds || !addon) return 0;
    var preReservations = getAddonPreStandaloneReservations(addon);

    if (slot && slot.startTime && slot.endTime) {
      var existingSlot = null;
      for (var i = 0; i < preReservations.length; i++) {
        var r = preReservations[i];
        if (!r || normalizeDateStr(r.date) !== ds) continue;
        var ts = r.timeSlot;
        if (ts && ts.startTime === slot.startTime && ts.endTime === slot.endTime) {
          existingSlot = r;
          break;
        }
      }
      if (existingSlot && existingSlot.remainingCapacity != null && !isNaN(Number(existingSlot.remainingCapacity))) {
        return Math.max(0, Number(existingSlot.remainingCapacity));
      }
      return getAddonSlotCapacity(addon, slot);
    }

    // Day-level add-on (no time slots): match date entry with null/missing timeSlot
    var existingDay = null;
    for (var j = 0; j < preReservations.length; j++) {
      var entry = preReservations[j];
      if (!entry || normalizeDateStr(entry.date) !== ds) continue;
      if (!entry.timeSlot || (!entry.timeSlot.startTime && !entry.timeSlot.endTime)) {
        existingDay = entry;
        break;
      }
    }
    if (existingDay && existingDay.remainingCapacity != null && !isNaN(Number(existingDay.remainingCapacity))) {
      return Math.max(0, Number(existingDay.remainingCapacity));
    }
    return getAddonSlotCapacity(addon, null);
  }

  function isAddonStandaloneSlotBooked(addon, dateStr, slot) {
    if (!addon || !slot) return false;
    return getSlotRemainingCapacity(addon, dateStr, slot) <= 0;
  }

  function isAddonStandaloneDateFullyBooked(addon, dateStr) {
    var ds = normalizeDateStr(dateStr);
    if (!ds || !addon) return false;

    if (addonRequiresTimeSlot(addon)) {
      var slots = getUniqueAddonTimeSlots(addon);
      if (!slots.length) return false;
      return slots.every(function (slot) {
        return getSlotRemainingCapacity(addon, ds, slot) <= 0;
      });
    }

    return getSlotRemainingCapacity(addon, ds) <= 0;
  }

  function isDateFullyBookedForAddon(addon, dateStr) {
    return isAddonStandaloneDateFullyBooked(addon, dateStr);
  }

  function hasAddonAvailableSlotOnDate(addon, dateStr) {
    return !isAddonStandaloneDateFullyBooked(addon, dateStr);
  }

  function isAddonStandaloneDateBooked(addon, dateStr) {
    return isAddonStandaloneDateFullyBooked(addon, dateStr);
  }

  function formatAddonSlotCapacityLabel(remaining) {
    var n = Number(remaining);
    if (isNaN(n) || n <= 0) return ' (Full)';
    if (n === 1) return ' (1 spot left)';
    return ' (' + n + ' spots left)';
  }

  function buildAddonSlotChipHtml(addon, slot, options) {
    options = options || {};
    var id = options.addonId || String(addon._id);
    var dateStr = options.dateStr || '';
    var active = !!options.active;
    var remaining = dateStr ? getSlotRemainingCapacity(addon, dateStr, slot) : getAddonSlotCapacity(addon, slot);
    var slotBooked = dateStr ? remaining <= 0 : false;
    var showCapacity = !!dateStr && remaining > 0 && remaining < getAddonSlotCapacity(addon, slot);
    var cls = 'cdp-addon-slot-chip' + (active ? ' is-active' : '') + (slotBooked ? ' is-disabled is-booked' : '');
    var attrs = options.saSlot
      ? ' data-sa-slot="' + id + '"'
      : ' data-addon-id="' + id + '"';
    var labelSuffix = '';
    if (slotBooked) labelSuffix = ' (Full)';
    else if (showCapacity) labelSuffix = formatAddonSlotCapacityLabel(remaining);
    return '<button type="button" aria-pressed="' + active + '" class="' + cls + '"' + attrs +
      ' data-start="' + slot.startTime + '" data-end="' + slot.endTime + '"' +
      (slotBooked ? ' disabled aria-disabled="true"' : '') + '>' +
      formatSlotLabel(slot) + labelSuffix + '</button>';
  }

  function pickFirstAvailableAddonSlot(addon, dateStr) {
    if (!addonRequiresTimeSlot(addon) || !dateStr) return null;
    var slots = getUniqueAddonTimeSlots(addon);
    for (var i = 0; i < slots.length; i++) {
      if (!isAddonStandaloneSlotBooked(addon, dateStr, slots[i])) return slots[i];
    }
    return null;
  }

  function ensureAddOnTimeSlotAuto(addon, addonId) {
    if (!addonRequiresTimeSlot(addon)) return;
    var primaryDate = getAddOnDatesOfBooking(addonId)[0];
    var current = getAddOnTimeSlot(addonId);
    if (current && primaryDate && !isAddonStandaloneSlotBooked(addon, primaryDate, current)) return;
    if (current && primaryDate && isAddonStandaloneSlotBooked(addon, primaryDate, current)) setAddOnTimeSlot(addonId, null);
    var next = pickFirstAvailableAddonSlot(addon, primaryDate);
    if (next) setAddOnTimeSlot(addonId, next);
  }

  function ensureStandaloneTimeSlotAuto(addon, state) {
    if (!addonRequiresTimeSlot(addon) || !state) return;
    var primaryDate = state.dates && state.dates[0];
    if (state.slot && primaryDate && !isAddonStandaloneSlotBooked(addon, primaryDate, state.slot)) return;
    if (state.slot && primaryDate && isAddonStandaloneSlotBooked(addon, primaryDate, state.slot)) state.slot = null;
    var next = pickFirstAvailableAddonSlot(addon, primaryDate);
    if (next) state.slot = { startTime: next.startTime, endTime: next.endTime };
  }

  function getAddOnPersons(id) {
    var n = parseInt((window.selectedAddOnGuests || {})[String(id)], 10);
    return n > 0 ? n : 0;
  }

  function setAddOnPersons(id, count) {
    window.selectedAddOnGuests = window.selectedAddOnGuests || {};
    var n = parseInt(count, 10);
    if (n > 0) window.selectedAddOnGuests[String(id)] = n;
    else delete window.selectedAddOnGuests[String(id)];
  }

  function getAddOnTimeSlot(id) {
    return (window.selectedAddOnTimeSlots || {})[String(id)] || null;
  }

  function setAddOnTimeSlot(id, slot) {
    window.selectedAddOnTimeSlots = window.selectedAddOnTimeSlots || {};
    if (slot && slot.startTime && slot.endTime) window.selectedAddOnTimeSlots[String(id)] = { startTime: slot.startTime, endTime: slot.endTime };
    else delete window.selectedAddOnTimeSlots[String(id)];
  }

  function getAddOnAvailableDates() {
    var dates = selectedDates();
    if (Array.isArray(dates) && dates.length) {
      if (typeof window.usesCheckInCheckOutDates === 'function' && window.usesCheckInCheckOutDates()) {
        if (dates.length < 2) return [];
        var out = [];
        var start = new Date(dates[0]);
        var end = new Date(dates[1]);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        var cur = new Date(start);
        while (cur < end) {
          out.push(cur.getFullYear() + '-' + String(cur.getMonth() + 1).padStart(2, '0') + '-' + String(cur.getDate()).padStart(2, '0'));
          cur.setDate(cur.getDate() + 1);
        }
        return out.length ? out : [dates[0]];
      }
      return dates.slice();
    }
    return [];
  }

  function getAddOnAvailableDatesForAddon(addon) {
    var base = getAddOnAvailableDates();
    if (!addon || !Array.isArray(addon.availableDays) || !addon.availableDays.length) return base;
    var allowed = addon.availableDays.map(function (d) { return String(d).toLowerCase(); });
    return base.filter(function (dateStr) {
      var d = new Date(dateStr + 'T00:00:00');
      return allowed.indexOf(DAY_NAMES[d.getDay()]) !== -1;
    });
  }

  function isAddOnVenueDateSelectable(addon, dateStr) {
    if (!dateStr) return false;
    if (!isDateAllowedForAddon(addon, dateStr)) return false;
    if (isAddonStandaloneDateFullyBooked(addon, dateStr)) return false;
    return true;
  }

  function buildAddonDateChipHtml(addon, dateStr, options) {
    options = options || {};
    var id = options.addonId || String(addon._id);
    var active = !!options.active;
    var disabled = !!options.disabled;
    var cls = 'cdp-addon-date-chip' + (active ? ' is-active' : '') + (disabled ? ' is-disabled' : '');
    return '<button type="button" aria-pressed="' + active + '" class="' + cls + '" data-addon-id="' + id +
      '" data-date="' + dateStr + '"' + (disabled ? ' disabled aria-disabled="true"' : '') + '>' +
      formatAddOnChipLabel(dateStr) + '</button>';
  }

  function getAddOnDatesOfBooking(addonId) {
    var addon = getAddonById(addonId);
    var available = addon ? getAddOnAvailableDatesForAddon(addon) : getAddOnAvailableDates();
    if (!available.length) available = getAddOnAvailableDates();
    if (!available.length) return [];
    if (!addonId) return available.slice();
    var chosen = (window.selectedAddOnDates || {})[String(addonId)];
    if (!Array.isArray(chosen) || !chosen.length) return available.slice();
    var filtered = chosen.filter(function (d) { return available.indexOf(d) !== -1; });
    return filtered.length ? filtered : available.slice();
  }

  function setAddOnDates(addonId, dates) {
    window.selectedAddOnDates = window.selectedAddOnDates || {};
    var addon = getAddonById(addonId);
    var available = addon ? getAddOnAvailableDatesForAddon(addon) : getAddOnAvailableDates();
    if (!available.length) available = getAddOnAvailableDates();
    var next = (dates || []).filter(function (d) { return available.indexOf(d) !== -1; });
    if (!next.length && available.length && dates && dates.length) next = [available[0]];
    if (!addonAllowsMultipleDates(addon) && next.length > 1) next = [next[0]];
    if (next.length) window.selectedAddOnDates[String(addonId)] = next;
    else delete window.selectedAddOnDates[String(addonId)];
  }

  function ensureAddOnDates(addonId) {
    var addon = getAddonById(addonId);
    var available = addon ? getAddOnAvailableDatesForAddon(addon) : getAddOnAvailableDates();
    // If availableDays filters out the venue event date, still fall back to that date for post-booking.
    if (!available.length) available = getAddOnAvailableDates();
    var current = getAddOnDatesOfBooking(addonId);
    if (!current.length && available.length) {
      window.selectedAddOnDates = window.selectedAddOnDates || {};
      window.selectedAddOnDates[String(addonId)] = addonAllowsMultipleDates(addon) ? available.slice() : [available[0]];
    }
    return getAddOnDatesOfBooking(addonId);
  }

  function toggleAddOnDate(addonId, dateStr) {
    var addon = getAddonById(addonId);
    var available = addon ? getAddOnAvailableDatesForAddon(addon) : getAddOnAvailableDates();
    if (!available.length) available = getAddOnAvailableDates();
    if (available.indexOf(dateStr) === -1) return;
    var current = getAddOnDatesOfBooking(addonId);
    if (current.indexOf(dateStr) !== -1) {
      if (current.length === 1) return;
      current = current.filter(function (d) { return d !== dateStr; });
    } else {
      current = addonAllowsMultipleDates(addon) ? current.concat(dateStr).sort() : [dateStr];
    }
    setAddOnDates(addonId, current);
  }

  function formatAddOnChipLabel(dateStr) {
    try {
      var d = new Date(dateStr + 'T00:00:00');
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    } catch (e) { return dateStr; }
  }

  function formatSlotLabel(slot) {
    return slot.startTime + ' – ' + slot.endTime;
  }

  function getAddOnBillingDays(id) {
    var n = id ? getAddOnDatesOfBooking(id).length : getAddOnAvailableDates().length;
    if (n > 0) return n;
    return getAddOnAvailableDates().length || 1;
  }

  function getSelectedAddOns(pd) {
    var selectedVariant = resolveSelectedVariant(pd);
    if (!selectedVariant || !Array.isArray(selectedVariant.addOns)) return [];
    var selectedIds = window.selectedAddOnIds || [];
    return selectedVariant.addOns.filter(function (addon) { return selectedIds.indexOf(String(addon._id)) !== -1; });
  }

  function getAddonLineTotal(a) {
    var p = Number(a && a.price) || 0;
    var d = getAddOnBillingDays(a && a._id);
    return p * d * (isBundleAddOn(a) ? getAddOnPersons(a._id) : 1);
  }

  function getSelectedAddOnsTotal(pd) {
    return getSelectedAddOns(pd).reduce(function (sum, a) { return sum + getAddonLineTotal(a); }, 0);
  }

  function buildSelectedAddonsPayload() {
    var addons = getSelectedAddOns();
    if (!addons.length) return [];
    return addons.map(function (addon) {
      var datesOfBooking = ensureAddOnDates(addon._id);
      var item = {
        addonId: String(addon._id),
        datesOfBooking: datesOfBooking,
        numberOfDays: datesOfBooking.length || 1
      };
      if (isBundleAddOn(addon)) item.noOfPersons = getAddOnPersons(addon._id) || 1;
      var slot = getAddOnTimeSlot(addon._id);
      if (addonRequiresTimeSlot(addon) && slot) item.timeSlot = { startTime: slot.startTime, endTime: slot.endTime };
      return item;
    });
  }

  function scrollCdpToElement(el, opts) {
    opts = opts || {};
    if (!el || typeof el.getBoundingClientRect !== 'function') return;
    var block = opts.block || 'center';
    try {
      el.scrollIntoView({ behavior: 'smooth', block: block, inline: 'nearest' });
    } catch (e) {
      try { el.scrollIntoView(true); } catch (e2) {}
    }
    if (opts.focus === false) return;
    var focusEl = opts.focusEl || el;
    if (!focusEl.matches || !focusEl.matches('input, select, textarea, button, [tabindex]')) {
      focusEl = el.querySelector('input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])') || el;
    }
    if (!focusEl || typeof focusEl.focus !== 'function') return;
    setTimeout(function () {
      try { focusEl.focus({ preventScroll: true }); } catch (e3) {
        try { focusEl.focus(); } catch (e4) {}
      }
    }, opts.focusDelay != null ? opts.focusDelay : 320);
  }

  function clearCdpFieldHighlight(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.cdp-field-error').forEach(function (node) {
      node.classList.remove('cdp-field-error');
      node.removeAttribute('aria-invalid');
    });
    root.querySelectorAll('.cdp-addon-card.has-validation-error, .cdp-addon-options.has-validation-error').forEach(function (node) {
      node.classList.remove('has-validation-error');
    });
    root.querySelectorAll('.cdp-addon-field-error, .cdp-field-inline-error.is-visible').forEach(function (node) {
      node.classList.remove('is-visible');
      node.textContent = '';
    });
  }

  function showCdpInlineFieldError(fieldEl, message, opts) {
    opts = opts || {};
    if (!fieldEl) return;
    var scope = fieldEl.closest('.cdp-addon-card') || fieldEl.closest('.cdp-addr-modal') || fieldEl.closest('.cdp-standalone-dialog') || fieldEl.parentElement;
    if (scope) clearCdpFieldHighlight(scope);
    fieldEl.classList.add('cdp-field-error');
    fieldEl.setAttribute('aria-invalid', 'true');
    var host = fieldEl.parentElement;
    if (host && message) {
      var key = fieldEl.id || fieldEl.name || 'field';
      var errEl = host.querySelector('[data-cdp-field-error="' + key + '"]');
      if (!errEl) {
        errEl = document.createElement('div');
        errEl.className = 'cdp-field-inline-error';
        errEl.setAttribute('data-cdp-field-error', key);
        errEl.setAttribute('role', 'alert');
        if (fieldEl.nextSibling) host.insertBefore(errEl, fieldEl.nextSibling);
        else host.appendChild(errEl);
      }
      errEl.textContent = message;
      errEl.classList.add('is-visible');
    }
    scrollCdpToElement(opts.scrollTarget || fieldEl.closest('.cdp-addon-card') || fieldEl.closest('.cdp-addr-modal') || fieldEl.closest('.bundle-guest-popup') || fieldEl.closest('.olivers-guest-popup') || fieldEl, {
      block: opts.block || 'center',
      focusEl: fieldEl,
      focus: opts.focus !== false
    });
  }

  function paintSectionValidation(el, message, type, scrollTarget) {
    if (!el) return false;
    el.textContent = message;
    el.className = 'cdp-section-validation is-visible is-' + (type || 'error');
    el.setAttribute('role', 'alert');
    el.setAttribute('tabindex', '-1');
    window._cdpSectionValidationTimers = window._cdpSectionValidationTimers || {};
    if (window._cdpSectionValidationTimers[el.id]) clearTimeout(window._cdpSectionValidationTimers[el.id]);
    window._cdpSectionValidationTimers[el.id] = setTimeout(function () {
      el.classList.remove('is-visible');
      el.textContent = '';
      el.removeAttribute('tabindex');
    }, 8000);
    scrollCdpToElement(scrollTarget || el, { block: 'center', focus: false });
    setTimeout(function () {
      try { el.focus({ preventScroll: true }); } catch (e) {}
    }, 320);
    return true;
  }

  function showVenueValidationMessage(message, type) {
    var msgEl = document.getElementById('cdp-venue-validation-message');
    var scrollTarget = document.querySelector('.products_details_calender')
      || document.querySelector('.calendar-container')
      || document.getElementById('book-me-container')
      || msgEl;
    if (!paintSectionValidation(msgEl, message, type, scrollTarget)) {
      notify(message, type);
      scrollCdpToElement(scrollTarget, { focus: false });
    }
  }

  function showAddonsValidationMessage(message, type, scrollTarget) {
    var msgEl = document.getElementById('cdp-addons-validation-message');
    var target = scrollTarget
      || document.getElementById('cdp-addons-panel')
      || document.querySelector('.cdp-addons-section')
      || msgEl;
    if (!paintSectionValidation(msgEl, message, type, target)) {
      notify(message, type);
      scrollCdpToElement(target, { focus: false });
    }
  }

  function clearVenueValidationMessage() {
    var el = document.getElementById('cdp-venue-validation-message');
    if (!el) return;
    el.classList.remove('is-visible', 'is-error', 'is-success', 'is-warn');
    el.textContent = '';
  }

  function clearAddonsValidationMessage() {
    var el = document.getElementById('cdp-addons-validation-message');
    if (!el) return;
    el.classList.remove('is-visible', 'is-error', 'is-success', 'is-warn');
    el.textContent = '';
  }

  function venueDatesReadyForAddons() {
    if (getAddOnAvailableDates().length) {
      return { ok: true };
    }
    var dates = selectedDates();
    if (!Array.isArray(dates) || !dates.length) {
      return { ok: false, message: 'Please select your booking date before choosing add-ons.' };
    }
    if (typeof window.usesCheckInCheckOutDates === 'function' && window.usesCheckInCheckOutDates()) {
      if (dates.length < 2) {
        return { ok: false, message: 'Please select your check-out date before choosing add-ons.' };
      }
    }
    return { ok: true };
  }

  function formatAddonAvailabilityMessage(addon, bookedDates) {
    var title = (addon && addon.title) || 'Add-on';
    var labels = bookedDates.map(formatAddOnChipLabel);
    var dateText = labels.length === 1
      ? labels[0]
      : labels.slice(0, -1).join(', ') + ' and ' + labels[labels.length - 1];
    return '"' + title + '" is already booked on ' + dateText + '. Please choose another available date or remove this add-on from your booking.';
  }

  function getAddonAvailabilityIssueDetails(addon) {
    var issues = [];
    if (!addon) return issues;
    var id = String(addon._id);
    var bookingDates = getAddOnDatesOfBooking(id);
    var selectedSlot = getAddOnTimeSlot(id);
    var fullyBookedDates = bookingDates.filter(function (dateStr) {
      return isAddonStandaloneDateFullyBooked(addon, dateStr);
    });
    if (fullyBookedDates.length) {
      issues.push({
        addonId: id,
        field: 'availability',
        message: formatAddonAvailabilityMessage(addon, fullyBookedDates)
      });
    }
    if (addonRequiresTimeSlot(addon) && selectedSlot) {
      bookingDates.forEach(function (dateStr) {
        if (fullyBookedDates.indexOf(dateStr) !== -1) return;
        if (isAddonStandaloneSlotBooked(addon, dateStr, selectedSlot)) {
          issues.push({
            addonId: id,
            field: 'slot',
            message: '"' + (addon.title || 'Add-on') + '" — the ' + formatSlotLabel(selectedSlot) +
              ' slot on ' + formatAddOnChipLabel(dateStr) + ' is fully booked. Please choose another time slot or date.'
          });
        }
      });
    }
    return issues;
  }

  function getAddonValidationIssueDetails(addon) {
    var issues = [];
    var title = (addon && addon.title) || 'Add-on';
    var id = String(addon._id);
    if (isBundleAddOn(addon) && getAddOnPersons(addon._id) < 1) {
      issues.push({ addonId: id, field: 'guests', message: 'Select the number of guests for "' + title + '".' });
    }
    if (!getAddOnDatesOfBooking(addon._id).length) {
      issues.push({ addonId: id, field: 'dates', message: 'Select at least one booking date for "' + title + '".' });
    }
    if (addonRequiresTimeSlot(addon) && !getAddOnTimeSlot(addon._id)) {
      issues.push({ addonId: id, field: 'slot', message: 'Select a time slot for "' + title + '".' });
    }
    getAddonAvailabilityIssueDetails(addon).forEach(function (issue) { issues.push(issue); });
    return issues;
  }

  function getAddonValidationIssues(addon) {
    return getAddonValidationIssueDetails(addon).map(function (issue) { return issue.message; });
  }

  function collectAddonValidationMessages() {
    var messages = [];
    getSelectedAddOns().forEach(function (addon) {
      getAddonValidationIssueDetails(addon).forEach(function (issue) { messages.push(issue.message); });
    });
    return messages;
  }

  function focusAddonValidationIssue(issue) {
    if (!issue || !issue.addonId) return false;
    var id = String(issue.addonId);
    var card = document.querySelector('.cdp-addon-card[data-addon-id="' + id + '"]');
    if (!card) return false;
    document.querySelectorAll('.cdp-addon-card.has-validation-error').forEach(function (node) {
      node.classList.remove('has-validation-error');
    });
    card.classList.add('has-validation-error');
    if (!card.classList.contains('is-selected')) {
      toggleAddOnSelection(id, true);
      card = document.querySelector('.cdp-addon-card[data-addon-id="' + id + '"]') || card;
    }
    var options = card.querySelector('.cdp-addon-options');
    if (options) {
      options.hidden = false;
      options.classList.add('has-validation-error');
    }
    var fieldWrap = null;
    if (issue.field === 'guests') fieldWrap = card.querySelector('.cdp-addon-stepper');
    else if (issue.field === 'dates' || issue.field === 'availability') fieldWrap = card.querySelector('.cdp-addon-dates');
    else if (issue.field === 'slot') fieldWrap = card.querySelector('.cdp-addon-slots');
    var inlineHost = fieldWrap || options || card;
    var errEl = inlineHost.querySelector('.cdp-addon-field-error');
    if (!errEl) {
      errEl = document.createElement('div');
      errEl.className = 'cdp-addon-field-error cdp-field-inline-error';
      errEl.setAttribute('role', 'alert');
      inlineHost.appendChild(errEl);
    }
    errEl.textContent = issue.message;
    errEl.classList.add('is-visible');
    scrollCdpToElement(card, { block: 'center', focus: false });
    return true;
  }

  function showAddonValidationErrors() {
    var panel = document.getElementById('cdp-addons-panel') || document.querySelector('.cdp-addons-section');
    clearCdpFieldHighlight(panel || document);
    var messages = [];
    var firstIssue = null;
    getSelectedAddOns().forEach(function (addon) {
      getAddonValidationIssueDetails(addon).forEach(function (issue) {
        messages.push(issue.message);
        if (!firstIssue) firstIssue = issue;
      });
    });
    if (!messages.length) return false;
    if (firstIssue) focusAddonValidationIssue(firstIssue);
    showAddonsValidationMessage(messages.join(' '), 'error', panel);
    return true;
  }

  function validateSelectedBundleAddOns() {
    return getSelectedAddOns().filter(function (addon) {
      return getAddonValidationIssues(addon).length > 0;
    });
  }

  function attachSelectedAddonsToRequest(requestData) {
    var payload = buildSelectedAddonsPayload();
    if (!payload.length) {
      delete requestData.selectedAddOns;
      delete requestData.selectedAddons;
      delete requestData.addOns;
      delete requestData.addOnsTotal;
      return requestData;
    }
    requestData.selectedAddOns = payload.map(sanitizeAddonItem);
    delete requestData.selectedAddons;
    requestData.addOnsTotal = getSelectedAddOnsTotal(window.productDetails || (typeof productDetails !== 'undefined' ? productDetails : null));
    delete requestData.addOns;
    return ensureSelectedAddOnsApiKey(requestData);
  }

  function shouldShowAddOnsPanel(v) {
    v = v || resolveSelectedVariant();
    return !!(v && Array.isArray(v.addOns) && v.addOns.length);
  }

  function updateAddOnsTotalUI() {
    var totalEl = document.getElementById('cdp-addons-total');
    var valueEl = document.getElementById('cdp-addons-total-value');
    if (!totalEl || !valueEl) return;
    var selected = getSelectedAddOns();
    var total = getSelectedAddOnsTotal();
    var symbol = curSym();
    if (!selected.length || !getAddOnAvailableDates().length) { totalEl.style.display = 'none'; return; }
    totalEl.style.display = 'flex';
    valueEl.textContent = selected.length + ' · ' + symbol + moneyFmt(total);
  }

  function resetVenueAddOnSelections() {
    window.selectedAddOnIds = [];
    window.selectedAddOnGuests = {};
    window.selectedAddOnDates = {};
    window.selectedAddOnTimeSlots = {};
    clearAddonsValidationMessage();
    document.querySelectorAll('#cdp-addons-list .cdp-addon-card').forEach(function (card) {
      card.classList.remove('has-validation-error');
      card.classList.remove('is-selected');
      card.setAttribute('aria-pressed', 'false');
      var checkbox = card.querySelector('input[type="checkbox"]');
      if (checkbox) checkbox.checked = false;
      syncAddOnIncludeButton(card, false);
      var addonId = card.getAttribute('data-addon-id');
      var addon = addonId ? getAddonById(addonId) : null;
      if (addon) syncAddOnStandaloneButton(card, addon);
      var options = card.querySelector('.cdp-addon-options');
      if (options) {
        options.hidden = true;
        options.classList.remove('has-validation-error');
      }
      card.querySelectorAll('.cdp-addon-field-error').forEach(function (errEl) {
        errEl.textContent = '';
        errEl.classList.remove('is-visible');
      });
    });
    updateAddOnsTotalUI();
    if (typeof updatePaymentSummary === 'function') updatePaymentSummary();
  }

  function addonIncludeLabel(selected) {
    return selected ? 'Included in booking' : 'Include in booking';
  }

  function hasVenueDatesSelected() {
    var dates = selectedDates();
    return Array.isArray(dates) && dates.length > 0;
  }

  function shouldHideAddonStandaloneBtn() {
    return hasVenueDatesSelected();
  }

  function syncAddOnStandaloneButton(card, addon) {
    if (!card || !addon || !addonCanBookSeparately(addon)) return;
    var actions = card.querySelector('.cdp-addon-actions');
    if (!actions) return;
    actions.hidden = shouldHideAddonStandaloneBtn();
  }

  function refreshAddonStandaloneButtons() {
    document.querySelectorAll('#cdp-addons-list .cdp-addon-card').forEach(function (card) {
      var addonId = card.getAttribute('data-addon-id');
      var addon = addonId ? getAddonById(addonId) : null;
      if (addon) syncAddOnStandaloneButton(card, addon);
    });
  }

  function syncAddOnIncludeButton(card, selected) {
    if (!card) return;
    var includeBtn = card.querySelector('.cdp-addon-include-btn');
    if (!includeBtn) return;
    includeBtn.classList.toggle('is-included', !!selected);
    includeBtn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    includeBtn.textContent = addonIncludeLabel(!!selected);
  }

  function syncAddOnCardControls(card, addon, selected) {
    if (!card || !addon) return;
    var id = String(addon._id);
    syncAddOnIncludeButton(card, selected);
    syncAddOnStandaloneButton(card, addon);
    var opts = card.querySelector('.cdp-addon-options');
    if (opts) opts.hidden = !selected;
    var guestVal = card.querySelector('.cdp-addon-guest-value');
    if (guestVal) guestVal.textContent = String(getAddOnPersons(id) || 1);
    card.querySelectorAll('.cdp-addon-date-chip').forEach(function (chip) {
      var dateStr = chip.getAttribute('data-date');
      var disabled = !isAddOnVenueDateSelectable(addon, dateStr);
      var active = !disabled && getAddOnDatesOfBooking(id).indexOf(dateStr) !== -1;
      chip.classList.toggle('is-active', active);
      chip.classList.toggle('is-disabled', disabled);
      chip.disabled = disabled;
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (disabled) chip.setAttribute('aria-disabled', 'true');
      else chip.removeAttribute('aria-disabled');
    });
    var primaryDate = getAddOnDatesOfBooking(id)[0] || '';
    card.querySelectorAll('.cdp-addon-slot-chip').forEach(function (chip) {
      var slot = { startTime: chip.getAttribute('data-start'), endTime: chip.getAttribute('data-end') };
      var selectedSlot = getAddOnTimeSlot(id);
      var active = !!(selectedSlot && selectedSlot.startTime === slot.startTime && selectedSlot.endTime === slot.endTime);
      var remaining = primaryDate ? getSlotRemainingCapacity(addon, primaryDate, slot) : getAddonSlotCapacity(addon, slot);
      var slotBooked = primaryDate && remaining <= 0;
      var showCapacity = !!primaryDate && remaining > 0 && remaining < getAddonSlotCapacity(addon, slot);
      chip.classList.toggle('is-active', active);
      chip.classList.toggle('is-disabled', !!slotBooked);
      chip.classList.toggle('is-booked', !!slotBooked);
      chip.disabled = !!slotBooked;
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      chip.textContent = formatSlotLabel(slot) + (slotBooked ? ' (Full)' : (showCapacity ? formatAddonSlotCapacityLabel(remaining) : ''));
      if (slotBooked && active) setAddOnTimeSlot(id, null);
    });
    if (selected && addonRequiresTimeSlot(addon)) ensureAddOnTimeSlotAuto(addon, id);
    var minus = card.querySelector('[data-addon-step="-1"]');
    if (minus) minus.disabled = getAddOnPersons(id) <= 1;
    var lineEl = card.querySelector('.cdp-addon-line-total');
    if (lineEl) {
      var symbol = curSym();
      var days = getAddOnBillingDays(id) || 1;
      var persons = getAddOnPersons(id) || 1;
      var total = getAddonLineTotal(addon);
      if (isBundleAddOn(addon)) lineEl.textContent = symbol + moneyFmt(+addon.price || 0) + ' × ' + persons + ' guest' + (persons > 1 ? 's' : '') + ' = ' + symbol + moneyFmt((+addon.price || 0) * persons) + ' × ' + days + ' day' + (days > 1 ? 's' : '') + ' = ' + symbol + moneyFmt(total);
      else if (isFixedAddOn(addon)) lineEl.textContent = days + ' days × ' + symbol + moneyFmt(Number(addon.price) || 0) + ' = ' + symbol + moneyFmt(total);
      else lineEl.textContent = days + 'd = ' + symbol + moneyFmt(total);
      lineEl.hidden = !selected;
    }
  }

  function applyAddOnSelection(id, nextState, addon) {
    window.selectedAddOnIds = window.selectedAddOnIds || [];
    var isSelected = window.selectedAddOnIds.indexOf(id) !== -1;
    if (nextState && !isSelected) {
      window.selectedAddOnIds.push(id);
      if (isBundleAddOn(addon) && getAddOnPersons(id) < 1) setAddOnPersons(id, 1);
      ensureAddOnDates(id);
      if (addon) ensureAddOnTimeSlotAuto(addon, id);
    } else if (!nextState && isSelected) {
      window.selectedAddOnIds = window.selectedAddOnIds.filter(function (x) { return x !== id; });
      setAddOnPersons(id, 0);
      delete (window.selectedAddOnDates || {})[id];
      delete (window.selectedAddOnTimeSlots || {})[id];
    }
    var card = document.querySelector('.cdp-addon-card[data-addon-id="' + id + '"]');
    if (card) {
      card.classList.toggle('is-selected', nextState);
      card.setAttribute('aria-pressed', nextState ? 'true' : 'false');
      var checkbox = card.querySelector('input[type="checkbox"]');
      if (checkbox) checkbox.checked = nextState;
      if (addon) syncAddOnCardControls(card, addon, nextState);
      else syncAddOnIncludeButton(card, nextState);
    }
    updateAddOnsTotalUI();
    if (typeof updatePaymentSummary === 'function') updatePaymentSummary();
  }

  function toggleAddOnSelection(addonId, forceState) {
    var id = String(addonId);
    window.selectedAddOnIds = window.selectedAddOnIds || [];
    var selectedVariant = resolveSelectedVariant();
    var addon = selectedVariant && Array.isArray(selectedVariant.addOns)
      ? selectedVariant.addOns.find(function (a) { return String(a._id) === id; })
      : null;
    var isSelected = window.selectedAddOnIds.indexOf(id) !== -1;
    var nextState = typeof forceState === 'boolean' ? forceState : !isSelected;
    if (nextState && !isSelected) {
      var venueCheck = venueDatesReadyForAddons();
      if (!venueCheck.ok) {
        showVenueValidationMessage(venueCheck.message, 'error');
        return;
      }
      clearVenueValidationMessage();
    }
    applyAddOnSelection(id, nextState, addon);
    if (nextState) clearAddonsValidationMessage();
  }

  function renderVariantAddOns(variantOverride) {
    var panel = document.getElementById('cdp-addons-panel');
    var list = document.getElementById('cdp-addons-list');
    var subtitle = document.getElementById('cdp-addons-subtitle');
    if (!panel || !list) return;
    var selectedVariant = variantOverride || resolveSelectedVariant();
    panel.classList.toggle('is-date-locked', !getAddOnAvailableDates().length);
    if (!shouldShowAddOnsPanel(selectedVariant)) {
      panel.classList.remove('is-visible');
      list.innerHTML = '';
      updateAddOnsTotalUI();
      if (typeof window.syncCdpAddonsLayout === 'function') window.syncCdpAddonsLayout();
      return;
    }
    var addOns = selectedVariant.addOns || [];
    var availableIds = addOns.map(function (a) { return String(a._id); });
    window.selectedAddOnIds = (window.selectedAddOnIds || []).filter(function (id) { return availableIds.indexOf(String(id)) !== -1; });
    Object.keys(window.selectedAddOnGuests || {}).forEach(function (id) { if (availableIds.indexOf(String(id)) === -1) delete window.selectedAddOnGuests[id]; });
    Object.keys(window.selectedAddOnDates || {}).forEach(function (id) { if (availableIds.indexOf(String(id)) === -1) delete window.selectedAddOnDates[id]; });
    Object.keys(window.selectedAddOnTimeSlots || {}).forEach(function (id) { if (availableIds.indexOf(String(id)) === -1) delete window.selectedAddOnTimeSlots[id]; });
    if (subtitle) subtitle.textContent = 'Personalise your booking with optional add-ons.';
    var symbol = curSym();
    list.innerHTML = addOns.map(function (addon) {
      var id = String(addon._id);
      var checked = (window.selectedAddOnIds || []).indexOf(id) !== -1;
      if (checked) {
        ensureAddOnDates(id);
        ensureAddOnTimeSlotAuto(addon, id);
      }
      var img = (Array.isArray(addon.images) && addon.images[0]) ? addon.images[0] : '';
      var addonVideoUrl = '';
      if (!img && Array.isArray(addon.videos)) {
        for (var vi = 0; vi < addon.videos.length; vi++) {
          var rawVideo = addon.videos[vi];
          if (!rawVideo) continue;
          if (typeof rawVideo === 'string' && rawVideo.trim()) {
            addonVideoUrl = rawVideo.trim();
            break;
          }
          var candidate = String((rawVideo && (rawVideo.url || rawVideo.src || rawVideo.videoUrl)) || '').trim();
          if (candidate) {
            addonVideoUrl = candidate;
            break;
          }
        }
      }
      var desc = addon.description ? String(addon.description) : '';
      var unitPrice = Number(addon.price) || 0;
      var bundle = isBundleAddOn(addon);
      var persons = getAddOnPersons(id) || 1;
      var venueDates = getAddOnAvailableDates();
      var addonDates = getAddOnAvailableDatesForAddon(addon);
      var chosenDates = getAddOnDatesOfBooking(id);
      var days = chosenDates.length || 1;
      var lineTotal = getAddonLineTotal(addon);
      var priceSuffix = bundle ? '/ person / day' : '/ day';
      var media = img
        ? '<div class="cdp-addon-media"><img src="' + img + '" alt="" loading="lazy"></div>'
        : (addonVideoUrl
          ? '<div class="cdp-addon-media cdp-addon-media--video"><video src="' + addonVideoUrl + '" muted playsinline preload="metadata"></video></div>'
          : '<div class="cdp-addon-media cdp-addon-media--empty">+</div>');
      var guestUI = bundle
        ? '<div class="cdp-addon-stepper"><span class="cdp-addon-stepper-label">Number of guests</span><div class="cdp-addon-stepper-controls"><button type="button" class="cdp-addon-stepper-btn" data-addon-step="-1" data-addon-id="' + id + '" aria-label="Remove guest"' + (persons <= 1 ? ' disabled' : '') + '>−</button><span class="cdp-addon-guest-value">' + persons + '</span><button type="button" class="cdp-addon-stepper-btn" data-addon-step="1" data-addon-id="' + id + '" aria-label="Add guest">+</button></div></div>'
        : '';
      var datesUI = venueDates.length > 1
        ? '<div class="cdp-addon-dates"><span class="cdp-addon-dates-label">' + (addonAllowsMultipleDates(addon) ? 'Choose add-on days' : 'Choose add-on day') + '</span><div class="cdp-addon-date-chips">' + venueDates.map(function (d) {
          var disabled = !isAddOnVenueDateSelectable(addon, d);
          var active = !disabled && chosenDates.indexOf(d) !== -1;
          return buildAddonDateChipHtml(addon, d, { addonId: id, active: active, disabled: disabled });
        }).join('') + '</div></div>'
        : '';
      var uniqueSlots = getUniqueAddonTimeSlots(addon);
      var selectedSlot = getAddOnTimeSlot(id);
      var primaryDate = chosenDates[0] || addonDates[0] || '';
      var slotsUI = uniqueSlots.length
        ? '<div class="cdp-addon-slots"><span class="cdp-addon-slots-label">Choose time slot</span><div class="cdp-addon-slot-chips">' + uniqueSlots.map(function (slot) {
          var active = !!(selectedSlot && selectedSlot.startTime === slot.startTime && selectedSlot.endTime === slot.endTime);
          return buildAddonSlotChipHtml(addon, slot, { addonId: id, dateStr: primaryDate, active: active });
        }).join('') + '</div></div>'
        : '';
      var lineLabel = bundle
        ? symbol + moneyFmt(unitPrice) + ' × ' + persons + ' guest' + (persons > 1 ? 's' : '') + ' = ' + symbol + moneyFmt(unitPrice * persons) + ' × ' + days + ' day' + (days > 1 ? 's' : '') + ' = ' + symbol + moneyFmt(lineTotal)
        : days + ' days × ' + symbol + moneyFmt(unitPrice) + ' = ' + symbol + moneyFmt(lineTotal);
      var showStandaloneBtn = addonCanBookSeparately(addon) && !shouldHideAddonStandaloneBtn();
      var standaloneBtn = showStandaloneBtn
        ? '<button type="button" class="cdp-addon-standalone-btn" data-standalone-addon-id="' + id + '">Book separately</button>'
        : '';
      var actions = standaloneBtn
        ? '<div class="cdp-addon-actions">' + standaloneBtn + '</div>'
        : '';
      var includeBtn = '<button type="button" class="cdp-addon-include-btn' + (checked ? ' is-included' : '') + '" data-addon-include-id="' + id + '" aria-pressed="' + (checked ? 'true' : 'false') + '">' + addonIncludeLabel(checked) + '</button>';
      return '<div class="cdp-addon-card' + (checked ? ' is-selected' : '') + '" data-addon-id="' + id + '" data-price-type="' + String(addon.priceType || '').toLowerCase() + '" role="button" tabindex="0" aria-pressed="' + (checked ? 'true' : 'false') + '"><span class="cdp-addon-check"><input type="checkbox" value="' + id + '" ' + (checked ? 'checked' : '') + '></span>' +
        media + '<span class="cdp-addon-body"><div class="cdp-addon-top">' + includeBtn + '<p class="cdp-addon-name">' + (addon.title || 'Add-on') + '</p>' +
        '<div class="cdp-addon-price">' + symbol + moneyFmt(unitPrice) + ' <span>' + priceSuffix + '</span></div></div>' +
        (desc ? '<p class="cdp-addon-desc">' + desc + '</p>' : '') +
        '<div class="cdp-addon-options"' + (checked ? '' : ' hidden') + '>' + guestUI + datesUI + slotsUI + '<div class="cdp-addon-line-total"' + (checked ? '' : ' hidden') + '>' + lineLabel + '</div></div>' +
        actions +
        '</span></div>';
    }).join('');
    var leftoverBar = panel.querySelector('.cdp-standalone-multi-bar');
    if (leftoverBar) leftoverBar.remove();
    panel.classList.add('is-visible');
    updateAddOnsTotalUI();
    refreshAddonStandaloneButtons();
    if (typeof window.syncCdpAddonsLayout === 'function') window.syncCdpAddonsLayout();
  }

  function clearAddonCardValidation(card) {
    if (!card) return;
    card.classList.remove('has-validation-error');
    var options = card.querySelector('.cdp-addon-options');
    if (options) options.classList.remove('has-validation-error');
    var errEl = card.querySelector('.cdp-addon-field-error');
    if (errEl) {
      errEl.textContent = '';
      errEl.classList.remove('is-visible');
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches) return;
    if (input.matches('#cdp-addons-list input[type="checkbox"]')) toggleAddOnSelection(input.value, input.checked);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var stepBtn = t.closest('.cdp-addon-stepper-btn');
    if (stepBtn) {
      e.preventDefault();
      e.stopPropagation();
      var id = stepBtn.getAttribute('data-addon-id');
      var delta = parseInt(stepBtn.getAttribute('data-addon-step'), 10) || 0;
      var next = Math.max(1, (getAddOnPersons(id) || 1) + delta);
      setAddOnPersons(id, next);
      if ((window.selectedAddOnIds || []).indexOf(String(id)) === -1) toggleAddOnSelection(id, true);
      else {
        var card = document.querySelector('.cdp-addon-card[data-addon-id="' + id + '"]');
        var variant = resolveSelectedVariant();
        var addon = variant && variant.addOns ? variant.addOns.find(function (a) { return String(a._id) === String(id); }) : null;
        if (card && addon) syncAddOnCardControls(card, addon, true);
        clearAddonCardValidation(card);
        updateAddOnsTotalUI();
        if (typeof updatePaymentSummary === 'function') updatePaymentSummary();
      }
      return;
    }
    var slotChip = t.closest('.cdp-addon-slot-chip');
    if (slotChip) {
      e.preventDefault();
      e.stopPropagation();
      if (slotChip.disabled || slotChip.classList.contains('is-disabled')) return;
      var slotId = slotChip.getAttribute('data-addon-id');
      if ((window.selectedAddOnIds || []).indexOf(String(slotId)) === -1) toggleAddOnSelection(slotId, true);
      setAddOnTimeSlot(slotId, { startTime: slotChip.getAttribute('data-start'), endTime: slotChip.getAttribute('data-end') });
      var slotCard = document.querySelector('.cdp-addon-card[data-addon-id="' + slotId + '"]');
      var slotVariant = resolveSelectedVariant();
      var slotAddon = slotVariant && slotVariant.addOns ? slotVariant.addOns.find(function (a) { return String(a._id) === String(slotId); }) : null;
      if (slotCard && slotAddon) syncAddOnCardControls(slotCard, slotAddon, true);
      clearAddonCardValidation(slotCard);
      updateAddOnsTotalUI();
      if (typeof updatePaymentSummary === 'function') updatePaymentSummary();
      return;
    }
    var dateChip = t.closest('.cdp-addon-date-chip');
    if (dateChip) {
      e.preventDefault();
      e.stopPropagation();
      if (dateChip.disabled || dateChip.classList.contains('is-disabled')) return;
      var dateId = dateChip.getAttribute('data-addon-id');
      var dateStr = dateChip.getAttribute('data-date');
      if ((window.selectedAddOnIds || []).indexOf(String(dateId)) === -1) toggleAddOnSelection(dateId, true);
      toggleAddOnDate(dateId, dateStr);
      var dateCard = document.querySelector('.cdp-addon-card[data-addon-id="' + dateId + '"]');
      var dateVariant = resolveSelectedVariant();
      var dateAddon = dateVariant && dateVariant.addOns ? dateVariant.addOns.find(function (a) { return String(a._id) === String(dateId); }) : null;
      if (dateCard && dateAddon) syncAddOnCardControls(dateCard, dateAddon, true);
      clearAddonCardValidation(dateCard);
      updateAddOnsTotalUI();
      if (typeof updatePaymentSummary === 'function') updatePaymentSummary();
      return;
    }
    var standaloneBtn = t.closest('.cdp-addon-standalone-btn');
    if (standaloneBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (shouldHideAddonStandaloneBtn()) return;
      startStandaloneAddonFlow(standaloneBtn.getAttribute('data-standalone-addon-id'));
      return;
    }
    var includeBtn = t.closest('.cdp-addon-include-btn');
    if (includeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var includeId = includeBtn.getAttribute('data-addon-include-id');
      if (!includeId) return;
      var includeSelected = (window.selectedAddOnIds || []).indexOf(String(includeId)) !== -1;
      toggleAddOnSelection(includeId, !includeSelected);
      return;
    }
    if (t.closest('.cdp-addon-options, .cdp-addon-stepper, .cdp-addon-dates, .cdp-addon-slots, .cdp-addon-standalone-btn, .cdp-addon-include-btn, .cdp-addon-actions')) return;
    var card = t.closest('#cdp-addons-list .cdp-addon-card');
    if (!card) return;
    if (t.matches && t.matches('input[type="checkbox"]')) return;
    e.preventDefault();
    var cardId = card.getAttribute('data-addon-id');
    if (cardId) toggleAddOnSelection(cardId);
  });

  function notify(message, type) {
    if (typeof window.showNotification === 'function') window.showNotification(message, type || 'error');
    else if (typeof showNotification === 'function') showNotification(message, type || 'error');
  }

  function isDateAllowedForAddon(addon, dateStr) {
    if (!dateStr) return false;
    if (!addon || !Array.isArray(addon.availableDays) || !addon.availableDays.length) return true;
    var allowed = addon.availableDays.map(function (d) { return String(d).toLowerCase(); });
    var d = new Date(dateStr + 'T00:00:00');
    return allowed.indexOf(DAY_NAMES[d.getDay()]) !== -1;
  }

  function getAddonFirstBookableDate() {
    if (typeof window.getFirstBookableDate === 'function') return window.getFirstBookableDate();
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var pd = window.productDetails || {};
    var minDays = pd.minimumAdvanceBookingDays;
    minDays = minDays !== undefined && minDays !== null && !isNaN(Number(minDays)) ? Number(minDays) : 0;
    var first = new Date(today);
    if (minDays > 0) first.setDate(today.getDate() + minDays);
    else first.setDate(today.getDate() + 1);
    first.setHours(0, 0, 0, 0);
    return first;
  }

  function isBeforeAddonFirstBookable(dateStr) {
    if (!dateStr) return true;
    var dateObj = new Date(dateStr + 'T00:00:00');
    dateObj.setHours(0, 0, 0, 0);
    return dateObj < getAddonFirstBookableDate();
  }

  function isAddonCalendarDateDisabled(addon, dateStr) {
    if (!dateStr) return true;
    if (isBeforeAddonFirstBookable(dateStr)) return true;
    if (!isDateAllowedForAddon(addon, dateStr)) return true;
    if (!hasAddonAvailableSlotOnDate(addon, dateStr)) return true;
    return false;
  }

  function standaloneLineTotal(addon, dates, persons) {
    var price = Number(addon.price) || 0;
    var days = (dates && dates.length) ? dates.length : 0;
    var count = isBundleAddOn(addon) ? (persons || 1) : 1;
    return price * days * count;
  }

  function standaloneDepositAmount(addon, total) {
    var pd = window.productDetails || {};
    var pct = (addon && addon.depositPercentage != null)
      ? Number(addon.depositPercentage)
      : (pd.paymentPolicy && pd.paymentPolicy.depositPercentage != null ? Number(pd.paymentPolicy.depositPercentage) : 40);
    return { percent: pct, amount: (total * pct) / 100 };
  }

  function buildStandaloneAddonItem(addon, state) {
    var dates = (state.dates || []).slice().sort();
    var item = {
      addonId: String(addon._id),
      datesOfBooking: dates,
      numberOfDays: dates.length || 1
    };
    if (isBundleAddOn(addon)) item.noOfPersons = state.persons || 1;
    if (addonRequiresTimeSlot(addon) && state.slot) {
      item.timeSlot = { startTime: state.slot.startTime, endTime: state.slot.endTime };
    }
    return item;
  }

  function listStandaloneAddons() {
    var variant = resolveSelectedVariant();
    if (!variant || !Array.isArray(variant.addOns)) return [];
    return variant.addOns.filter(addonCanBookSeparately);
  }

  function getStandaloneProductIds() {
    var pd = window.productDetails || {};
    var variant = resolveSelectedVariant();
    var shopifyProductId = pd.shopifyProductId || (typeof window.getCdpProductId === 'function' ? window.getCdpProductId() : null);
    var productId = pd._id || pd.productId || shopifyProductId;
    var variantId = variant ? (variant.variantId || variant.id) : null;
    var productPackageId = variant ? (variant._id || variant.packageId || variantId) : null;
    return {
      shopifyProductId: shopifyProductId,
      productId: productId,
      productPackageId: productPackageId,
      variantId: variantId
    };
  }

  function resolveStandaloneSeedIds(seedAddonId) {
    var all = listStandaloneAddons();
    if (!all.length) return [];
    if (seedAddonId) {
      var one = all.find(function (a) { return String(a._id) === String(seedAddonId); });
      if (one) return [String(one._id)];
      var seed = getAddonById(seedAddonId);
      return seed && addonCanBookSeparately(seed) ? [String(seed._id)] : [];
    }
    var checked = (window.selectedAddOnIds || []).map(String).filter(function (id) {
      return all.some(function (a) { return String(a._id) === id; });
    });
    if (checked.length) return checked;
    return [String(all[0]._id)];
  }

  function nextAllowedDateForAddon(addon) {
    var base = getAddonFirstBookableDate();
    for (var i = 0; i < 60; i++) {
      var cand = new Date(base);
      cand.setDate(cand.getDate() + i);
      var candStr = cand.getFullYear() + '-' + String(cand.getMonth() + 1).padStart(2, '0') + '-' + String(cand.getDate()).padStart(2, '0');
      if (!isAddonCalendarDateDisabled(addon, candStr)) return candStr;
    }
    var fallback = new Date(base);
    fallback.setDate(fallback.getDate() + 1);
    return fallback.getFullYear() + '-' + String(fallback.getMonth() + 1).padStart(2, '0') + '-' + String(fallback.getDate()).padStart(2, '0');
  }

  function createStandaloneAddonState(addon) {
    var id = String(addon._id);
    return {
      selected: false,
      dates: [],
      persons: Math.max(1, getAddOnPersons(id) || 1),
      slot: null
    };
  }

  function resolveBookingOrderId(bookingData, paymentResponse) {
    if (bookingData) {
      var fromBooking = bookingData.orderRefId || bookingData.orderId || bookingData.orderRef;
      if (fromBooking) return fromBooking;
    }
    var payData = paymentResponse && paymentResponse.data;
    if (payData) return payData.orderRefId || payData.orderId || null;
    return null;
  }

  function openStandaloneBookingModal(seedAddonId) {
    var all = listStandaloneAddons();
    if (!all.length && seedAddonId) {
      all = [getAddonById(seedAddonId)].filter(addonCanBookSeparately);
    }
    if (!all.length) {
      notify('No add-ons can be booked separately on this package.', 'error');
      return;
    }
    if (seedAddonId) {
      var addon = getAddonById(seedAddonId);
      if (!addonCanBookSeparately(addon)) {
        notify('This add-on cannot be booked separately.', 'error');
        return;
      }
    }
    var seedIds = resolveStandaloneSeedIds(seedAddonId);
    var authToken = localStorage.getItem('authToken');
    var customerId = localStorage.getItem('customerId');
    if (!authToken || !customerId) {
      window.requestData = {
        _standaloneAddon: true,
        _standaloneAddonId: seedAddonId ? String(seedAddonId) : (seedIds[0] || null),
        _standaloneAddonIds: seedIds
      };
      if (typeof window.showLoginPopups === 'function') window.showLoginPopups(window.requestData);
      else if (typeof showLoginPopups === 'function') showLoginPopups(window.requestData);
      else notify('Please log in to continue.', 'error');
      return;
    }
    if (typeof hideLoaderFull === 'function') hideLoaderFull();
    openStandaloneAddonModal(seedAddonId, window._standaloneAddressContext || null, seedIds);
  }

  function startStandaloneAddonFlow(seedAddonId) {
    openStandaloneBookingModal(seedAddonId);
  }

  function normalizeStandaloneBillingAddress(billing, phone) {
    if (!billing) return null;
    var next = {
      address1: billing.address1 || '',
      city: billing.city || '',
      country: billing.country || '',
      province: billing.province || '',
      zip: billing.zip || '',
      contactNumber: billing.contactNumber || phone || ''
    };
    return next.address1 ? next : null;
  }

  function normalizeStandaloneShippingAddress(shipping, phone) {
    if (!shipping) return null;
    var next = {
      address1: shipping.address1 || '',
      city: shipping.city || '',
      country: shipping.country || '',
      province: shipping.province || '',
      zip: shipping.zip || '',
      contactNumber: shipping.contactNumber || phone || ''
    };
    return next.address1 ? next : null;
  }

  function normalizeWeddingId(value) {
    if (value == null) return null;
    var s = String(value).trim();
    if (!s || s.toLowerCase() === 'n/a' || s.toLowerCase() === 'nan') return null;
    return s;
  }

  function getStoredWeddingId() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = normalizeWeddingId(params.get('weddingRefId') || params.get('weddingId'));
      if (fromUrl) return fromUrl;
    } catch (e) { /* ignore */ }
    return normalizeWeddingId(localStorage.getItem('weddingRefId') || localStorage.getItem('weddingId'));
  }

  function resolveStandaloneWeddingId(bookingData) {
    if (bookingData) {
      var fromBooking = normalizeWeddingId(
        bookingData.weddingRefId || bookingData.weddingId || bookingData.weddingRef ||
        (bookingData.wedding && (bookingData.wedding.weddingRefId || bookingData.wedding._id))
      );
      if (fromBooking) return fromBooking;
      var payment = bookingData.payment || {};
      var fromPayment = normalizeWeddingId(
        (payment.couple && (payment.couple.weddingRefId || payment.couple.weddingId)) ||
        (payment.guest && (payment.guest.weddingRefId || payment.guest.weddingId))
      );
      if (fromPayment) return fromPayment;
    }
    return getStoredWeddingId();
  }

  function rememberWeddingId(weddingId) {
    var id = normalizeWeddingId(weddingId);
    if (id) localStorage.setItem('weddingRefId', id);
  }

  function calcStandaloneSelectionTotals(selectedPairs) {
    var symbol = curSym();
    var total = 0;
    var deposit = 0;
    var titles = [];
    selectedPairs.forEach(function (pair) {
      var line = standaloneLineTotal(pair.addon, pair.state.dates, pair.state.persons);
      var dep = standaloneDepositAmount(pair.addon, line);
      total += line;
      deposit += dep.amount;
      titles.push(pair.addon.title || 'Add-on');
    });
    return {
      total: total,
      deposit: deposit,
      depositLabel: symbol + moneyFmt(deposit),
      depositDisplay: symbol + moneyFmt(deposit) + (selectedPairs.length > 1 ? ' (combined)' : ''),
      titles: titles,
      titleLabel: titles.length === 1 ? titles[0] : (titles.length + ' add-ons')
    };
  }

  function buildStandaloneRequestData(selectedPairs, contact, addressContext) {
    var items = selectedPairs.map(function (pair) {
      return sanitizeAddonItem(buildStandaloneAddonItem(pair.addon, pair.state));
    });
    var first = items[0] || {};
    var totals = calcStandaloneSelectionTotals(selectedPairs);
    var ids = getStandaloneProductIds();
    var customerType = localStorage.getItem('customerType') === 'couple' ? 'couple' : 'guest';
    var requestData = {
      _standaloneAddon: true,
      productId: ids.productId,
      productPackageId: ids.productPackageId,
      selectedAddOns: items,
      payment: {},
      addOnsTotal: totals.total,
      _standaloneDepositLabel: totals.depositLabel,
      _standaloneInitialDepositDisplay: totals.depositDisplay,
      _standaloneAddonTitle: totals.titleLabel,
      _standaloneContact: contact
    };
    if (first.noOfPersons) requestData.noOfPersons = first.noOfPersons;
    if (first.timeSlot) requestData.timeSlot = first.timeSlot;
    requestData.payment[customerType] = contact;
    if (addressContext) {
      if (addressContext.billingAddress) {
        requestData.billingAddress = normalizeStandaloneBillingAddress(addressContext.billingAddress, contact.phone);
      }
      if (addressContext.shippingAddress) {
        requestData.shippingAddress = normalizeStandaloneShippingAddress(addressContext.shippingAddress, contact.phone);
      }
      if (requestData.billingAddress && requestData.shippingAddress) {
        requestData._addressGatePassed = true;
      }
    }
    return requestData;
  }

  function buildStandaloneApiPayload(requestData) {
    var items = getSelectedAddonsFromData(requestData).map(sanitizeAddonItem);
    var customerType = localStorage.getItem('customerType') === 'couple' ? 'couple' : 'guest';
    var contact = requestData._standaloneContact || {};
    var billing = normalizeStandaloneBillingAddress(
      requestData.billingAddress || (window._standaloneAddressContext && window._standaloneAddressContext.billingAddress),
      contact.phone
    );
    var shipping = normalizeStandaloneShippingAddress(
      requestData.shippingAddress || (window._standaloneAddressContext && window._standaloneAddressContext.shippingAddress),
      contact.phone
    );
    var ids = getStandaloneProductIds();
    var payload = {
      productPackageId: requestData.productPackageId || ids.productPackageId,
      selectedAddOns: items
    };
    if (billing) payload.billingAddress = billing;
    if (shipping) payload.shippingAddress = shipping;
    if (requestData.payment) payload.payment = requestData.payment;
    if (!payload.payment) payload.payment = {};
    if (!payload.payment[customerType] && requestData._standaloneContact) {
      payload.payment[customerType] = requestData._standaloneContact;
    }
    var weddingId = resolveStandaloneWeddingId(null);
    if (weddingId) payload.weddingRefId = weddingId;
    return ensureSelectedAddOnsApiKey(payload);
  }

  var SA_MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function saMonthKeyFromDate(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0');
  }

  function shiftSaMonthKey(key, delta) {
    var parts = key.split('-');
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1 + delta, 1);
    return saMonthKeyFromDate(d);
  }

  function getAddonDepositPercent(addon) {
    return standaloneDepositAmount(addon, 100).percent;
  }

  function getStandaloneContactFromStorage() {
    return {
      firstName: localStorage.getItem('customerFirstName') || '',
      lastName: localStorage.getItem('customerLastName') || '',
      email: localStorage.getItem('customerEmail') || '',
      phone: localStorage.getItem('customerPhone') || ''
    };
  }

  function renderSaCalendarHtml(addon, state, monthKey) {
    var id = String(addon._id);
    var parts = monthKey.split('-');
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1;
    var first = new Date(year, month, 1);
    var startDow = first.getDay();
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var html = '<div class="cdp-sa-calendar" data-sa-calendar="' + id + '">' +
      '<div class="cdp-sa-cal-nav">' +
        '<button type="button" class="cdp-sa-cal-nav-btn" data-sa-cal-prev="' + id + '" aria-label="Previous month">&lsaquo;</button>' +
        '<span class="cdp-sa-cal-title">' + SA_MONTH_NAMES[month] + ' ' + year + '</span>' +
        '<button type="button" class="cdp-sa-cal-nav-btn" data-sa-cal-next="' + id + '" aria-label="Next month">&rsaquo;</button>' +
      '</div>' +
      '<div class="cdp-sa-cal-weekdays">' +
        ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(function (d) { return '<span>' + d + '</span>'; }).join('') +
      '</div><div class="cdp-sa-cal-grid">';
    var i;
    for (i = 0; i < startDow; i++) html += '<span class="cdp-sa-cal-empty" aria-hidden="true"></span>';
    for (var day = 1; day <= daysInMonth; day++) {
      var dateObj = new Date(year, month, day);
      var ds = dateObj.getFullYear() + '-' + String(dateObj.getMonth() + 1).padStart(2, '0') + '-' + String(dateObj.getDate()).padStart(2, '0');
      var booked = isAddonStandaloneDateFullyBooked(addon, ds);
      var disabled = isAddonCalendarDateDisabled(addon, ds);
      var selected = !disabled && state.dates.indexOf(ds) !== -1;
      var dayLabel = booked ? 'Booked' : (disabled ? 'Unavailable' : formatAddOnChipLabel(ds));
      html += '<button type="button" class="cdp-sa-cal-day' + (disabled ? ' is-disabled' : '') + (booked ? ' is-booked' : '') + (selected ? ' is-selected' : '') +
        '" data-sa-cal-day="' + id + '" data-date="' + ds + '"' + (disabled ? ' disabled' : '') +
        ' aria-label="' + dayLabel + '">' + day + '</button>';
    }
    html += '</div></div>';
    return html;
  }

  function normalizeSaVideoUrl(video) {
    if (!video) return '';
    if (typeof video === 'string') return video.trim();
    return String(video.url || video.src || video.videoUrl || '').trim();
  }

  function getSaAddonMediaItems(addon) {
    if (typeof window.getCdpAddonMediaItems === 'function') {
      return window.getCdpAddonMediaItems(addon) || [];
    }
    var items = [];
    var seen = {};
    var images = Array.isArray(addon.images) ? addon.images.filter(Boolean) : [];
    var videos = Array.isArray(addon.videos) ? addon.videos : [];
    images.forEach(function (src) {
      var url = String(src || '').trim();
      if (!url || seen[url]) return;
      seen[url] = true;
      items.push({ type: 'image', src: url });
    });
    videos.forEach(function (video) {
      var url = normalizeSaVideoUrl(video);
      if (!url || seen[url]) return;
      seen[url] = true;
      items.push({ type: 'video', src: url });
    });
    return items;
  }

  function renderSaAddonMedia(addon) {
    var mediaItems = getSaAddonMediaItems(addon);
    if (!mediaItems.length) {
      return '<div class="cdp-sa-addon-media cdp-addon-media cdp-addon-media--empty" aria-hidden="true">+</div>';
    }
    var first = mediaItems[0];
    var mainInner = first.type === 'video'
      ? '<video src="' + first.src + '" muted playsinline preload="metadata" data-sa-main-media="' + String(addon._id) + '" data-sa-media-type="video"></video>'
      : '<img src="' + first.src + '" alt="" loading="lazy" data-sa-main-media="' + String(addon._id) + '" data-sa-media-type="image">';
    var thumbs = mediaItems.length > 1
      ? '<div class="cdp-sa-addon-thumbs">' + mediaItems.slice(0, 4).map(function (item, idx) {
        var thumbInner = item.type === 'video'
          ? '<video src="' + item.src + '" muted playsinline preload="metadata" aria-hidden="true"></video>'
          : '<img src="' + item.src + '" alt="" loading="lazy">';
        return '<button type="button" class="cdp-sa-addon-thumb' + (item.type === 'video' ? ' is-video' : '') + (idx === 0 ? ' is-active' : '') +
          '" data-sa-thumb-src="' + item.src + '" data-sa-thumb-type="' + item.type + '" aria-label="View ' + item.type + ' ' + (idx + 1) + '">' +
          thumbInner + '</button>';
      }).join('') + (mediaItems.length > 4 ? '<span class="cdp-sa-thumb-more">+' + (mediaItems.length - 4) + '</span>' : '') + '</div>'
      : '';
    return '<div class="cdp-sa-addon-media-wrap">' +
      '<button type="button" class="cdp-sa-addon-media cdp-addon-media' + (first.type === 'video' ? ' cdp-addon-media--video' : '') + '" data-sa-gallery="' + String(addon._id) + '" aria-label="View media">' +
        mainInner +
      '</button>' + thumbs + '</div>';
  }

  function openStandaloneAddonModal(seedAddonId, addressContext, seedIds) {
    if (typeof hideLoaderFull === 'function') hideLoaderFull();
    addressContext = addressContext || window._standaloneAddressContext || null;
    var catalog = listStandaloneAddons();
    if (!catalog.length) {
      notify('No add-ons can be booked separately on this package.', 'error');
      return;
    }
    seedIds = (seedIds && seedIds.length ? seedIds : resolveStandaloneSeedIds(seedAddonId)).map(String);
    var existing = document.getElementById('cdp-standalone-modal');
    if (existing) existing.remove();

    var states = {};
    catalog.forEach(function (addon) {
      var id = String(addon._id);
      states[id] = createStandaloneAddonState(addon);
      states[id].selected = seedIds.indexOf(id) !== -1;
      ensureStandaloneTimeSlotAuto(addon, states[id]);
    });
    if (!Object.keys(states).some(function (id) { return states[id].selected; })) {
      states[String(catalog[0]._id)].selected = true;
    }

    var singleMode = catalog.length === 1;
    if (singleMode) states[String(catalog[0]._id)].selected = true;

    var symbol = curSym();
    var modal = document.createElement('div');
    modal.id = 'cdp-standalone-modal';
    modal.className = 'cdp-standalone-modal';
    var saCalendarMonths = {};

    modal.innerHTML =
      '<div class="cdp-standalone-dialog cdp-standalone-dialog--multi" role="dialog" aria-modal="true" aria-labelledby="cdp-standalone-title">' +
        '<div class="cdp-standalone-head">' +
          '<div class="cdp-standalone-head-text">' +
            '<span class="cdp-standalone-kicker">Book separately</span>' +
            '<h2 id="cdp-standalone-title">' + (singleMode ? 'Book this add-on' : 'Book add-ons separately') + '</h2>' +
            '<p class="cdp-standalone-sub">' +
              (singleMode
                ? 'Choose your date, time slot, and guests — then continue to checkout.'
                : 'Select add-ons, configure each one, then pay one combined deposit at checkout.') +
            '</p>' +
            '<ol class="cdp-sa-steps" aria-hidden="true">' +
              '<li class="is-active"><span>1</span> Configure booking</li>' +
              '<li><span>2</span> Address &amp; pay</li>' +
            '</ol>' +
          '</div>' +
          '<button type="button" class="cdp-standalone-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="cdp-standalone-body">' +
          '<div class="cdp-standalone-col cdp-standalone-col--booking">' +
            '<div class="cdp-sa-col-head">' +
              '<h3 class="cdp-standalone-section-title">Add-on details</h3>' +
              '<p class="cdp-sa-col-help" id="cdp-sa-count-help"></p>' +
            '</div>' +
            '<div class="cdp-standalone-addon-list"></div>' +
            '<div class="cdp-standalone-inline-error" id="cdp-sa-selection-error"></div>' +
          '</div>' +
          '<div class="cdp-standalone-col cdp-standalone-col--summary">' +
            '<div class="cdp-sa-col-head cdp-sa-col-head--summary">' +
              '<h3 class="cdp-standalone-section-title">Order summary</h3>' +
              '<p class="cdp-sa-col-help">Your contact, shipping, and billing details will be collected at checkout.</p>' +
            '</div>' +
            '<div class="cdp-standalone-summary"></div>' +
          '</div>' +
        '</div>' +
        '<div class="cdp-standalone-foot">' +
          '<div class="cdp-sa-foot-meta" id="cdp-sa-foot-meta"></div>' +
          '<button type="button" class="cdp-standalone-submit">Continue to checkout</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);

    var listEl = modal.querySelector('.cdp-standalone-addon-list');
    var summary = modal.querySelector('.cdp-standalone-summary');
    var countHelp = modal.querySelector('#cdp-sa-count-help');
    var footMeta = modal.querySelector('#cdp-sa-foot-meta');
    var submitBtn = modal.querySelector('.cdp-standalone-submit');
    var selectionErrorEl = modal.querySelector('#cdp-sa-selection-error');

    function selectedPairs() {
      return catalog.filter(function (addon) {
        return states[String(addon._id)] && states[String(addon._id)].selected;
      }).map(function (addon) {
        return { addon: addon, state: states[String(addon._id)] };
      });
    }

    function setInlineError(el, msg) {
      if (!el) return;
      el.textContent = msg || '';
      el.classList.toggle('is-visible', !!msg);
      if (!msg) return;
      var scrollTarget = el.closest('.cdp-sa-addon-block')
        || el.closest('.cdp-standalone-col')
        || el.closest('.cdp-standalone-body')
        || el;
      scrollCdpToElement(scrollTarget, { block: 'center', focus: false });
    }

    function addonReadyState(addon, state) {
      if (!state.selected) return { key: 'off', label: 'Not included' };
      if (!state.dates || !state.dates.length) return { key: 'need', label: 'Needs a date' };
      if (addonRequiresTimeSlot(addon) && !state.slot) return { key: 'need', label: 'Needs a time' };
      if (isBundleAddOn(addon) && state.persons < 1) return { key: 'need', label: 'Needs guests' };
      return { key: 'ready', label: 'Ready' };
    }

    function refreshSummary() {
      var pairs = selectedPairs();
      var n = pairs.length;
      if (countHelp) {
        countHelp.textContent = singleMode
          ? 'Only this add-on can be booked alone here.'
          : (n === 0
            ? 'Tick an add-on below to include it.'
            : n + ' of ' + catalog.length + ' add-on' + (n === 1 ? '' : 's') + ' included');
      }

      if (!pairs.length) {
        summary.innerHTML =
          '<div class="cdp-sa-summary-empty">' +
            '<strong>Nothing selected yet</strong>' +
            '<p>Include at least one add-on on the left to see pricing.</p>' +
          '</div>';
        if (footMeta) footMeta.textContent = 'Select an add-on to continue';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Select an add-on first';
        }
        return;
      }

      var totals = calcStandaloneSelectionTotals(pairs);
      var lines = pairs.map(function (pair) {
        var line = standaloneLineTotal(pair.addon, pair.state.dates, pair.state.persons);
        var dep = standaloneDepositAmount(pair.addon, line);
        var ready = addonReadyState(pair.addon, pair.state);
        var dateBit = pair.state.dates && pair.state.dates.length
          ? pair.state.dates.map(formatAddOnChipLabel).join(', ')
          : 'No date yet';
        return '<div class="cdp-sa-summary-item">' +
          '<div class="cdp-sa-summary-item-top">' +
            '<span class="cdp-sa-summary-item-name">' + (pair.addon.title || 'Add-on') + '</span>' +
            '<strong>' + symbol + moneyFmt(line) + '</strong>' +
          '</div>' +
          '<div class="cdp-sa-summary-item-meta">' + dateBit +
            (pair.state.slot ? ' · ' + formatSlotLabel(pair.state.slot) : '') +
            (isBundleAddOn(pair.addon) ? ' · ' + pair.state.persons + ' guest' + (pair.state.persons > 1 ? 's' : '') : '') +
            ' · Deposit ' + dep.percent + '% (' + symbol + moneyFmt(dep.amount) + ')' +
            ' · <em class="cdp-sa-status cdp-sa-status--' + ready.key + '">' + ready.label + '</em>' +
          '</div>' +
        '</div>';
      }).join('');

      var avgDepositPct = pairs.length === 1
        ? getAddonDepositPercent(pairs[0].addon)
        : (totals.total > 0 ? Math.round((totals.deposit / totals.total) * 100) : getAddonDepositPercent(pairs[0].addon));

      summary.innerHTML =
        '<div class="cdp-sa-summary-list">' + lines + '</div>' +
        '<div class="cdp-sa-summary-row"><span>Booking total</span><strong>' + symbol + moneyFmt(totals.total) + '</strong></div>' +
        '<div class="cdp-sa-summary-row cdp-sa-summary-row--deposit"><span>Pay now (' + avgDepositPct + '% deposit)</span><strong>' + symbol + moneyFmt(totals.deposit) + '</strong></div>' +
        '<p class="cdp-sa-summary-note">The remaining balance is due before your event. Shipping, billing, and contact details are collected at checkout.</p>';

      if (footMeta) {
        footMeta.innerHTML = '<strong>' + n + ' add-on' + (n === 1 ? '' : 's') + '</strong>' +
          '<span>Deposit due: ' + symbol + moneyFmt(totals.deposit) + '</span>';
      }
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Continue to checkout · ' + symbol + moneyFmt(totals.deposit) + ' deposit';
      }
    }

    function renderAddonBlock(addon) {
      var id = String(addon._id);
      var state = states[id];
      var multiDates = addonAllowsMultipleDates(addon);
      var ready = addonReadyState(addon, state);
      var lineTotal = standaloneLineTotal(addon, state.dates, state.persons);
      var dep = standaloneDepositAmount(addon, lineTotal);
      var depositPct = getAddonDepositPercent(addon);
      var desc = addon.description ? String(addon.description) : '';
      if (!saCalendarMonths[id]) {
        saCalendarMonths[id] = state.dates[0]
          ? state.dates[0].slice(0, 7)
          : nextAllowedDateForAddon(addon).slice(0, 7);
      }
      var selectedChips = state.dates.length
        ? '<div class="cdp-addon-dates"><span class="cdp-addon-dates-label">' + (multiDates ? 'Selected days' : 'Selected day') + '</span><div class="cdp-addon-date-chips">' +
          state.dates.map(function (d) {
            return '<button type="button" class="cdp-addon-date-chip is-active" data-sa-remove-date="' + id + '" data-date="' + d + '" aria-label="Remove ' + formatAddOnChipLabel(d) + '">' +
              formatAddOnChipLabel(d) + (multiDates ? ' ×' : '') + '</button>';
          }).join('') + '</div></div>'
        : '';
      var daysHint = Array.isArray(addon.availableDays) && addon.availableDays.length
        ? '<p class="cdp-standalone-hint">Available on: ' + addon.availableDays.map(function (d) { return d.charAt(0).toUpperCase() + d.slice(1); }).join(', ') + '</p>'
        : '';
      var slotsHtml = '';
      if (addonRequiresTimeSlot(addon)) {
        var saPrimaryDate = state.dates[0] || '';
        var saUniqueSlots = getUniqueAddonTimeSlots(addon);
        slotsHtml = '<div class="cdp-addon-slots"><span class="cdp-addon-slots-label">Choose time slot</span><div class="cdp-addon-slot-chips">' +
          saUniqueSlots.map(function (slot) {
            var active = state.slot && state.slot.startTime === slot.startTime && state.slot.endTime === slot.endTime;
            return buildAddonSlotChipHtml(addon, slot, { addonId: id, dateStr: saPrimaryDate, active: active, saSlot: true });
          }).join('') +
          '</div><div class="cdp-standalone-inline-error" data-sa-slot-error="' + id + '"></div></div>';
      }
      var guestsHtml = isBundleAddOn(addon)
        ? '<div class="cdp-addon-stepper"><span class="cdp-addon-stepper-label">Number of guests</span><div class="cdp-addon-stepper-controls">' +
            '<button type="button" class="cdp-addon-stepper-btn" data-sa-step="' + id + '" data-delta="-1" aria-label="Remove guest"' + (state.persons <= 1 ? ' disabled' : '') + '>−</button>' +
            '<span class="cdp-addon-guest-value" data-sa-guests="' + id + '">' + state.persons + '</span>' +
            '<button type="button" class="cdp-addon-stepper-btn" data-sa-step="' + id + '" data-delta="1" aria-label="Add guest">+</button>' +
          '</div><div class="cdp-standalone-inline-error" data-sa-guests-error="' + id + '"></div></div>'
        : '';
      var unit = Number(addon.price) || 0;
      var priceLabel = symbol + moneyFmt(unit) + (isBundleAddOn(addon) ? ' / person / day' : ' / day');
      var includeLabel = addonIncludeLabel(!!state.selected);
      var includeToggle = singleMode
        ? ''
        : '<label class="cdp-sa-include-toggle' + (state.selected ? ' is-included' : '') + '"><input type="checkbox" data-sa-toggle="' + id + '"' + (state.selected ? ' checked' : '') + '><span data-sa-include-label="' + id + '">' + includeLabel + '</span></label>';

      return '<div class="cdp-sa-addon-block' + (state.selected ? ' is-selected' : '') + '" data-sa-block="' + id + '">' +
        '<div class="cdp-sa-addon-card">' +
          renderSaAddonMedia(addon) +
          '<div class="cdp-sa-addon-body">' +
            '<div class="cdp-sa-addon-head">' +
              '<div class="cdp-sa-addon-head-text">' +
                '<p class="cdp-sa-addon-name">' + (addon.title || 'Add-on') +
                  '<span class="cdp-sa-deposit-badge">' + depositPct + '% deposit</span>' +
                  '<span class="cdp-sa-status cdp-sa-status--' + ready.key + '">' + ready.label + '</span>' +
                '</p>' +
                '<div class="cdp-sa-addon-price">' + priceLabel + '</div>' +
              '</div>' +
              includeToggle +
            '</div>' +
            (desc ? '<p class="cdp-sa-addon-desc">' + desc + '</p>' : '') +
          '</div>' +
        '</div>' +
        '<div class="cdp-sa-addon-options"' + (state.selected ? '' : ' hidden') + '>' +
          '<div class="cdp-sa-options-lead">Choose your booking date' + (multiDates ? 's' : '') + '</div>' +
          renderSaCalendarHtml(addon, state, saCalendarMonths[id]) +
          selectedChips +
          daysHint +
          '<div class="cdp-standalone-inline-error" data-sa-date-error="' + id + '"></div>' +
          slotsHtml +
          guestsHtml +
          '<div class="cdp-sa-addon-line">' +
            '<span>Subtotal · Deposit ' + dep.percent + '% (' + symbol + moneyFmt(dep.amount) + ')</span>' +
            '<strong>' + symbol + moneyFmt(lineTotal) + '</strong>' +
          '</div>' +
        '</div></div>';
    }

    function syncSaIncludeToggle(id) {
      var state = states[id];
      if (!state) return;
      var block = listEl.querySelector('[data-sa-block="' + id + '"]');
      if (!block) return;
      block.classList.toggle('is-selected', !!state.selected);
      var toggle = block.querySelector('.cdp-sa-include-toggle');
      if (toggle) {
        toggle.classList.toggle('is-included', !!state.selected);
        var label = toggle.querySelector('[data-sa-include-label="' + id + '"]') || toggle.querySelector('span');
        if (label) label.textContent = addonIncludeLabel(!!state.selected);
        var input = toggle.querySelector('[data-sa-toggle="' + id + '"]');
        if (input) input.checked = !!state.selected;
      }
      var opts = block.querySelector('.cdp-sa-addon-options');
      if (opts) opts.hidden = !state.selected;
    }

    function renderList() {
      listEl.innerHTML = catalog.map(renderAddonBlock).join('');
      refreshSummary();
    }

    function toggleSaDate(addon, state, dateStr) {
      var id = String(addon._id);
      var err = modal.querySelector('[data-sa-date-error="' + id + '"]');
      if (!dateStr) return;
      if (isAddonStandaloneDateFullyBooked(addon, dateStr)) {
        setInlineError(err, 'All time slots are fully booked on this date.');
        return;
      }
      if (isBeforeAddonFirstBookable(dateStr)) {
        setInlineError(err, 'This date is not available for booking yet.');
        return;
      }
      if (!isDateAllowedForAddon(addon, dateStr)) {
        setInlineError(err, 'That weekday is not available for this add-on.');
        return;
      }
      if (addonAllowsMultipleDates(addon)) {
        if (state.dates.indexOf(dateStr) === -1) state.dates = state.dates.concat(dateStr).sort();
        else state.dates = state.dates.filter(function (d) { return d !== dateStr; });
      } else if (state.dates[0] === dateStr) {
        state.dates = [];
      } else {
        state.dates = [dateStr];
      }
      saCalendarMonths[id] = dateStr.slice(0, 7);
      setInlineError(err, '');
      ensureStandaloneTimeSlotAuto(addon, state);
      renderList();
    }

    function addDateToAddon(id, dateStr) {
      var addon = getAddonById(id);
      var state = states[id];
      if (!addon || !state || !dateStr) return;
      toggleSaDate(addon, state, dateStr);
    }

    var previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    function close() {
      document.removeEventListener('keydown', onStandaloneEsc);
      document.body.style.overflow = previousOverflow || '';
      if (typeof hideLoaderFull === 'function') hideLoaderFull();
      modal.remove();
    }

    function onStandaloneEsc(e) {
      if (e.key === 'Escape') close();
    }

    modal.querySelector('.cdp-standalone-close').onclick = close;
    modal.onclick = function (ev) {
      if (ev.target === modal) close();
    };
    document.addEventListener('keydown', onStandaloneEsc);

    listEl.addEventListener('change', function (ev) {
      var toggle = ev.target.closest('[data-sa-toggle]');
      if (toggle) {
        var id = toggle.getAttribute('data-sa-toggle');
        if (!states[id]) return;
        states[id].selected = !!toggle.checked;
        if (states[id].selected) ensureStandaloneTimeSlotAuto(getAddonById(id), states[id]);
        setInlineError(selectionErrorEl, '');
        syncSaIncludeToggle(id);
        refreshSummary();
      }
    });

    listEl.addEventListener('click', function (ev) {
      var galleryBtn = ev.target.closest('[data-sa-gallery]');
      if (galleryBtn) {
        ev.preventDefault();
        var gId = galleryBtn.getAttribute('data-sa-gallery');
        var gAddon = getAddonById(gId);
        if (gAddon && typeof window.openCdpAddonGallery === 'function') window.openCdpAddonGallery(gAddon);
        return;
      }
      var thumbBtn = ev.target.closest('.cdp-sa-addon-thumb');
      if (thumbBtn) {
        var src = thumbBtn.getAttribute('data-sa-thumb-src');
        var thumbType = thumbBtn.getAttribute('data-sa-thumb-type') || 'image';
        var block = thumbBtn.closest('[data-sa-block]');
        if (block && src) {
          block.querySelectorAll('.cdp-sa-addon-thumb').forEach(function (t) { t.classList.remove('is-active'); });
          thumbBtn.classList.add('is-active');
          var mainBtn = block.querySelector('.cdp-sa-addon-media[data-sa-gallery]');
          var mainMedia = block.querySelector('[data-sa-main-media]');
          if (mainBtn) {
            var addonId = mainBtn.getAttribute('data-sa-gallery') || '';
            if (thumbType === 'video') {
              mainBtn.classList.add('cdp-addon-media--video');
              mainBtn.innerHTML = '<video src="' + src + '" muted playsinline preload="metadata" data-sa-main-media="' + addonId + '" data-sa-media-type="video"></video>';
            } else {
              mainBtn.classList.remove('cdp-addon-media--video');
              mainBtn.innerHTML = '<img src="' + src + '" alt="" loading="lazy" data-sa-main-media="' + addonId + '" data-sa-media-type="image">';
            }
          } else if (mainMedia) {
            mainMedia.src = src;
          }
        }
        return;
      }
      var calPrev = ev.target.closest('[data-sa-cal-prev]');
      if (calPrev) {
        var prevId = calPrev.getAttribute('data-sa-cal-prev');
        saCalendarMonths[prevId] = shiftSaMonthKey(saCalendarMonths[prevId] || saMonthKeyFromDate(new Date()), -1);
        renderList();
        return;
      }
      var calNext = ev.target.closest('[data-sa-cal-next]');
      if (calNext) {
        var nextId = calNext.getAttribute('data-sa-cal-next');
        saCalendarMonths[nextId] = shiftSaMonthKey(saCalendarMonths[nextId] || saMonthKeyFromDate(new Date()), 1);
        renderList();
        return;
      }
      var calDay = ev.target.closest('[data-sa-cal-day]');
      if (calDay && !calDay.disabled) {
        var dayId = calDay.getAttribute('data-sa-cal-day');
        var dayDate = calDay.getAttribute('data-date');
        var dayAddon = getAddonById(dayId);
        if (dayAddon && states[dayId]) toggleSaDate(dayAddon, states[dayId], dayDate);
        return;
      }
      var removeBtn = ev.target.closest('[data-sa-remove-date]');
      if (removeBtn) {
        var remId = removeBtn.getAttribute('data-sa-remove-date');
        var remDate = removeBtn.getAttribute('data-date');
        var remAddon = getAddonById(remId);
        if (remAddon && states[remId] && addonAllowsMultipleDates(remAddon)) {
          states[remId].dates = states[remId].dates.filter(function (d) { return d !== remDate; });
          renderList();
        }
        return;
      }
      var slotBtn = ev.target.closest('[data-sa-slot]');
      if (slotBtn) {
        if (slotBtn.disabled || slotBtn.classList.contains('is-disabled')) return;
        var slotId = slotBtn.getAttribute('data-sa-slot');
        states[slotId].slot = { startTime: slotBtn.getAttribute('data-start'), endTime: slotBtn.getAttribute('data-end') };
        setInlineError(modal.querySelector('[data-sa-slot-error="' + slotId + '"]'), '');
        renderList();
        return;
      }
      var stepBtn = ev.target.closest('[data-sa-step]');
      if (stepBtn) {
        var stepId = stepBtn.getAttribute('data-sa-step');
        var delta = parseInt(stepBtn.getAttribute('data-delta'), 10) || 0;
        states[stepId].persons = Math.max(1, states[stepId].persons + delta);
        setInlineError(modal.querySelector('[data-sa-guests-error="' + stepId + '"]'), '');
        renderList();
      }
    });

    submitBtn.onclick = function () {
      setInlineError(selectionErrorEl, '');
      var pairs = selectedPairs();
      if (!pairs.length) {
        setInlineError(selectionErrorEl, 'Please include at least one add-on.');
        return;
      }
      var invalid = false;
      pairs.forEach(function (pair) {
        var id = String(pair.addon._id);
        if (!pair.state.dates.length) {
          setInlineError(modal.querySelector('[data-sa-date-error="' + id + '"]'), 'Please choose a booking date on the calendar.');
          invalid = true;
        }
        if (isBundleAddOn(pair.addon) && pair.state.persons < 1) {
          setInlineError(modal.querySelector('[data-sa-guests-error="' + id + '"]'), 'Please set the number of guests.');
          invalid = true;
        }
        if (addonRequiresTimeSlot(pair.addon) && !pair.state.slot) {
          setInlineError(modal.querySelector('[data-sa-slot-error="' + id + '"]'), 'Please choose a time slot.');
          invalid = true;
        }
        if (addonRequiresTimeSlot(pair.addon) && pair.state.slot && pair.state.dates.length) {
          var slotTaken = pair.state.dates.some(function (d) {
            return isAddonStandaloneSlotBooked(pair.addon, d, pair.state.slot);
          });
          if (slotTaken) {
            setInlineError(modal.querySelector('[data-sa-slot-error="' + id + '"]'),
              'The selected time slot is fully booked on your chosen date. Please pick another slot or date.');
            invalid = true;
          }
        }
        if (pair.state.dates.some(function (d) { return isAddonStandaloneDateFullyBooked(pair.addon, d); })) {
          setInlineError(modal.querySelector('[data-sa-date-error="' + id + '"]'),
            'All time slots are fully booked on one of your selected dates.');
          invalid = true;
        }
      });
      if (invalid) {
        setInlineError(selectionErrorEl, 'Finish the highlighted details for each included add-on.');
        var firstBad = modal.querySelector('.cdp-standalone-inline-error:not(:empty)');
        if (firstBad) scrollCdpToElement(firstBad.closest('.cdp-sa-addon-block') || firstBad, { block: 'center', focus: false });
        return;
      }

      var contact = getStandaloneContactFromStorage();
      var requestData = buildStandaloneRequestData(pairs, contact, addressContext);
      if (!requestData.billingAddress || !requestData.shippingAddress) {
        delete requestData._addressGatePassed;
      }
      window.requestData = requestData;
      close();
      if (typeof window.bookVenueOrService === 'function') window.bookVenueOrService(requestData);
      else if (typeof bookVenueOrService === 'function') bookVenueOrService(requestData);
      else submitStandaloneAddonReservation(requestData);
    };

    renderList();
  }

  function submitStandaloneAddonReservation(requestData) {
    if (!requestData || !requestData._standaloneAddon) return;
    var contactPhone = (requestData._standaloneContact && requestData._standaloneContact.phone) || localStorage.getItem('customerPhone');
    var billing = normalizeStandaloneBillingAddress(
      requestData.billingAddress || (window._standaloneAddressContext && window._standaloneAddressContext.billingAddress),
      contactPhone
    );
    var venueShip = null;
    try {
      var pd = window.productDetails || {};
      var vl = pd.venueLocation || pd.location || null;
      if (vl && (vl.address || vl.address1)) {
        venueShip = {
          address1: vl.address || vl.address1 || '',
          city: vl.city || '',
          country: vl.country || '',
          province: vl.province || vl.region || '',
          zip: vl.zip || ''
        };
      }
    } catch (e) {}
    if ((!requestData.shippingAddress || !requestData.shippingAddress.address1) && venueShip) {
      requestData.shippingAddress = venueShip;
    }
    var shipping = normalizeStandaloneShippingAddress(
      requestData.shippingAddress || venueShip || (window._standaloneAddressContext && window._standaloneAddressContext.shippingAddress),
      contactPhone
    );
    if (!billing || !shipping) {
      delete requestData._addressGatePassed;
      window.requestData = requestData;
      if (typeof window.ensureAddressBeforeReservation === 'function') {
        window.ensureAddressBeforeReservation(requestData, function () {
          requestData._addressGatePassed = true;
          submitStandaloneAddonReservation(requestData);
        });
        return;
      }
      notify('Shipping and billing addresses are required for standalone add-on bookings.', 'error');
      return;
    }
    requestData.billingAddress = billing;
    requestData.shippingAddress = shipping;
    requestData._addressGatePassed = true;

    var authToken = localStorage.getItem('authToken') || '';
    var customerId = localStorage.getItem('customerId') || '';
    var contact = requestData._standaloneContact || {};
    var firstName = contact.firstName || localStorage.getItem('customerFirstName') || '';
    var lastName = contact.lastName || localStorage.getItem('customerLastName') || '';
    var email = contact.email || localStorage.getItem('customerEmail') || '';
    var phone = contact.phone || localStorage.getItem('customerPhone') || '';
    if (email) localStorage.setItem('customerEmail', email);
    if (firstName) localStorage.setItem('customerFirstName', firstName);
    if (lastName) localStorage.setItem('customerLastName', lastName);
    if (phone) localStorage.setItem('customerPhone', phone);

    var payload = buildStandaloneApiPayload(requestData);
    var url = API_BASE + '/api/reservations/standalone-addon';
    var body = ensureSelectedAddOnsApiKey(payload);

    if (typeof showLoaderFull === 'function') showLoaderFull();
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken.indexOf('Bearer ') === 0 ? authToken : 'Bearer ' + authToken
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error((data && data.message) || 'Unable to create standalone add-on reservation.');
          return data;
        });
      })
      .then(function (data) {
        if (!data || !data.data) throw new Error('Invalid response from server. Please try again.');
        var bookingId = data.data._id;
        var bookingData = data.data;
        var weddingRefId = normalizeWeddingId(bookingData.weddingRefId);
        var weddingInternalId = normalizeWeddingId(bookingData.weddingId);
        var weddingIdForDisplay = weddingRefId || weddingInternalId || resolveStandaloneWeddingId(bookingData);
        rememberWeddingId(weddingRefId || weddingIdForDisplay);
        var paymentIntentBody = {
          reservationId: bookingId,
          customerId: customerId,
          payerEmail: email,
          payerName: (firstName + ' ' + lastName).trim(),
          type: 'reservation'
        };
        if (weddingInternalId) paymentIntentBody.weddingId = weddingInternalId;
        else if (weddingRefId) paymentIntentBody.weddingId = weddingRefId;
        return fetch(API_BASE + '/api/payments/create-payment-intent', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authToken.indexOf('Bearer ') === 0 ? authToken : 'Bearer ' + authToken
          },
          body: JSON.stringify(paymentIntentBody)
        }).then(function (res) { return res.json(); }).then(function (paymentResponse) {
          if (typeof hideLoaderFull === 'function') hideLoaderFull();
          var clientSecret = paymentResponse && paymentResponse.data && paymentResponse.data.clientSecret;
          if (!clientSecret || typeof initStripePaymentModal !== 'function') {
            notify('Payment could not be started. Please try again.', 'error');
            return;
          }
          initStripePaymentModal({
            clientSecret: clientSecret,
            prefill: { firstName: firstName, lastName: lastName, email: email },
            submitLabel: 'Pay ' + (requestData._standaloneDepositLabel || ''),
            hideSummary: false,
            standaloneRequestData: requestData,
            onSuccess: function () {
              if (typeof showPaymentSuccessPopup === 'function') {
                showPaymentSuccessPopup({
                  venueName: requestData._standaloneAddonTitle || (bookingData && bookingData.venueName) || (addonTitleFromPayload(payload)) || 'Add-on',
                  amount: requestData._standaloneDepositLabel || 'N/A',
                  initialDepositDisplay: requestData._standaloneInitialDepositDisplay || null,
                  currency: typeof getSelectedCurrency === 'function' ? getSelectedCurrency() : 'USD',
                  bookingId: bookingId || 'N/A',
                  orderId: resolveBookingOrderId(bookingData, paymentResponse) || bookingData.orderRefId || bookingId,
                  weddingRefId: weddingRefId || weddingIdForDisplay,
                  weddingId: weddingRefId || weddingIdForDisplay,
                  Bdate: ((bookingData.selectedStandaloneAddons || bookingData.selectedAddOns || bookingData.selectedAddons) && (bookingData.selectedStandaloneAddons || bookingData.selectedAddOns || bookingData.selectedAddons)[0] && ((bookingData.selectedStandaloneAddons || bookingData.selectedAddOns || bookingData.selectedAddons)[0].datesOfBooking && (bookingData.selectedStandaloneAddons || bookingData.selectedAddOns || bookingData.selectedAddons)[0].datesOfBooking[0])) || bookingData.date,
                  paymentDate: new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' }),
                  date: ((bookingData.selectedStandaloneAddons || bookingData.selectedAddOns || bookingData.selectedAddons) && (bookingData.selectedStandaloneAddons || bookingData.selectedAddOns || bookingData.selectedAddons)[0] && ((bookingData.selectedStandaloneAddons || bookingData.selectedAddOns || bookingData.selectedAddons)[0].datesOfBooking && (bookingData.selectedStandaloneAddons || bookingData.selectedAddOns || bookingData.selectedAddons)[0].datesOfBooking[0])) || bookingData.date
                });
              } else {
                notify('Payment successful.', 'success');
              }
            }
          });
        });
      })
      .catch(function (err) {
        if (typeof hideLoaderFull === 'function') hideLoaderFull();
        notify(err.message || 'Standalone booking failed.', 'error');
      });
  }

  function renderStandalonePaymentSummary(requestData) {
    var summaryContainer = document.getElementById('payment-summary');
    if (!summaryContainer || !requestData) return;
    var items = getSelectedAddonsFromData(requestData);
    var total = Number(requestData.addOnsTotal) || 0;
    var depositAmount = 0;
    var lines = [];
    var formatAmount = function (amount) { return curSym() + moneyFmt(amount); };

    items.forEach(function (item) {
      var addon = getAddonById(item.addonId);
      if (!addon) return;
      var dates = item.datesOfBooking || [];
      var persons = item.noOfPersons || 1;
      var lineTotal = standaloneLineTotal(addon, dates, persons);
      if (!total) total += lineTotal;
      depositAmount += standaloneDepositAmount(addon, lineTotal).amount;
      var unit = Number(addon.price) || 0;
      var days = dates.length || 1;
      var title = addon.title || 'Add-on';
      if (isBundleAddOn(addon)) {
        lines.push(title + ': ' + formatAmount(unit) + ' × ' + persons + ' guest' + (persons > 1 ? 's' : '') + ' × ' + days + ' day' + (days > 1 ? 's' : '') + ' = ' + formatAmount(lineTotal));
      } else {
        lines.push(title + ': ' + formatAmount(unit) + ' × ' + days + ' day' + (days > 1 ? 's' : '') + ' = ' + formatAmount(lineTotal));
      }
    });

    if (!depositAmount && total) {
      var firstAddon = getAddonById(requestData.addonId || (items[0] && items[0].addonId));
      depositAmount = standaloneDepositAmount(firstAddon || {}, total).amount;
    }
    var remainingAmount = Math.max(0, total - depositAmount);

    var totalPriceEl = document.getElementById('summary-total-price');
    var payingNowEl = document.getElementById('summary-paying-now');
    var remainingAmountEl = document.getElementById('summary-remaining-amount');
    var pricePerNightRow = document.getElementById('summary-price-per-night-row');
    var addOnsRow = document.getElementById('summary-addons-row');
    var addOnsAmountEl = document.getElementById('summary-addons-amount');
    var addOnsInfo = document.getElementById('summary-addons-info');
    var nightsInfo = document.getElementById('summary-nights-info');
    var depositInfo = document.getElementById('summary-deposit-info');
    var installmentInfo = document.getElementById('summary-installment-info');
    var summaryTitle = summaryContainer.querySelector('h3');
    var summarySubtitle = summaryContainer.querySelector('h4');

    if (summaryTitle) summaryTitle.textContent = 'Complete your payment';
    if (summarySubtitle) summarySubtitle.textContent = items.length > 1 ? 'Standalone add-ons summary' : 'Standalone add-on summary';
    if (totalPriceEl) totalPriceEl.textContent = formatAmount(total);
    if (payingNowEl) payingNowEl.textContent = formatAmount(depositAmount);
    if (remainingAmountEl) remainingAmountEl.textContent = formatAmount(remainingAmount);
    if (pricePerNightRow) pricePerNightRow.style.display = 'none';
    if (addOnsRow && addOnsAmountEl) {
      addOnsRow.style.display = 'flex';
      addOnsRow.firstElementChild.textContent = items.length > 1 ? 'Add-ons total:' : 'Add-on total:';
      addOnsAmountEl.textContent = formatAmount(total);
    }
    if (addOnsInfo) addOnsInfo.textContent = lines.length ? ('• ' + lines.join('\n• ')) : '';
    if (nightsInfo) {
      var bits = items.map(function (item) {
        var addon = getAddonById(item.addonId);
        var label = (addon && addon.title) || 'Add-on';
        var dates = item.datesOfBooking || [];
        var part = label + ': ' + (dates.length ? dates.map(formatAddOnChipLabel).join(', ') : '—');
        if (item.timeSlot && item.timeSlot.startTime) part += ' · ' + formatSlotLabel(item.timeSlot);
        return part;
      });
      nightsInfo.textContent = bits.join(' | ');
    }
    if (depositInfo) depositInfo.textContent = 'Initial deposit due now: ' + formatAmount(depositAmount);
    if (installmentInfo) installmentInfo.textContent = 'Remaining balance due before your event.';
    summaryContainer.style.display = 'block';
    summaryContainer.classList.add('cdp-standalone-payment-summary');
  }

  function addonTitleFromPayload(payload) {
    try {
      var items = (payload && (payload.selectedAddOns || payload.selectedAddons)) || [];
      if (!items.length) return '';
      if (items.length === 1) {
        var one = getAddonById(items[0].addonId);
        return one && one.title;
      }
      return items.length + ' add-ons';
    } catch (e) { return ''; }
  }

  window.resolveSelectedVariant = resolveSelectedVariant;
  window.renderVariantAddOns = renderVariantAddOns;
  window.getSlotRemainingCapacity = getSlotRemainingCapacity;
  window.isDateFullyBookedForAddon = isDateFullyBookedForAddon;
  window.refreshAddonStandaloneButtons = refreshAddonStandaloneButtons;
  window.resetVenueAddOnSelections = resetVenueAddOnSelections;
  window.getSelectedAddOns = getSelectedAddOns;
  window.getSelectedAddOnsTotal = getSelectedAddOnsTotal;
  window.getAddOnBillingDays = getAddOnBillingDays;
  window.buildSelectedAddonsPayload = buildSelectedAddonsPayload;
  window.attachSelectedAddonsToRequest = attachSelectedAddonsToRequest;
  window.ensureSelectedAddOnsApiKey = ensureSelectedAddOnsApiKey;
  window.validateSelectedBundleAddOns = validateSelectedBundleAddOns;
  window.collectAddonValidationMessages = collectAddonValidationMessages;
  window.showAddonValidationErrors = showAddonValidationErrors;
  window.scrollCdpToElement = scrollCdpToElement;
  window.showCdpInlineFieldError = showCdpInlineFieldError;
  window.clearCdpFieldHighlight = clearCdpFieldHighlight;
  window.focusAddonValidationIssue = focusAddonValidationIssue;
  window.showVenueValidationMessage = showVenueValidationMessage;
  window.showAddonsValidationMessage = showAddonsValidationMessage;
  window.clearVenueValidationMessage = clearVenueValidationMessage;
  window.clearAddonsValidationMessage = clearAddonsValidationMessage;
  window.venueDatesReadyForAddons = venueDatesReadyForAddons;
  window.getAddOnPersons = getAddOnPersons;
  window.openStandaloneAddonModal = openStandaloneAddonModal;
  window.startStandaloneAddonFlow = startStandaloneAddonFlow;
  window.renderStandalonePaymentSummary = renderStandalonePaymentSummary;
  window.submitStandaloneAddonReservation = submitStandaloneAddonReservation;
})();


/* ===== Extracted from cdp.liquid (modals / auth / address / reviews) ===== */
(function () {
'use strict';

/* --- showCustomConfirm --- */
function showCustomConfirm(){
  return new Promise(function(resolve){
    var modal=document.getElementById('confirm-modal');
    var yesBtn=document.getElementById('confirm-yes');
    var noBtn=document.getElementById('confirm-no');
    var closeBtn=document.getElementById('confirm-close');
    if(!modal||!yesBtn||!noBtn){resolve(false);return;}
    var settled=false;
    function finish(result){
      if(settled)return;
      settled=true;
      modal.classList.add('hidden');
      yesBtn.removeEventListener('click',onYes);
      noBtn.removeEventListener('click',onNo);
      if(closeBtn)closeBtn.removeEventListener('click',onNo);
      modal.removeEventListener('click',onOverlay);
      document.removeEventListener('keydown',onEsc);
      resolve(result);
    }
    function onYes(e){if(e){e.preventDefault();e.stopPropagation();}finish(true);}
    function onNo(e){if(e){e.preventDefault();e.stopPropagation();}finish(false);}
    function onOverlay(e){if(e.target===modal)onNo(e);}
    function onEsc(e){if(e.key==='Escape')onNo(e);}
    modal.classList.remove('hidden');
    yesBtn.addEventListener('click',onYes);
    noBtn.addEventListener('click',onNo);
    if(closeBtn)closeBtn.addEventListener('click',onNo);
    modal.addEventListener('click',onOverlay);
    document.addEventListener('keydown',onEsc);
  });
}
window.showCustomConfirm = showCustomConfirm;

/* --- showPaymentSuccessPopup --- */
function showPaymentSuccessPopup(invoiceData=null){try{const popup=document.createElement('div');popup.className='payment-success-popup';let venueName='Venue/Service';try{venueName=invoiceData?.venueName||venueName;if(venueName==='Venue/Service'&&typeof productDetails!=='undefined'&&productDetails){venueName=productDetails.title||productDetails.name||venueName;}if(venueName==='Venue/Service'){const productTitleElement=document.querySelector('.productView-title, h1.product-title, [data-product-title]');if(productTitleElement)venueName=productTitleElement.textContent.trim()||venueName;}}catch(e){}let paymentAmount='N/A';try{paymentAmount=invoiceData?.amount||invoiceData?.depositAmount||(typeof getPaymentToPay==='function'?getPaymentToPay():null)||'N/A';}catch(e){paymentAmount=invoiceData?.amount||invoiceData?.depositAmount||'N/A';}const paymentDate=invoiceData?.paymentDate||new Date().toLocaleDateString('en-GB',{year:'numeric',month:'long',day:'numeric'});const bookingId=invoiceData?.bookingId||invoiceData?.reservationId||'N/A';const rawWeddingId=invoiceData?.weddingRefId||invoiceData?.weddingId;const weddingId=(rawWeddingId!=null&&String(rawWeddingId).trim()!==''&&String(rawWeddingId).toLowerCase()!=='n/a'&&String(rawWeddingId).toLowerCase()!=='nan')?String(rawWeddingId).trim():null;const orderId=invoiceData?.orderId||invoiceData?.bookingId||invoiceData?.reservationId||'N/A';const checkInDateValue=invoiceData?.checkInDate||invoiceData?.checkinDate;const checkOutDateValue=invoiceData?.checkOutDate||invoiceData?.checkoutDate;const hasStayDates=!!(checkInDateValue&&checkOutDateValue);const currentProductSource=window.productSource||(typeof productSource!=='undefined'?productSource:'');const invoicePd=window.productDetails||(typeof productDetails!=='undefined'?productDetails:null);const showVenueStayDatesOnInvoice=vendorType!=='Service'&&!(invoicePd&&invoicePd.venueType==='regular');const Bdate=invoiceData?.Bdate||invoiceData?.bookingDate||(!hasStayDates?invoiceData?.date:null);const showBookingDate=!!Bdate&&!hasStayDates;const bookingDateObject=showBookingDate?new Date(Bdate):null;const dateFmt={year:'numeric',month:'long',day:'numeric'};const bookingDateRow=bookingDateObject&&!isNaN(bookingDateObject.getTime())?`<div class="invoice-row"><span class="invoice-label">Booking Date:</span><span class="invoice-value">${bookingDateObject.toLocaleDateString('en-GB', dateFmt)}</span></div>`:'';const formattedAmount=typeof paymentAmount==='string'&&paymentAmount.includes('$')?paymentAmount:`$${paymentAmount}`;let invoiceHTML='';let hasProductDetails=false;try{hasProductDetails=typeof productDetails!=='undefined'&&productDetails;}catch(e){hasProductDetails=false;}if(true){invoiceHTML=`<div class="invoice-container"><div class="invoice-title">📄 Invoice</div><div class="invoice-row"><span class="invoice-label">Venue/Service Name:</span><span class="invoice-value">${venueName}</span></div> ${weddingId ? `<div class="invoice-row"><span class="invoice-label">Wedding ID:</span><span class="invoice-value">${weddingId}</span></div>` : ''} <div class="invoice-row"><span class="invoice-label">Order ID:</span><span class="invoice-value">${orderId}</span></div> ${bookingDateRow} <div class="invoice-row"><span class="invoice-label">Payment Date:</span><span class="invoice-value">${paymentDate}</span></div><div class="invoice-row"><span class="invoice-label">Initial Deposit:</span><span class="invoice-value invoice-amount">${(() => { if (invoiceData && invoiceData.initialDepositDisplay) return invoiceData.initialDepositDisplay; const pd = window.productDetails || (typeof productDetails !== 'undefined' ? productDetails : null); const ps = window.productSource || (typeof productSource !== 'undefined' ? productSource : ''); if (ps === 'olivers_travel') return '35%'; if (pd && pd.paymentPolicy && pd.paymentPolicy.depositPercentage !== undefined) { let depositPercentage = pd.paymentPolicy.depositPercentage; let totalPrice = 0; if (pd.variants && pd.variants.length > 0) { let variantId = null; const urlParams = new URLSearchParams(window.location.search); variantId = urlParams.get("variant"); if (!variantId) { const pathParts = window.location.pathname.split("/"); const variantIndex = pathParts.indexOf("variant"); if (variantIndex !== -1 && pathParts[variantIndex + 1]) variantId = pathParts[variantIndex + 1]; } const selectedVariant = variantId ? pd.variants.find(v => v.id == variantId) || pd.variants[0] : pd.variants[0]; if (selectedVariant && selectedVariant.price) { totalPrice = selectedVariant.price; if (ps === 'internal' && pd.venueType === 'accommodation' && invoiceData?.checkInDate && invoiceData?.checkOutDate) { const checkIn = new Date(invoiceData.checkInDate); const checkOut = new Date(invoiceData.checkOutDate); const nights = Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24)); totalPrice = totalPrice * nights; } if (pd.priceType === 'bundle') { const globalReqData = window.requestData || null; const guestCapacity = (globalReqData && globalReqData.capacity) ? globalReqData.capacity : 1; totalPrice = totalPrice * guestCapacity; } if (typeof getSelectedAddOnsTotal === 'function') { totalPrice = totalPrice + getSelectedAddOnsTotal(pd); } } } if (totalPrice > 0) { const depositAmount = (totalPrice * depositPercentage) / 100; const formattedDepositAmount = '$' + formatMoney(depositAmount); return `${depositPercentage}%(${formattedDepositAmount})`; } return `${depositPercentage}%`; } return '35%'; })()}</span></div> ${checkInDateValue && showVenueStayDatesOnInvoice ? `<div class="invoice-row"><span class="invoice-label">Check-In Date:</span><span class="invoice-value">${new Date(checkInDateValue).toLocaleDateString('en-GB',dateFmt)}</span></div>` : ''} ${checkOutDateValue && showVenueStayDatesOnInvoice ? `<div class="invoice-row"><span class="invoice-label">Check-Out Date:</span><span class="invoice-value">${new Date(checkOutDateValue).toLocaleDateString('en-GB',dateFmt)}</span></div>` : ''} </div>`;}popup.innerHTML=`<div class="payment-success-content"><button class="payment-success-close cdp-modal-close" onclick="this.closest('.payment-success-popup').remove()" aria-label="Close popup">&times;</button><h2>🎉 Payment Successful!</h2><p>Your payment has been processed successfully. You will receive a confirmation email shortly with all the details of your reservation.</p> ${invoiceHTML} <button class="payment-success-btn" onclick="this.closest('.payment-success-popup').remove()">Continue</button></div>`;document.body.appendChild(popup);popup.addEventListener('click',function(e){if(e.target===popup)popup.remove();});document.addEventListener('keydown',function onPsEsc(e){if(e.key==='Escape'){popup.remove();document.removeEventListener('keydown',onPsEsc);}});}catch(error){showNotification('Payment successful!','success');}}
window.showPaymentSuccessPopup = showPaymentSuccessPopup;

/* --- showOliversSuccessPopup --- */
function showOliversSuccessPopup(){const popup=document.createElement('div');popup.className='payment-success-popup';popup.innerHTML=` <div class="payment-success-content"><button class="payment-success-close cdp-modal-close" onclick="this.closest('.payment-success-popup').remove()" aria-label="Close popup">&times;</button><h2>✅ Request Submitted!</h2><p>Your request has been successfully sent to the admin. The admin will contact you after receiving confirmation from Oliver Travels. Please keep checking your email regularly.</p><button class="payment-success-btn" onclick="this.closest('.payment-success-popup').remove()"> Continue </button></div> `;document.body.appendChild(popup);setTimeout(()=>{if(popup.parentNode){popup.remove();}},8000);popup.addEventListener('click',function(e){if(e.target===popup)popup.remove();});document.addEventListener('keydown',function onOsEsc(e){if(e.key==='Escape'){popup.remove();document.removeEventListener('keydown',onOsEsc);}});}
window.showOliversSuccessPopup = showOliversSuccessPopup;

/* --- showOliversGuestPopup --- */
function showOliversGuestPopup(requestData,dwellingData){const popup=document.createElement("div");popup.className="olivers-guest-popup";popup.style.cssText='position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:99999;font-family:Arial,sans-serif;';const minGuests=dwellingData.details.base_capacity||1;const maxGuests=dwellingData.details.maximum_capacity||20;const currencySymbol='$';const initialPrice=calculateOliversPrice(dwellingData,requestData.date,requestData.checkoutDate,minGuests,'USD');const formattedPrice=formatCurrency(initialPrice.total);popup.innerHTML=` <div style="background:#fff;padding:20px;border-radius:12px;width:500px;max-width:95%;text-align:center;position:relative;box-shadow:0 8px 30px rgba(0,0,0,0.2);"><button id="closeOliversGuestPopup" class="cdp-modal-close" aria-label="Close">&times;</button><h2 style="color:#e02f8a;margin-bottom:20px;">Guest Details</h2><div style="margin-bottom:15px;text-align:left;"><label style="display:block;margin-bottom:6px;font-size:14px;color:#555;font-weight:bold;"> Check-In: <span style="color:#666;font-weight:normal;">${new Date(requestData.date).toLocaleDateString()}</span></label><label style="display:block;margin-bottom:6px;font-size:14px;color:#555;font-weight:bold;"> Check-Out: <span style="color:#666;font-weight:normal;">${new Date(requestData.checkoutDate).toLocaleDateString()}</span></label></div><div style="margin-bottom:15px;text-align:left;"><label style="display:block;margin-bottom:6px;font-size:14px;color:#555;font-weight:bold;"> Number of Adults <span style="color:#e02f8a;">*</span></label><input type="number" id="olivers-adults" min="1" max="${maxGuests}" value="${minGuests}" required style="width:100%;padding:12px;border:1px solid #ddd;border-radius:6px;font-size:14px;" /></div><div style="margin-bottom:20px;text-align:left;"><label style="display:block;margin-bottom:6px;font-size:14px;color:#555;font-weight:bold;"> Number of Children </label><input type="number" id="olivers-children" min="0" max="${maxGuests}" value="0" required style="width:100%;padding:12px;border:1px solid #ddd;border-radius:6px;font-size:14px;" /><div id="olivers-guest-error" style="color:#d32f2f;font-size:12px;margin-top:5px;display:none;"></div></div><div style="margin-bottom:25px;padding:15px;background:#f9f9f9;border-radius:8px;text-align:left;"><div style="font-size:14px;color:#666;margin-bottom:8px;">Total Price:</div><div id="olivers-total-price" style="font-size:24px;font-weight:bold;color:#e02f8a;"> ${currencySymbol}${formattedPrice} </div><div id="olivers-price-breakdown" style="font-size:12px;color:#999;margin-top:8px;"></div></div><button id="confirmOliversGuestBooking" style="width:100%;padding:12px;font-size:15px;background:#e02f8a;color:#fff;border:none;border-radius:6px;cursor:pointer;font-weight:600;">Confirm Booking</button></div> `;document.body.appendChild(popup);const adultsInput=document.getElementById('olivers-adults');const childrenInput=document.getElementById('olivers-children');const guestErrorEl=document.getElementById('olivers-guest-error');const totalPriceEl=document.getElementById('olivers-total-price');const priceBreakdownEl=document.getElementById('olivers-price-breakdown');function updatePrice(){const adults=parseInt(adultsInput.value)||minGuests;const children=parseInt(childrenInput.value)||0;const totalGuests=adults+children;if(totalGuests>maxGuests){guestErrorEl.textContent=`Total guests (${totalGuests}) cannot exceed maximum capacity (${maxGuests})`;guestErrorEl.style.display='block';return;}else if(totalGuests<minGuests){guestErrorEl.textContent=`Total guests must be at least ${minGuests}`;guestErrorEl.style.display='block';return;}else{guestErrorEl.style.display='none';}const priceData=calculateOliversPrice(dwellingData,requestData.date,requestData.checkoutDate,totalGuests,'USD');if(priceData.error){totalPriceEl.textContent='Price calculation error';priceBreakdownEl.textContent=priceData.error;return;}let displayPrice=priceData.total;if(productSource==='olivers_travel'){displayPrice=priceData.total*1;}const formattedPrice=formatCurrency(displayPrice);totalPriceEl.textContent=formattedPrice;const nights=priceData.nights;const avgPricePerNight=formatCurrency(displayPrice/nights);priceBreakdownEl.textContent=`${nights} night${nights > 1 ? 's' : ''} × ${avgPricePerNight} per night`;let calculatedPriceForStorage=priceData.total;if(productSource==='olivers_travel'){calculatedPriceForStorage=calculatedPriceForStorage*1;}requestData.calculatedPrice=calculatedPriceForStorage;requestData.numberOfGuests=totalGuests;requestData.numberOfAdults=adults;requestData.numberOfChildren=children;if(typeof window!=='undefined'){window.requestData=requestData;}}adultsInput.addEventListener('input',updatePrice);adultsInput.addEventListener('change',updatePrice);childrenInput.addEventListener('input',updatePrice);childrenInput.addEventListener('change',updatePrice);updatePrice();document.getElementById('closeOliversGuestPopup').addEventListener('click',()=>{document.body.removeChild(popup);document.removeEventListener('keydown',onOliversEsc);});function onOliversEsc(e){if(e.key==='Escape'&&popup.parentNode){document.body.removeChild(popup);document.removeEventListener('keydown',onOliversEsc);}}document.addEventListener('keydown',onOliversEsc);popup.addEventListener('click',(e)=>{if(e.target===popup&&popup.parentNode){document.body.removeChild(popup);document.removeEventListener('keydown',onOliversEsc);}});document.getElementById('confirmOliversGuestBooking').addEventListener('click',()=>{const adults=parseInt(adultsInput.value)||minGuests;const children=parseInt(childrenInput.value)||0;const totalGuests=adults+children;if(totalGuests>maxGuests){guestErrorEl.textContent=`Total guests (${totalGuests}) cannot exceed maximum capacity (${maxGuests})`;guestErrorEl.style.display='block';if(typeof window.showCdpInlineFieldError==='function')window.showCdpInlineFieldError(adultsInput,guestErrorEl.textContent);else if(typeof window.scrollCdpToElement==='function')window.scrollCdpToElement(adultsInput,{block:'center'});return;}if(totalGuests<minGuests){guestErrorEl.textContent=`Total guests must be at least ${minGuests}`;guestErrorEl.style.display='block';if(typeof window.showCdpInlineFieldError==='function')window.showCdpInlineFieldError(adultsInput,guestErrorEl.textContent);else if(typeof window.scrollCdpToElement==='function')window.scrollCdpToElement(adultsInput,{block:'center'});return;}const priceData=calculateOliversPrice(dwellingData,requestData.date,requestData.checkoutDate,totalGuests,'USD');let calculatedPrice=priceData.total/100;if(productSource==='olivers_travel'){calculatedPrice=calculatedPrice*1;}requestData.calculatedPrice=calculatedPrice;requestData.numberOfAdults=adults;requestData.numberOfChildren=children;requestData.numberOfGuests=totalGuests;if(typeof window!=='undefined'){window.requestData=requestData;}document.body.removeChild(popup);window.bookOliversTravel(requestData);});}
window.showOliversGuestPopup = showOliversGuestPopup;

/* --- showBundleGuestPopup --- */
function showBundleGuestPopup(requestData){const variantId=(function(){const urlParams=new URLSearchParams(window.location.search);return urlParams.get(' variant');})();const variants=productDetails?productDetails.variants:[];const selectedVariant=variants.find(v=>v.variantId==variantId||v.id==variantId)||variants[0];const perPersonPrice=selectedVariant?selectedVariant.price:0;const minGuests=selectedVariant&&selectedVariant.minGuests!=null?parseInt(selectedVariant.minGuests,10):1;const maxGuests=selectedVariant&&selectedVariant.maxGuests!=null?parseInt(selectedVariant.maxGuests,10):null;const initialGuestCount=minGuests>0?minGuests:1;const guestRangeHint=maxGuests!=null?`Guests must be between ${minGuests} and ${maxGuests}.`:(minGuests>1?`Minimum ${minGuests} guests required.`:'');const currencySymbol=getCurrencySymbol();const popup=document.createElement('div');popup.className= 'bundle-guest-popup';popup.style.cssText= 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:99999;font-family:Arial,sans-serif;';popup.innerHTML=` <div style="background:#fff;padding:20px;border-radius:12px;width:420px;max-width:95%;text-align:center;position:relative;box-shadow:0 8px 30px rgba(0,0,0,0.2);"><button id="closeBundleGuestPopup" class="cdp-modal-close" aria-label="Close">&times;</button><h2 style="color:#e02f8a;margin-bottom:8px;">Guest Details</h2><p style="margin-bottom:20px;color:#555;">How many guests will be attending?</p><div style="margin-bottom:15px;padding:12px;background:#f9f9f9;border-radius:8px;text-align:left;"><div style="font-size:14px;color:#666;">Price per person:</div><div id="bundle-price-per-person" style="font-size:20px;font-weight:bold;color:#333;">${currencySymbol}${formatMoney(perPersonPrice)}</div></div><div style="margin-bottom:15px;text-align:left;"><label style="display:block;margin-bottom:6px;font-size:14px;color:#555;font-weight:bold;"> Number of Guests <span style="color:#e02f8a;">*</span></label> ${guestRangeHint ? `<p style="margin:0 0 8px;font-size:12px;color:#888;">${guestRangeHint}</p>` : ''} <input type="number" id="bundle-guest-count" min="${minGuests}"${maxGuests != null ? `max="${maxGuests}"` : ''} value="${initialGuestCount}" required style="width:100%;padding:12px;border:1px solid #ddd;border-radius:6px;font-size:14px;" /><div id="bundle-guest-error" style="color:#d32f2f;font-size:12px;margin-top:5px;display:none;"></div></div><div style="margin-bottom:20px;padding:15px;background:#f9f9f9;border-radius:8px;text-align:left;"><div style="font-size:14px;color:#666;margin-bottom:4px;">Total Price:</div><div id="bundle-total-price" style="font-size:24px;font-weight:bold;color:#e02f8a;">${currencySymbol}${formatMoney(perPersonPrice * initialGuestCount)}</div><div id="bundle-price-breakdown" style="font-size:12px;color:#999;margin-top:4px;">${initialGuestCount} guest${initialGuestCount > 1 ? ' s' : ''} × ${currencySymbol}${formatMoney(perPersonPrice)} per person</div></div><div style="display:flex;gap:10px;"><button id="cancelBundleGuest" style="flex:1;padding:12px;font-size:15px;background:#f0f0f0;color:#333;border:none;border-radius:6px;cursor:pointer;">Cancel</button><button id="confirmBundleGuest" style="flex:1;padding:12px;font-size:15px;background:#e02f8a;color:#fff;border:none;border-radius:6px;cursor:pointer;font-weight:600;">Confirm & Book</button></div></div> `;document.body.appendChild(popup);const guestInput=document.getElementById('bundle-guest-count');const errorEl=document.getElementById('bundle-guest-error');const totalPriceEl=document.getElementById('bundle-total-price');const breakdownEl=document.getElementById('bundle-price-breakdown');const confirmBtn=document.getElementById('confirmBundleGuest');function validateGuestCount(showError){const guestCount=parseInt(guestInput.value,10);if(!guestCount||guestCount<1){if(showError){errorEl.textContent= 'Please enter a valid number of guests.';errorEl.style.display= 'block';if(typeof window.showCdpInlineFieldError=== 'function')window.showCdpInlineFieldError(guestInput,errorEl.textContent);else if(typeof window.scrollCdpToElement=== 'function')window.scrollCdpToElement(guestInput,{block: 'center'});else try{guestInput.focus();}catch(e){}}return false;}if(selectedVariant&&selectedVariant.minGuests!=null&&guestCount<minGuests){if(showError){errorEl.textContent=`Minimum guests required is ${minGuests}.`;errorEl.style.display= 'block';if(typeof window.showCdpInlineFieldError=== 'function')window.showCdpInlineFieldError(guestInput,errorEl.textContent);else if(typeof window.scrollCdpToElement=== 'function')window.scrollCdpToElement(guestInput,{block: 'center'});else try{guestInput.focus();}catch(e){}}return false;}if(selectedVariant&&selectedVariant.maxGuests!=null&&guestCount>maxGuests){if(showError){errorEl.textContent=`Maximum guests allowed is ${maxGuests}.`;errorEl.style.display= 'block';if(typeof window.showCdpInlineFieldError=== 'function')window.showCdpInlineFieldError(guestInput,errorEl.textContent);else if(typeof window.scrollCdpToElement=== 'function')window.scrollCdpToElement(guestInput,{block: 'center'});else try{guestInput.focus();}catch(e){}}return false;}errorEl.textContent='';errorEl.style.display= 'none';return true;}function updateBundleTotal(){const count=parseInt(guestInput.value,10)||0;const isValid=validateGuestCount(false);if(confirmBtn)confirmBtn.disabled=!isValid;if(!isValid){if(count>0)validateGuestCount(true);return;}const addOnsTotal=(typeof getSelectedAddOnsTotal=== 'function')?getSelectedAddOnsTotal(productDetails):0;const total=(perPersonPrice*count)+addOnsTotal;totalPriceEl.textContent=`${currencySymbol}${formatMoney(total)}`;breakdownEl.textContent=addOnsTotal>0?`${count} guest${count > 1 ? ' s' : ''} × ${currencySymbol}${formatMoney(perPersonPrice)} + add-ons ${currencySymbol}${formatMoney(addOnsTotal)}`:`${count} guest${count > 1 ? ' s' : ''} × ${currencySymbol}${formatMoney(perPersonPrice)} per person`;}guestInput.addEventListener(' input',updateBundleTotal);guestInput.addEventListener(' change',updateBundleTotal);updateBundleTotal();document.getElementById('closeBundleGuestPopup').addEventListener(' click',()=>{popup.remove();document.removeEventListener(' keydown',onBundleEsc);});document.getElementById('cancelBundleGuest').addEventListener(' click',()=>{popup.remove();document.removeEventListener(' keydown',onBundleEsc);});popup.addEventListener(' click',(e)=>{if(e.target===popup){popup.remove();document.removeEventListener(' keydown',onBundleEsc);}});function onBundleEsc(e){if(e.key=== 'Escape'){popup.remove();document.removeEventListener(' keydown',onBundleEsc);}}document.addEventListener(' keydown',onBundleEsc);document.getElementById('confirmBundleGuest').addEventListener(' click',()=>{const guestCount=parseInt(guestInput.value,10);if(!validateGuestCount(true)){return;}requestData.capacity=guestCount;ensureAddressBeforeReservation(requestData,()=>{popup.style.display= 'none';if(typeof showLoaderFull=== 'function')showLoaderFull();confirmBtn.disabled=true;confirmBtn.textContent= 'Booking...';confirmBtn.style.opacity= '0.7';const authToken=localStorage.getItem("authToken")||"";const customeris=localStorage.getItem("customerId")||"";if(typeof ensureSelectedAddOnsApiKey=== 'function')ensureSelectedAddOnsApiKey(requestData);fetch(' https://ejuno.skylinxtech.co/api/reservations',{method: 'POST',headers:{'Content-Type': 'application/json',' Authorization':authToken.startsWith('Bearer ')?authToken:`Bearer ${authToken}`},body:JSON.stringify(requestData)}).then(response=>{if(!response.ok){return response.json().then(errorData=>{throw new Error(errorData.message||' Booking failed. Please try again.');});}return response.json();}).then(data=>{if(data&&data.data){popup.remove();showLoaderFull();const bookingId=data.data._id;const bookingData=data.data;const orderId=data.data.orderRefId;const weddingId=data.data.weddingRefId;const Bdate=data.data.date;const customerFirstName=localStorage.getItem("customerFirstName")||"";const customerLastName=localStorage.getItem("customerLastName")||"";const customerEmail=localStorage.getItem("customerEmail")||"";const paymentPayload={reservationId:bookingId,customerId:customeris,payerEmail:customerEmail,payerName:`${customerFirstName} ${customerLastName}`.trim(),type:"reservation"};fetch(' https://ejuno.skylinxtech.co/api/payments/create-payment-intent',{method: 'POST',headers:{'Content-Type': 'application/json',' Authorization':authToken.startsWith('Bearer ')?authToken:`Bearer ${authToken}`},body:JSON.stringify(paymentPayload)}).then(response=>response.json()).then(paymentResponse=>{const clientSecret=paymentResponse.data.clientSecret;hideLoaderFull();initStripePaymentModal({clientSecret:clientSecret,prefill:{firstName:customerFirstName||'',lastName:customerLastName||'',email:customerEmail||''},submitLabel: 'Pay '+getPaymentToPay(),onSuccess:function(){let venueName= 'Venue/Service';try{venueName=bookingData?.venueName||venueName;if(venueName=== 'Venue/Service'&&typeof productDetails!== 'undefined'&&productDetails){venueName=productDetails.title||productDetails.name||venueName;}}catch(e){}let paymentAmount= 'N/A';try{paymentAmount=(typeof getPaymentToPay=== 'function'?getPaymentToPay():null)||' N/A';}catch(e){}const invoiceData={venueName:venueName,amount:paymentAmount,currency:getSelectedCurrency(),bookingId:bookingId||' N/A',orderId:orderId,weddingId:weddingId,Bdate:Bdate,paymentDate:new Date().toLocaleDateString(' en-GB',{year: 'numeric',month: 'long',day: 'numeric'}),checkInDate:bookingData?.checkInDate||bookingData?.date,checkOutDate:bookingData?.checkOutDate||bookingData?.checkoutDate,date:bookingData?.date};showPaymentSuccessPopup(invoiceData);}});}).catch(paymentError=>{showNotification("You need to log in before using our services.",'error');hideLoaderFull();});}else{throw new Error(' Invalid response from server.');}}).catch(error=>{popup.style.display= 'flex';errorEl.textContent=error.message;errorEl.style.display= 'block';confirmBtn.disabled=false;confirmBtn.textContent= 'Confirm & Book';confirmBtn.style.opacity= '1';});});});}
window.showBundleGuestPopup = showBundleGuestPopup;

/* --- handleCdpRegistryClick --- */
var registryClickLock = false;
function handleCdpRegistryClick(e) { if (e && typeof e.preventDefault === 'function') e.preventDefault(); if (e && typeof e.stopPropagation === 'function') e.stopPropagation(); if (registryClickLock) return; var _vt = String((typeof vendorType !== 'undefined' && vendorType) ? vendorType : ((window.productDetails && window.productDetails.vendor && window.productDetails.vendor.type) || (window.productDetails && window.productDetails.type) || '')).toLowerCase(); if (_vt === 'venue' || _vt === 'service') { var _b = document.getElementById('registry-btn'); if (_b) _b.style.display = 'none'; return; } var registryBtn = document.getElementById('registry-btn'); if (!registryBtn || registryBtn.disabled) return; registryClickLock = true; customerId = localStorage.getItem('customerId'); authToken = localStorage.getItem('authToken'); var _role = String(localStorage.getItem('customerRole') || localStorage.getItem('customerType') || '').toLowerCase(); if (_role === 'guest') { registryClickLock = false; if (typeof window.syncCdpRegistryButtonVisibility === 'function') { window.syncCdpRegistryButtonVisibility(); } return; } if (!authToken || authToken === 'null' || authToken === 'undefined' || !String(authToken).trim() || !customerId) { registryClickLock = false; if (typeof window.syncCdpRegistryButtonVisibility === 'function') { window.syncCdpRegistryButtonVisibility(); } return showLoginPopupregistry(function () { customerId = localStorage.getItem('customerId'); authToken = localStorage.getItem('authToken'); try { document.dispatchEvent(new CustomEvent('cdpAuthChanged')); } catch (err) {} if (typeof window.syncCdpRegistryButtonVisibility === 'function') { window.syncCdpRegistryButtonVisibility(); } var roleAfterLogin = String(localStorage.getItem('customerRole') || localStorage.getItem('customerType') || '').toLowerCase(); if (roleAfterLogin === 'guest') { var _rb2 = document.getElementById('registry-btn'); var _pb2 = document.getElementById('add-to-plan'); if (_rb2) _rb2.style.setProperty('display', 'none', 'important'); if (_pb2) _pb2.style.setProperty('display', 'none', 'important'); registryClickLock = false; return; } handleCdpRegistryClick(); }); } registryBtn.disabled = true; try { if (vendorType === 'Venue' || vendorType === 'Service') { var dates = (typeof window.getCdpSelectedDates === 'function' ? window.getCdpSelectedDates() : selectedDates) || []; if (!Array.isArray(dates) || dates.length === 0) { showNotification('Please select a date first !', 'error'); registryBtn.disabled = false; registryClickLock = false; return; } var lastValue = dates[dates.length - 1]; var urlParams = new URLSearchParams(window.location.search); var variantIdbookReg = urlParams.get('variant'); sendDataToRegistry({ shopifyProductId: productData.shopifyProductId, variantId: variantIdbookReg || (productData.variants[0] && productData.variants[0].id), date: lastValue }, true, registryBtn); } else { quantityValue = document.querySelector('.quantityValue') ? document.querySelector('.quantityValue').value.trim() : 1; var matchedVariant = getVariantByTitle(currentVariantTitle); if (!matchedVariant) matchedVariant = getFirstAvailableVariant(); if (matchedVariant) { sendDataToRegistry({ shopifyProductId: productData.shopifyProductId, variantId: matchedVariant.id, requiredQuantity: quantityValue }, false, registryBtn); } else { showNotification('Unable to find a product variant to add to registry.', 'error'); registryBtn.disabled = false; } } } catch (err) { console.error('Add to registry failed', err); showNotification((err && err.message) || 'Unable to add to registry.', 'error'); registryBtn.disabled = false; } finally { setTimeout(function () { registryClickLock = false; }, 500); } }
window.handleCdpRegistryClick = handleCdpRegistryClick;

/* --- sendDataToRegistry --- */
function sendDataToRegistry(data, isVenueOrService, button) { const apiUrl = 'https://ejuno.skylinxtech.co/api/registry-products/'; const token = localStorage.getItem('authToken') || authToken || ''; authToken = token; const payload = isVenueOrService ? { ...data, requiredQuantity: undefined } : { ...data, dates: undefined }; if (!token) { showNotification('Please log in again to add this to your registry.', 'error'); if (button) button.disabled = false; return; } fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': token.startsWith('Bearer ') ? token : `Bearer ${token}` }, body: JSON.stringify(payload) }) .then(response => { if (!response.ok) { return response.json().then(errData => { throw new Error(errData.message || 'Failed to add to registry'); }); } return response.json(); }) .then(data => { const successMessage = isVenueOrService ? 'Dates added to registry successfully!' : 'Product added to registry successfully!'; showNotification(successMessage, 'success'); }) .catch(error => { showNotification(error.message, 'error'); }) .finally(() => { if (button) button.disabled = false; }); }
window.sendDataToRegistry = sendDataToRegistry;

/* --- showLoginPopupregistry --- */
function showLoginPopupregistry(onLoginSuccess) {
let resendTimers = new Map();
const popup = document.createElement("div");
popup.className = "login-popup";
popup.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;z-index:99999;font-family:Arial,sans-serif;";
popup.innerHTML = `
<div class="login-modal"><button id="closePopup" class="close-btn cdp-modal-close" aria-label="Close">&times;</button><div class="tabs"><button class="tab-btn active" data-tab="coupleTab">Couple</button><button class="tab-btn" data-tab="guestTab">Guest</button></div>
${["coupleTab", "guestTab"].map(tab => `
<div id="${tab}" class="tab-content" style="${tab !== "coupleTab" ? "display:none" : ""}"><div class="login-header"><h2>Welcome</h2><p>Sign in to your account</p></div><div class="emailSection"><input type="email" class="loginEmail input" placeholder="Enter your email" /><button class="sendOtpBtn btn" style="margin-top:12px;">Send OTP</button><div class="msg sendMsg"></div></div><div class="otpSection" style="display:none;"><p style="font-size:13px;color:#666;text-align:center;">
Code sent to <br><span class="otpEmail" style="color:#e02f8a;font-weight:600;"></span></p><div class="otp-wrapper">
${[1,2,3,4,5,6].map(() => `<input class="otp-input" maxlength="1" />`).join("")}
</div><div class="msg otpMsg"></div><div class="resend">
Didn't receive?
<button class="resendOtpBtn" disabled>
Resend in <span class="countdown">30</span>s
</button></div><button class="verifyOtpBtn btn" style="margin-top:12px;">Verify</button><div class="msg verifyMsg"></div></div></div>
`).join("")}
<p class="register-prompt">Don't have an account? <a href="https://app.ejuno.io/registration" target="_blank" rel="noopener noreferrer">Register now</a></p>
</div>
`;
document.body.appendChild(popup);
popup.querySelector("#closePopup").onclick = function () {
resendTimers.forEach(function (t) { clearInterval(t); });
popup.remove();
};
popup.querySelectorAll(".tab-btn").forEach(function (btn) {
btn.onclick = function () {
popup.querySelectorAll(".tab-btn").forEach(function (b) { b.classList.remove("active"); });
popup.querySelectorAll(".tab-content").forEach(function (t) { t.style.display = "none"; });
btn.classList.add("active");
popup.querySelector("#" + btn.dataset.tab).style.display = "block";
};
});
popup.querySelectorAll(".tab-content").forEach(function (tab) {
var savedEmail = "";
var isGuest = tab.id === "guestTab";
var API_BASE = isGuest
? "https://ejuno.skylinxtech.co/api/guests"
: "https://ejuno.skylinxtech.co/api/couples";
var emailSection = tab.querySelector(".emailSection");
var otpSection = tab.querySelector(".otpSection");
var emailInput = tab.querySelector(".loginEmail");
var sendOtpBtn = tab.querySelector(".sendOtpBtn");
var verifyOtpBtn = tab.querySelector(".verifyOtpBtn");
var resendOtpBtn = tab.querySelector(".resendOtpBtn");
var otpEmail = tab.querySelector(".otpEmail");
var otpInputs = tab.querySelectorAll(".otp-input");
var sendMsg = tab.querySelector(".sendMsg");
var verifyMsg = tab.querySelector(".verifyMsg");
function setMsg(el, type, text) {
el.style.display = "block";
el.className = "msg " + type;
el.textContent = text;
}
function startTimer() {
var time = 30;
resendOtpBtn.disabled = true;
resendOtpBtn.innerHTML = 'Resend in <span class="countdown">' + time + '</span>s';
var countdownEl = resendOtpBtn.querySelector(".countdown");
var timer = setInterval(function () {
time--;
if (countdownEl) countdownEl.textContent = time;
if (time <= 0) {
clearInterval(timer);
resendOtpBtn.disabled = false;
resendOtpBtn.textContent = "Resend OTP";
}
}, 1000);
resendTimers.set(tab, timer);
}
function setSendOtpLoading(btn, loading) {
if (!btn) return;
if (loading) {
btn.disabled = true;
btn.classList.add("is-loading");
btn.dataset.originalLabel = btn.dataset.originalLabel || btn.textContent.trim() || "Send OTP";
btn.innerHTML = '<span class="cdp-btn-spinner" aria-hidden="true"></span> Sending…';
} else {
btn.disabled = false;
btn.classList.remove("is-loading");
btn.textContent = btn.dataset.originalLabel || "Send OTP";
}
}
function persistSession(data) {
if (typeof window.persistCdpLoginSession === "function") {
window.persistCdpLoginSession(data);
} else {
var payload = (data && data.data) || {};
var user = payload.user || {};
var customerId = payload.customerId || user.customerId || user._id || "";
var authToken = payload.authToken || payload.token || "";
var contactEmail = payload.contactEmail || user.contactEmail || "";
var firstName = payload.firstName || user.firstName || "";
var lastName = payload.lastName || user.lastName || "";
if (customerId) localStorage.setItem("customerId", String(customerId));
if (authToken) localStorage.setItem("authToken", authToken);
if (contactEmail) localStorage.setItem("customerEmail", contactEmail);
if (firstName) localStorage.setItem("customerFirstName", firstName);
if (lastName) localStorage.setItem("customerLastName", lastName);
}
var apiRole = "";
try {
var p = (data && data.data) || {};
var u = p.user || {};
apiRole = String(p.role || u.role || "").toLowerCase();
} catch (e) {}
var role = apiRole || (isGuest ? "guest" : "couple");
if (isGuest) role = "guest";
localStorage.setItem("customerRole", role);
localStorage.setItem("customerType", role === "guest" ? "guest" : "couple");
try { document.dispatchEvent(new CustomEvent("cdpAuthChanged")); } catch (e) {}
if (typeof window.syncCdpRegistryButtonVisibility === "function") window.syncCdpRegistryButtonVisibility();
// Force-hide both CTAs for guests immediately (before any callback)
if (role === "guest") {
var _rb = document.getElementById("registry-btn");
var _pb = document.getElementById("add-to-plan");
if (_rb) _rb.style.setProperty("display", "none", "important");
if (_pb) _pb.style.setProperty("display", "none", "important");
}
}
sendOtpBtn.onclick = async function () {
if (sendOtpBtn.disabled || sendOtpBtn.classList.contains("is-loading")) return;
var email = emailInput.value.trim();
sendMsg.style.display = "none";
if (!email) return setMsg(sendMsg, "error", "Please enter email");
savedEmail = email;
setSendOtpLoading(sendOtpBtn, true);
try {
var res = await fetch(API_BASE + "/send-login-otp", {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify({ contactEmail: email })
});
var data = await res.json();
if (!data.status) {
return setMsg(sendMsg, "error", data.message || "Failed to send OTP");
}
setMsg(sendMsg, "success", "OTP sent successfully");
emailSection.style.display = "none";
otpSection.style.display = "block";
otpEmail.textContent = email;
otpInputs.forEach(function (i) { i.value = ""; });
otpInputs[0].focus();
startTimer();
} catch (e) {
setMsg(sendMsg, "error", "Network error");
} finally {
setSendOtpLoading(sendOtpBtn, false);
}
};
resendOtpBtn.onclick = async function () {
if (resendOtpBtn.disabled || resendOtpBtn.dataset.sending === "1") return;
if (!savedEmail) return setMsg(sendMsg, "error", "Email not found. Please restart login.");
resendOtpBtn.dataset.sending = "1";
resendOtpBtn.disabled = true;
var prevResendLabel = resendOtpBtn.textContent;
resendOtpBtn.textContent = "Sending…";
try {
var res = await fetch(API_BASE + "/send-login-otp", {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify({ contactEmail: savedEmail })
});
var data = await res.json();
if (!data.status) {
return setMsg(sendMsg, "error", data.message || "Failed to resend OTP");
}
setMsg(sendMsg, "success", "OTP resent successfully");
if (resendTimers.has(tab)) clearInterval(resendTimers.get(tab));
startTimer();
otpInputs.forEach(function (i) { i.value = ""; });
otpInputs[0].focus();
} catch (e) {
setMsg(sendMsg, "error", "Network error");
resendOtpBtn.disabled = false;
resendOtpBtn.textContent = prevResendLabel || "Resend OTP";
} finally {
resendOtpBtn.dataset.sending = "0";
}
};
async function verifyOTP() {
var otp = Array.prototype.map.call(otpInputs, function (i) { return i.value; }).join("");
verifyMsg.style.display = "none";
if (otp.length !== 6) {
return setMsg(verifyMsg, "error", "Enter 6-digit OTP");
}
try {
var res = await fetch(API_BASE + "/verify-login-otp", {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify({ contactEmail: savedEmail, otp: otp })
});
var data = await res.json();
if (!data.status) {
otpInputs.forEach(function (i) { i.value = ""; });
otpInputs[0].focus();
return setMsg(verifyMsg, "error", "Invalid OTP");
}
setMsg(verifyMsg, "success", "Login successful");
persistSession(data);
setTimeout(function () {
popup.remove();
if (typeof onLoginSuccess === "function") onLoginSuccess();
else location.reload();
}, 800);
} catch (e) {
setMsg(verifyMsg, "error", "Network error");
}
}
otpInputs.forEach(function (input, i) {
input.oninput = function () {
input.value = input.value.replace(/\D/g, "");
if (input.value && i < 5) otpInputs[i + 1].focus();
else if (i === 5 && input.value) verifyOTP();
};
input.onkeydown = function (e) {
if (e.key === "Backspace" && !input.value && i > 0) otpInputs[i - 1].focus();
};
});
verifyOtpBtn.onclick = verifyOTP;
});
}

window.showLoginPopupregistry = showLoginPopupregistry;

/* --- openReviewImageModal --- */
function openReviewImageModal(images, startIndex) { currentReviewImages = images; currentReviewImageIndex = startIndex; const modal = document.getElementById('review-image-modal'); const img = document.getElementById('review-image-modal-img'); const indicators = document.querySelector('.review-image-modal-indicators'); const counter = document.querySelector('.review-image-modal-counter'); img.src = images[startIndex]; modal.style.display = 'flex'; if (counter) { counter.textContent = `${startIndex + 1} of ${images.length}`; } indicators.innerHTML = images.map((_, index) => `<div class="review-image-modal-indicator ${index===startIndex?' active':''}" onclick="goToReviewImage(${index})"></div>` ).join(''); document.body.style.overflow = 'hidden'; }
window.openReviewImageModal = openReviewImageModal;

/* --- closeReviewImageModal --- */
function closeReviewImageModal() { const modal = document.getElementById('review-image-modal'); modal.style.display = 'none'; document.body.style.overflow = ''; }
window.closeReviewImageModal = closeReviewImageModal;

/* --- nextReviewImage --- */
function nextReviewImage() { currentReviewImageIndex = (currentReviewImageIndex + 1) % currentReviewImages.length; updateReviewImageModal(); }
window.nextReviewImage = nextReviewImage;

/* --- prevReviewImage --- */
function prevReviewImage() { currentReviewImageIndex = (currentReviewImageIndex - 1 + currentReviewImages.length) % currentReviewImages.length; updateReviewImageModal(); }
window.prevReviewImage = prevReviewImage;

/* --- goToReviewImage --- */
function goToReviewImage(index) { currentReviewImageIndex = index; updateReviewImageModal(); }
window.goToReviewImage = goToReviewImage;

/* --- updateReviewImageModal --- */
function updateReviewImageModal() { const img = document.getElementById('review-image-modal-img'); const indicators = document.querySelectorAll('.review-image-modal-indicator'); const counter = document.querySelector('.review-image-modal-counter'); img.src = currentReviewImages[currentReviewImageIndex]; indicators.forEach((indicator, index) => { indicator.classList.toggle(' active', index === currentReviewImageIndex); }); if (counter) { counter.textContent = `${currentReviewImageIndex + 1} of ${currentReviewImages.length}`; } }
window.updateReviewImageModal = updateReviewImageModal;

/* --- openReviewVideoModal --- */
function openReviewVideoModal(src) { const modal = document.getElementById('review-video-modal'); const player = document.getElementById('review-video-modal-player'); player.src = src; modal.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
window.openReviewVideoModal = openReviewVideoModal;

/* --- closeReviewVideoModal --- */
function closeReviewVideoModal() { const modal = document.getElementById('review-video-modal'); const player = document.getElementById('review-video-modal-player'); player.pause(); player.src = ''; modal.style.display = 'none'; document.body.style.overflow = ''; }
window.closeReviewVideoModal = closeReviewVideoModal;

})();


/* ===== CDP address / login / date UI (from cdp.liquid) ===== */

/* --- address-gate --- */
(function(){function cdpAddrValidateFields(popup,errEl,fieldIds){var firstEmpty=null;fieldIds.forEach(function(id){var input=popup.querySelector('#'+id);if(!input)return;var empty=!String(input.value||'').trim();if(empty){input.classList.add('cdp-field-error');input.setAttribute('aria-invalid','true');if(!firstEmpty)firstEmpty=input;}else{input.classList.remove('cdp-field-error');input.removeAttribute('aria-invalid');}});if(firstEmpty){errEl.textContent= 'Please complete all required fields.';errEl.style.display= 'block';if(typeof window.showCdpInlineFieldError=== 'function')window.showCdpInlineFieldError(firstEmpty,errEl.textContent);else if(typeof window.scrollCdpToElement=== 'function')window.scrollCdpToElement(firstEmpty,{block: 'center'});else try{firstEmpty.focus();}catch(e){}return true;}errEl.style.display= 'none';errEl.textContent='';return false;}var __cdpAddrStyle=document.getElementById('cdp-addr-styles');if(__cdpAddrStyle){__cdpAddrStyle.remove();}{var s=document.createElement('style');s.id='cdp-addr-styles';s.textContent='.cdp-addr-overlay{position:fixed;inset:0;background:rgba(17,24,39,.72);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;z-index:100050;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;padding:16px;box-sizing:border-box}.cdp-addr-overlay--form{overflow:auto;padding:20px 16px;z-index:100050;align-items:center;justify-content:center}.cdp-addr-modal{background:#fff;border-radius:16px;max-width:100%;max-height:min(92vh,900px);position:relative;box-shadow:0 20px 60px rgba(0,0,0,.18);overflow:hidden;display:flex;flex-direction:column}.cdp-addr-modal--form{width:min(720px,100%)}.cdp-addr-modal--venue{width:min(540px,100%)}.cdp-addr-modal--venues{width:min(960px,100%)}.cdp-addr-modal-inner{padding:24px 28px 28px;overflow:auto;flex:1}.cdp-addr-modal--venues .cdp-addr-modal-inner{padding:24px 26px 26px}.cdp-addr-header{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:8px}.cdp-addr-header-text{flex:1;min-width:0;padding-right:44px}.cdp-addr-form-head{display:none;justify-content:space-between;align-items:center;margin-bottom:12px;min-height:36px}.cdp-addr-back{background:none;border:none;color:#e02f8a;font-size:14px;font-weight:600;cursor:pointer;padding:8px 0;display:inline-flex;align-items:center;gap:6px;transition:opacity .2s}.cdp-addr-back:hover{opacity:.8}.cdp-addr-close{position:absolute;top:14px;right:14px;z-index:5;width:36px;height:36px;display:flex;align-items:center;justify-content:center;background:#f3f4f6;border:none;border-radius:50%;font-size:20px;cursor:pointer;color:#6b7280;line-height:1;padding:0;transition:background .2s,color .2s}.cdp-addr-close:hover{background:#e5e7eb;color:#111827}.cdp-addr-modal h2{color:#111827;margin:0 0 6px;font-size:22px;font-weight:700;letter-spacing:-.02em;line-height:1.25}.cdp-addr-accent{color:#e02f8a}.cdp-addr-sub{margin:0;color:#6b7280;font-size:14px;line-height:1.6;max-width:52ch}.cdp-addr-body{margin:16px 0 4px;display:block;width:100%}.cdp-addr-modal-footer{margin-top:20px;padding-top:18px;border-top:1px solid #f0f0f0;display:flex;flex-direction:column;gap:10px}.cdp-addr-modal-footer .cdp-addr-link{margin:0;align-self:center}.cdp-addr-modal-footer .cdp-addr-btn{margin-top:0}.cdp-addr-split{display:flex;align-items:stretch;gap:0;width:100%}.cdp-addr-col{flex:1;min-width:0;display:flex;flex-direction:column}.cdp-addr-col-head{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 12px;padding-bottom:0;min-height:28px}.cdp-addr-col-title{font-size:14px;font-weight:600;color:#111827;margin:0;line-height:1.3}.cdp-addr-col-badge{font-size:11px;font-weight:600;color:#e02f8a;background:#fff5fa;border:1px solid #fce4f0;padding:4px 10px;border-radius:999px;white-space:nowrap;line-height:1.3}.cdp-addr-col--saved{padding-right:18px}.cdp-addr-saved-list{display:flex;flex-direction:column;gap:12px;width:100%}.cdp-addr-col--saved .cdp-addr-saved-list{flex:1}.cdp-addr-saved-list .cdp-addr-select-card{width:100%;box-sizing:border-box}.cdp-addr-saved-list--row{flex-direction:row;flex-wrap:wrap;align-items:stretch;gap:12px}.cdp-addr-saved-list--row .cdp-addr-select-card{flex:1;min-width:min(280px,100%)}.cdp-addr-select-card{cursor:pointer}.cdp-addr-col--venue{padding-left:18px}.cdp-addr-split-divider{flex:0 0 auto;width:1px;min-width:1px;align-self:stretch;background:#ececec;margin:0 6px}.cdp-addr-select-card{border:1.5px solid #e5e7eb;border-radius:12px;background:#fff;margin-bottom:0;overflow:hidden;transition:border-color .2s,box-shadow .2s,background .2s;box-shadow:0 1px 4px rgba(0,0,0,.04)}.cdp-addr-split .cdp-addr-select-card{width:100%}.cdp-addr-select-card--on{border-color:#e02f8a;background:#fffafb;box-shadow:0 0 0 3px rgba(224,47,138,.08)}.cdp-addr-select-card--on .cdp-addr-card-toolbar{background:#fff5fa;border-bottom-color:#fce4f0}.cdp-addr-card-toolbar{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:12px 14px;background:#fafafa;border-bottom:1px solid #f0f0f0}.cdp-addr-select-card--on .cdp-addr-card-toolbar{background:#fff5fa;border-bottom-color:#fce4f0}.cdp-addr-card-badge{flex:1;min-width:0;font-size:13px;font-weight:600;color:#111827;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cdp-addr-card-body{padding:14px 14px 16px;cursor:pointer}.cdp-addr-section--plain{border-bottom:none;margin-bottom:0;padding-bottom:0}.cdp-addr-combo{border:none;padding:0;background:transparent;cursor:inherit;position:static}.cdp-addr-combo:hover{background:transparent}.cdp-addr-combo--on{border:none;background:transparent;box-shadow:none}.cdp-addr-combo--on::after{display:none}.cdp-addr-section--venue-ship{background:#fafafa;border:1px solid #f0f0f0;border-radius:12px;padding:14px;margin:0 0 16px}.cdp-addr-locked-note{font-size:11px;font-weight:600;color:#e02f8a;background:#fff5fa;border:1px solid #fce4f0;padding:3px 8px;border-radius:999px;line-height:1.3}.cdp-addr-section{margin-bottom:16px;padding-bottom:16px;border-bottom:1px solid #f3f4f6}.cdp-addr-section:last-child{margin-bottom:0;padding-bottom:0;border-bottom:none}.cdp-addr-section h4{margin:0 0 8px;font-size:12px;color:#6b7280;font-weight:600;letter-spacing:0}.cdp-addr-section-head{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 8px;flex-wrap:wrap}.cdp-addr-section-head h4{margin:0}.cdp-addr-section--miss-bill,.cdp-addr-section--miss-ship{padding-bottom:0}.cdp-addr-btn-sm,.cdp-addr-add-billing-btn,.cdp-addr-add-shipping-btn{flex-shrink:0;display:inline-flex;align-items:center;justify-content:center;padding:7px 14px;border:1px solid #e5e7eb;border-radius:8px;background:#fff;color:#374151;font-size:12px;font-weight:600;line-height:1.3;cursor:pointer;font:inherit;white-space:nowrap;transition:all .2s}.cdp-addr-btn-sm:hover,.cdp-addr-add-billing-btn:hover,.cdp-addr-add-shipping-btn:hover{border-color:#e02f8a;color:#e02f8a;background:#fffafb}.cdp-addr-edit-btn{width:36px;height:36px;padding:0;border-radius:8px;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;border:1px solid #e5e7eb;background:#fff;color:#6b7280;cursor:pointer;transition:all .2s;position:relative;font:inherit;line-height:0}.cdp-addr-edit-btn:hover,.cdp-addr-edit-btn:focus-visible{border-color:#e02f8a;color:#e02f8a;background:#fffafb;outline:none}.cdp-addr-edit-icon{width:16px;height:16px;stroke:currentColor;fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;display:block;pointer-events:none}.cdp-addr-edit-btn::after{content:attr(title);position:absolute;bottom:calc(100% + 8px);right:0;background:#111827;color:#fff;font-size:11px;font-weight:500;line-height:1.3;padding:5px 8px;border-radius:6px;white-space:nowrap;opacity:0;visibility:hidden;transform:translateY(4px);transition:opacity .15s,transform .15s,visibility .15s;pointer-events:none;z-index:20;box-shadow:0 4px 12px rgba(0,0,0,.15)}.cdp-addr-edit-btn:hover::after,.cdp-addr-edit-btn:focus-visible::after{opacity:1;visibility:visible;transform:translateY(0)}.cdp-addr-miss-note{margin:0;font-size:13px;color:#9ca3af;line-height:1.5;font-style:italic}.cdp-addr-miss-bill-note{margin:0;font-size:13px;color:#9ca3af;line-height:1.5;font-style:italic}.cdp-addr-line{margin:0;line-height:1.5}.cdp-addr-line--primary{font-size:14px;font-weight:500;color:#111827;margin-bottom:3px}.cdp-addr-line--secondary{font-size:13px;color:#6b7280;margin-bottom:2px}.cdp-addr-section p{margin:0 0 2px;color:#374151;font-size:14px;line-height:1.55}.cdp-addr-form-cols{display:grid;grid-template-columns:1fr 1fr;gap:28px;margin-top:4px}.cdp-addr-form-cols--one{grid-template-columns:1fr}.cdp-addr-form-col h3{margin:0 0 16px;font-size:15px;color:#111827;font-weight:600;padding-bottom:10px;border-bottom:2px solid #fce4f0}.cdp-addr-form-col{margin-bottom:4px}.cdp-addr-form-actions{margin-top:28px;padding-top:4px}.cdp-addr-modal--form .cdp-addr-btn{margin-top:0}.cdp-addr-grid{display:grid;grid-template-columns:1fr 1fr;gap:20px 16px;margin-top:4px}.cdp-addr-field{text-align:left;margin:0}.cdp-addr-field--full{grid-column:1/-1}.cdp-addr-field label{display:block;margin-bottom:8px;font-size:13px;color:#374151;font-weight:500}.cdp-addr-field input{width:100%;padding:11px 14px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;box-sizing:border-box;transition:border-color .2s,box-shadow .2s;background:#fff}.cdp-addr-field input::placeholder{color:#9ca3af}.cdp-addr-field input:focus{outline:none;border-color:#e02f8a;box-shadow:0 0 0 3px rgba(224,47,138,.1)}.cdp-addr-same{display:flex;align-items:center;gap:10px;margin:20px 0 8px;font-size:14px;color:#4b5563;cursor:pointer}.cdp-addr-same input{width:16px;height:16px;accent-color:#e02f8a}.cdp-addr-same-wrap{margin-top:6px}.cdp-addr-btn{width:100%;padding:14px 24px;font-size:15px;background:#e02f8a;color:#fff;border:none;border-radius:10px;cursor:pointer;font-weight:600;margin-top:0;transition:background .2s,box-shadow .2s,transform .1s;box-shadow:0 2px 8px rgba(224,47,138,.22)}.cdp-addr-btn:hover{background:#c9287a;box-shadow:0 4px 14px rgba(224,47,138,.28)}.cdp-addr-btn:active{transform:translateY(1px)}.cdp-addr-btn:disabled{opacity:.6;cursor:not-allowed;transform:none;box-shadow:none}.cdp-addr-err{display:none;margin:0 0 16px;padding:12px 14px;border-radius:8px;background:#fef2f2;border:1px solid #fecaca;color:#b91c1c;font-size:13px;line-height:1.45}.cdp-addr-link{display:inline-flex;align-items:center;gap:4px;background:none;border:none;color:#e02f8a;font-weight:600;font-size:14px;cursor:pointer;padding:8px 4px;text-align:center;transition:opacity .2s}.cdp-addr-link:hover{opacity:.85;text-decoration:underline}.cdp-addr-reservation-tag{margin:0 0 12px;padding-bottom:10px;border-bottom:1px dashed #f0b8d4;font-size:13px;color:#374151;line-height:1.45}.cdp-addr-reservation-tag strong{font-weight:600;color:#111827}.cdp-addr-reservation-tag span{color:#6b7280;font-weight:400}.cdp-addr-divider{display:flex;align-items:center;gap:12px;margin:22px 0 18px;color:#9ca3af;font-size:13px;font-weight:500}.cdp-addr-divider::before,.cdp-addr-divider::after{content:"";flex:1;height:1px;background:#e5e7eb}.cdp-addr-venue-picker{position:relative;margin-bottom:4px}.cdp-addr-venue-picker--active .cdp-addr-venue-dd{border-color:#e02f8a}.cdp-addr-venue-dd-wrap{position:relative;margin-bottom:14px}.cdp-addr-venue-dd-label{display:block;font-size:12px;font-weight:500;color:#6b7280;margin:0 0 8px;line-height:1.3}.cdp-addr-venue-dd{width:100%;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 14px;border:1.5px solid #e5e7eb;border-radius:10px;background:#fafafa;cursor:pointer;font:inherit;text-align:left;transition:border-color .2s,background .2s,box-shadow .2s;min-height:58px;box-sizing:border-box}.cdp-addr-venue-dd:hover{border-color:#f0b8d4;background:#fff}.cdp-addr-venue-dd--open{border-color:#e02f8a;background:#fff;box-shadow:0 0 0 3px rgba(224,47,138,.1)}.cdp-addr-venue-dd-text{font-weight:600;color:#111827;flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px}.cdp-addr-venue-dd-meta{font-size:12px;color:#6b7280;font-weight:400;margin-top:4px;line-height:1.35}.cdp-addr-venue-dd-left{flex:1;min-width:0}.cdp-addr-venue-dd-chevron{flex-shrink:0;width:34px;height:34px;display:flex;align-items:center;justify-content:center;background:#fff;border:1px solid #f0b8d4;border-radius:8px;color:#e02f8a;font-size:11px;transition:transform .2s,background .2s,color .2s,border-color .2s}.cdp-addr-venue-dd--open .cdp-addr-venue-dd-chevron{transform:rotate(180deg);background:#e02f8a;color:#fff;border-color:#e02f8a}.cdp-addr-venue-dd-menu{position:absolute;top:calc(100% + 6px);left:0;right:0;z-index:10;background:#fff;border:1px solid #e8e8e8;border-radius:12px;box-shadow:0 12px 32px rgba(0,0,0,.14);max-height:280px;overflow:auto;padding:6px}.cdp-addr-venue-dd-item{display:flex;flex-direction:row;align-items:center;gap:12px;width:100%;padding:11px 12px;border:none;background:transparent;border-radius:8px;cursor:pointer;text-align:left;font:inherit;transition:background .15s}.cdp-addr-venue-dd-item:hover{background:#fff5fa}.cdp-addr-venue-dd-item--on{background:#fff5fa;box-shadow:inset 0 0 0 1px #f0b8d4}.cdp-addr-venue-dd-item-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.cdp-addr-venue-dd-item-title{font-size:14px;font-weight:600;color:#111827;line-height:1.35}.cdp-addr-venue-dd-item-date{font-size:12px;color:#6b7280;line-height:1.35}.cdp-addr-venue-dd-item-check{flex-shrink:0;width:22px;height:22px;border-radius:50%;border:2px solid #e5e7eb;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:transparent;line-height:1}.cdp-addr-venue-dd-item--on .cdp-addr-venue-dd-item-check{border-color:#e02f8a;background:#e02f8a;color:#fff}.cdp-addr-venue-single-head{padding:12px 14px;background:#fafafa;border-radius:10px;border:1px solid #f0f0f0;margin-bottom:14px}.cdp-addr-venue-panel{border:1.5px solid #e5e7eb;border-radius:12px;padding:14px;background:#fff;transition:border-color .2s,box-shadow .2s,background .2s;width:100%;box-sizing:border-box;display:flex;flex-direction:column;flex:1;box-shadow:0 1px 4px rgba(0,0,0,.04)}.cdp-addr-venue-panel--active{border-color:#e02f8a;background:#fffafb;box-shadow:0 0 0 3px rgba(224,47,138,.08)}.cdp-addr-split .cdp-addr-divider{display:none}.cdp-addr-venue-panel .cdp-addr-venue-detail{margin-top:0;padding-top:14px;border-top:1px solid #f3f4f6;flex:1}.cdp-addr-split .cdp-addr-venue-panel .cdp-addr-venue-detail{border-color:#fce4f0}.cdp-addr-venue-panel--active .cdp-addr-venue-detail{border-color:#fce4f0}.cdp-addr-venue-panel .cdp-addr-reservation-tag{display:none}.cdp-addr-venue-picker--active .cdp-addr-venue-dd{border-color:#e02f8a;background:#fff5fa}@media(max-width:720px){.cdp-addr-overlay{align-items:flex-end;padding:0}.cdp-addr-overlay--form{align-items:center;justify-content:center;padding:16px}.cdp-addr-overlay--form .cdp-addr-modal{width:min(540px,100%);max-height:min(90vh,900px);border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,.18)}.cdp-addr-overlay--form .cdp-addr-modal::before{display:none}.cdp-addr-modal{width:100%;max-height:94vh;border-radius:20px 20px 0 0;box-shadow:0 -8px 40px rgba(0,0,0,.2)}.cdp-addr-modal::before{content:"";display:block;width:36px;height:4px;background:#d1d5db;border-radius:999px;margin:10px auto 4px;flex-shrink:0}.cdp-addr-modal--form,.cdp-addr-modal--venue,.cdp-addr-modal--venues{width:100%;max-width:100%}.cdp-addr-modal-inner{padding:20px 18px 24px;padding-bottom:max(24px,env(safe-area-inset-bottom,0px))}.cdp-addr-header-text{padding-right:40px}.cdp-addr-modal h2{font-size:20px}.cdp-addr-sub{font-size:13px;max-width:none}.cdp-addr-body{margin:12px 0 0}.cdp-addr-split{flex-direction:column;gap:20px}.cdp-addr-split-divider{width:100%;height:1px;min-height:1px;margin:0}.cdp-addr-col--saved,.cdp-addr-col--venue{padding:0}.cdp-addr-modal-footer{margin-top:16px;padding-top:16px;position:sticky;bottom:0;background:#fff;z-index:2;border-top:1px solid #f0f0f0;padding-bottom:max(4px,env(safe-area-inset-bottom,0px))}.cdp-addr-btn{padding:15px 20px;font-size:16px}.cdp-addr-close{top:10px;right:10px}.cdp-addr-venue-dd{min-height:52px;padding:11px 12px}.cdp-addr-card-toolbar{padding:10px 12px}.cdp-addr-card-body{padding:12px}.cdp-addr-select-card{border-radius:10px}.cdp-addr-venue-panel{padding:12px}.cdp-addr-edit-btn::after{display:none}}@media(max-width:600px){.cdp-addr-form-cols{grid-template-columns:1fr;gap:24px}.cdp-addr-grid{grid-template-columns:1fr;gap:18px}.cdp-addr-form-actions{margin-top:24px}.cdp-addr-section-head{flex-direction:column;align-items:stretch;gap:8px}.cdp-addr-add-billing-btn,.cdp-addr-add-shipping-btn{width:100%;justify-content:center}.cdp-addr-saved-list--row{flex-direction:column}.cdp-addr-saved-list--row .cdp-addr-select-card{min-width:100%}.cdp-addr-col-head{margin-bottom:10px}.cdp-addr-divider{margin:16px 0}.cdp-addr-form-head{margin-bottom:8px}.cdp-addr-modal-inner{padding:18px 16px 22px}}';document.head.appendChild(s);}var API= 'https://ejuno.skylinxtech.co/api';function isServiceVendor(){return typeof vendorType!== 'undefined'&&vendorType=== 'Service';}function authHeaders(){var t=localStorage.getItem('authToken')||'';return{'Content-Type': 'application/json',Authorization:t.indexOf('Bearer ')===0?t: 'Bearer '+t};}function addrLines(a){if(!a)return['—'];return[a.address1,[a.city,a.province,a.zip].filter(Boolean).join(', '),a.country,a.contactNumber?'Phone: '+a.contactNumber:''].filter(Boolean);}function norm(a){if(!a)return null;return{address1:a.address1||'',city:a.city||'',country:a.country||'',province:a.province||'',zip:a.zip||'',contactNumber:a.contactNumber||''};}function fetchStatus(customerId){return fetch(API+'/shopify/checkout/address-status?customerId='+encodeURIComponent(customerId),{method: 'GET',headers:authHeaders()}).then(function(r){return r.json();});}function isStandaloneAddon(){return!!(window.requestData&&window.requestData._standaloneAddon);}function getProductVenueShipping(){var pd=window.productDetails||(typeof productDetails!=='undefined'?productDetails:null)||{};return venueToShipping(pd.venueLocation||pd.location||null);}function hasRequired(d){if(!d)return false;if(d.reservationMeta)return!!(norm(d.shippingAddress)&&norm(d.shippingAddress).address1&&hasBillingAddr(d.billingAddress));if(isServiceVendor())return!!(norm(d.shippingAddress)&&norm(d.shippingAddress).address1&&hasBillingAddr(d.billingAddress));return hasBillingAddr(d.billingAddress);}function hasBillingAddr(a){var b=norm(a);return!!(b&&b.address1);}function hasShippingAddr(a){var s=norm(a);return!!(s&&s.address1);}function hasProfileAddressesSaved(payload){if(!payload)return false;if(isServiceVendor())return payload.shippingAvailable===true&&payload.billingAvailable===true;return payload.billingAvailable===true;}function mustSaveNewAddress(payload,billingOnly,shippingOnly){return false;}function escHtml(t){return String(t||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g, '&quot;'); } function stripContact(a) { if (!a) return a; var o = { address1: a.address1 || '', city: a.city || '', country: a.country || '', province: a.province || '', zip: a.zip || '' }; return o; } function addrEqual(a, b) { a = stripContact(norm(a)); b = stripContact(norm(b)); return a && b && a.address1 === b.address1 && a.city === b.city && a.country === b.country && a.province === b.province && a.zip === b.zip; } function venueToShipping(venue) { if (!venue) return null; var address1 = venue.address || venue.address1 || ""; if (!address1) return null; return { address1: address1, city: venue.city || "", country: venue.country || "", province: venue.province || venue.region || "", zip: venue.zip || "" }; } function buildAddressOptions(payload) { var options = []; if (!payload) return options; var billing = payload.billingAddress || null; if (hasRequired(payload)) { if (isServiceVendor()) { options.push(toOption({ shippingAddress: payload.shippingAddress, billingAddress: billing, label: 'Saved address' })); } else { options.push(toOption({ shippingAddress: (isStandaloneAddon() ? getProductVenueShipping() : null), billingAddress: billing, label: 'Billing address' })); } } else if (billing) { options.push(toOption({ shippingAddress: (isStandaloneAddon() ? getProductVenueShipping() : null), billingAddress: billing, label: 'Billing address' })); } else if (isServiceVendor() && payload.shippingAvailable === true) { var savedShip = norm(payload.shippingAddress); if (savedShip && savedShip.address1) { options.push(toOption({ shippingAddress: payload.shippingAddress, billingAddress: null, label: 'Shipping Address/Place of Performance' })); } } if (isServiceVendor()) { (payload.reservationAddresses || []).forEach(function (res) { var ship = venueToShipping(res.venueLocation); if (!ship) return; var bill = res.billingAddress || billing || null; options.push(toOption({ shippingAddress: ship, billingAddress: bill, reservationMeta: { id: res.reservationId, type: res.reservationType, date: res.date, title: res.productTitle || 'Reservation' } })); }); } return options; } function field(id, label, ph, full) { return '<div class="cdp-addr-field' + (full ? ' cdp-addr-field--full' : '') + '"><label for="' + id + '">' + label + '</label><input id="' + id + '" type="text" placeholder="' + ph + '" required /></div>'; } function sectionFields(prefix, ph) { return '<div class="cdp-addr-grid">' + field(prefix + '-address1', ' Street address', ph.a, true) + field(prefix + '-city', ' City', ph.c, false) + field(prefix + '-province', ' State / province', ph.p, false) + field(prefix + '-zip', ' ZIP / postal code', ph.z, false) + field(prefix + '-country', ' Country', ph.co, false) + '</div>'; } function addrBlockHtml(a) { var n = norm(a); if (!n || !n.address1) return ''; return '<p class="cdp-addr-line cdp-addr-line--primary">' + escHtml(n.address1) + '</p><p class="cdp-addr-line cdp-addr-line--secondary">' + escHtml([n.city, n.province, n.zip].filter(Boolean).join(', ')) + '</p><p class="cdp-addr-line cdp-addr-line--secondary">' + escHtml(n.country) + '</p>'; } function addressDetailBlock(d) { var html = ""; if (d.reservationMeta) { html += '<div class="cdp-addr-reservation-tag"><strong>' + escHtml(d.reservationMeta.title) + '</strong>'; if (d.reservationMeta.date) html += '<span>&middot; ' + escHtml(d.reservationMeta.date) + '</span>'; html += '</div>'; } else if (d.label) { html += '<div class="cdp-addr-reservation-tag"><strong>' + escHtml(d.label) + '</strong></div>'; } var showShip = isServiceVendor() && (d.reservationMeta || d.shippingAddress); if (showShip) { html += '<div class="cdp-addr-section"><h4>' + (d.reservationMeta ? 'Venue location' : 'Shipping Address/Place of Performance') + '</h4>'; html += hasShippingAddr(d.shippingAddress) ? addrBlockHtml(d.shippingAddress) : '<p class="cdp-addr-miss-note">Not provided</p>'; html += '</div>'; } html += '<div class="cdp-addr-section"><h4>Billing address</h4>'; html += hasBillingAddr(d.billingAddress) ? addrBlockHtml(d.billingAddress) : '<p class="cdp-addr-miss-note">Not provided</p>'; html += '</div>'; return html; } function addressSectionsOnly(d) { var html = ""; var standaloneVenueShip = isStandaloneAddon() ? getProductVenueShipping() : null; if (standaloneVenueShip && hasShippingAddr(standaloneVenueShip)) { html += '<div class="cdp-addr-section cdp-addr-section--venue-ship"><div class="cdp-addr-section-head"><h4>Shipping address</h4><span class="cdp-addr-locked-note">Venue</span></div>' + addrBlockHtml(standaloneVenueShip) + '</div>'; } var showShip = !standaloneVenueShip && isServiceVendor() && (d.reservationMeta || hasBillingAddr(d.billingAddress) || hasShippingAddr(d.shippingAddress)); if (showShip) { var missShip = isServiceVendor() && !d.reservationMeta && !hasShippingAddr(d.shippingAddress); html += '<div class="cdp-addr-section' + (missShip ? ' cdp-addr-section--miss-ship' : '') + '"><div class="cdp-addr-section-head"><h4>' + (d.reservationMeta ? 'Venue location' : 'Shipping Address/Place of Performance') + '</h4>'; if (missShip) html += '<button type="button" class="cdp-addr-add-shipping-btn">Add Shipping Address/Place of Performance</button>'; html += '</div>'; if (hasShippingAddr(d.shippingAddress)) { html += addrBlockHtml(d.shippingAddress); } else if (!missShip) { html += '<p class="cdp-addr-miss-note">Not provided</p>'; } else { html += '<p class="cdp-addr-miss-note">Required to complete your booking.</p>'; } html += '</div>'; } var billingOnly = !isServiceVendor() && !d.reservationMeta; if (billingOnly) { var missBillVenue = !hasBillingAddr(d.billingAddress); html += '<div class="cdp-addr-section' + (missBillVenue ? ' cdp-addr-section--miss-bill' : '') + '"><div class="cdp-addr-section-head"><h4>Billing address</h4>'; if (missBillVenue) html += '<button type="button" class="cdp-addr-add-billing-btn">Add billing address</button>'; html += '</div>'; if (hasBillingAddr(d.billingAddress)) { html += addrBlockHtml(d.billingAddress); } else { html += '<p class="cdp-addr-miss-note">Required to complete your booking.</p>'; } html += '</div>'; } else { var missBill = !hasBillingAddr(d.billingAddress); html += '<div class="cdp-addr-section' + (missBill ? ' cdp-addr-section--miss-bill' : '') + '"><div class="cdp-addr-section-head"><h4>Billing address</h4>'; if (missBill) html += '<button type="button" class="cdp-addr-add-billing-btn">Add billing address</button>'; html += '</div>'; if (hasBillingAddr(d.billingAddress)) { html += addrBlockHtml(d.billingAddress); } else if (!missBill) { html += '<p class="cdp-addr-miss-note">Not provided</p>'; } else { html += '<p class="cdp-addr-miss-note">Required to complete your booking.</p>'; } html += '</div>'; } return html; } function comboBlock(d, selected) { return '<div class="cdp-addr-combo' + (selected ? ' cdp-addr-combo--on' : '') + '">' + addressDetailBlock(d) + '</div>'; } function toOption(d) { return { shippingAddress: d.shippingAddress, billingAddress: d.billingAddress, label: d.label || null, reservationMeta: d.reservationMeta || null }; } function editAddressBtn(idx) { return '<button type="button" class="cdp-addr-edit-btn" data-edit-idx="' + idx + '" aria-label="Edit address" title="Edit address"><svg class="cdp-addr-edit-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></button>'; } function showFormPopup(customerId, onSaved, onBack, prefill, directContinue, billingOnly, shippingOnly) { var service = isServiceVendor(); var dualAddress = service; directContinue = !!directContinue; billingOnly = !!billingOnly; shippingOnly = !!shippingOnly; var serviceBillingOnly = service && billingOnly; var serviceShippingOnly = service && shippingOnly; var isEdit = !!prefill && !directContinue && !serviceBillingOnly && !serviceShippingOnly; var popup = document.createElement('div'); popup.className = 'cdp-addr-overlay cdp-addr-overlay--form'; var shipPh = { a: 'e.g. 123 Main Street', c: 'e.g. New York', p: 'e.g. NY', z: 'e.g. 10001', co: 'e.g. United States' }; var billPh = { a: 'e.g. 123 Main Street', c: 'e.g. New York', p: 'e.g. NY', z: 'e.g. 10001', co: 'e.g. United States' }; var backBtn = onBack ? '<button type="button" id="cdpFormBack" class="cdp-addr-back">&#8592; Back</button>' : '<span></span>'; var title = false ? 'Enter your <span class="cdp-addr-accent">shipping &amp; billing addresses</span>' : (isEdit ? (service ? ' Edit your <span class="cdp-addr-accent">addresses</span>' : 'Edit billing <span class="cdp-addr-accent">address</span>') : (serviceShippingOnly ? 'Add shipping <span class="cdp-addr-accent">address</span>' : (serviceBillingOnly ? 'Add billing <span class="cdp-addr-accent">address</span>' : (service ? 'Enter your <span class="cdp-addr-accent">addresses</span>' : 'Enter billing <span class="cdp-addr-accent">address</span>')))); var sub = false ? 'Enter your shipping and billing details to proceed with your add-on booking.' : (serviceShippingOnly ? 'Provide a shipping address for this reservation.' : (serviceBillingOnly ? 'Provide a billing address for this reservation.' : (isEdit ? 'Update your details below, then continue with your reservation.' : (service ? 'Enter your shipping and billing details to proceed.' : (isStandaloneAddon() ? 'Shipping uses the venue address shown below. Enter your billing address to proceed.' : 'Enter your billing address to proceed.'))))); var body = '<div class="cdp-addr-modal cdp-addr-modal--form' + (dualAddress && !billingOnly && !shippingOnly ? '' : 'cdp-addr-modal--venue') + '"><button type="button" class="cdp-addr-close" id="cdpFormClose" aria-label="Close">&times;</button><div class="cdp-addr-modal-inner"><div class="cdp-addr-form-head">' + backBtn + '</div><div class="cdp-addr-header-text"><h2>' + title + '</h2><p class="cdp-addr-sub">' + sub + '</p></div><div id="cdpAddrErr" class="cdp-addr-err"></div>'; if (dualAddress && !billingOnly && !shippingOnly) { body += '<div class="cdp-addr-form-cols cdp-addr-form-cols--one" id="cdpFormCols"><div class="cdp-addr-form-col" id="ship-col"><h3>Shipping Address/Place of Performance</h3>' + sectionFields('ship', shipPh) + '</div><div class="cdp-addr-form-col" id="bill-col" style="display:none"><h3>Billing address</h3>' + sectionFields('bill', billPh) + '</div></div><label class="cdp-addr-same cdp-addr-same-wrap"><input type="checkbox" id="billing-same-as-shipping" checked /> Billing address same as shipping</label>'; } else if (serviceShippingOnly) { body += '<div class="cdp-addr-form-col"><h3>Shipping Address/Place of Performance</h3>' + sectionFields('ship', shipPh) + '</div>'; } else { if (isStandaloneAddon()) { var _vs = getProductVenueShipping(); if (_vs && hasShippingAddr(_vs)) { body += '<div class="cdp-addr-section cdp-addr-section--venue-ship"><div class="cdp-addr-section-head"><h4>Shipping address</h4><span class="cdp-addr-locked-note">Venue</span></div>' + addrBlockHtml(_vs) + '<p class="cdp-addr-miss-note">Ships to the venue automatically - only billing is editable below.</p></div>'; } } body += '<div class="cdp-addr-form-col"><h3>Billing address</h3>' + sectionFields('bill', billPh) + '</div>'; } body += '<div class="cdp-addr-form-actions"><button type="button" id="cdpAddrSubmit" class="cdp-addr-btn">' + (onBack ? (serviceShippingOnly ? 'Add shipping address' : (serviceBillingOnly ? 'Add billing address' : 'Continue to Reservation')) : 'Continue to Reservation') + '</button></div></div></div>'; popup.innerHTML = body; document.body.appendChild(popup); var errEl = popup.querySelector('#cdpAddrErr'); var close = function () { popup.remove(); }; function fillPrefix(prefix, a) { if (!a) return; var map = { address1: prefix + '-address1', city: prefix + '-city', country: prefix + '-country', province: prefix + '-province', zip: prefix + '-zip' }; Object.keys(map).forEach(function (k) { var el = popup.querySelector('#' + map[k]); if (el) el.value = a[k] || ''; }); } if (prefill) { if (dualAddress && !billingOnly && !shippingOnly) { fillPrefix('ship', prefill.shipping); var sameCb = popup.querySelector('#billing-same-as-shipping'); var formCols = popup.querySelector('#cdpFormCols'); var billCol = popup.querySelector('#bill-col'); var same = addrEqual(prefill.shipping, prefill.billing); if (sameCb) { sameCb.checked = same; if (same) { formCols.classList.add('cdp-addr-form-cols--one'); billCol.style.display = 'none'; } else { formCols.classList.remove('cdp-addr-form-cols--one'); billCol.style.display = 'block'; fillPrefix('bill', prefill.billing); } } } else if (serviceShippingOnly) { fillPrefix('ship', prefill.shipping); } else { fillPrefix('bill', prefill.billing); } } if (onBack) popup.querySelector('#cdpFormBack').onclick = function () { close(); onBack(); }; popup.querySelector('#cdpFormClose').onclick = close; popup.onclick = function (e) { if (e.target === popup) { if (onBack) onBack(); close(); } }; if (dualAddress && !billingOnly && !shippingOnly) { var formCols = popup.querySelector('#cdpFormCols'); var billCol = popup.querySelector('#bill-col'); var sameCb = popup.querySelector('#billing-same-as-shipping'); sameCb.onchange = function () { if (sameCb.checked) { formCols.classList.add('cdp-addr-form-cols--one'); billCol.style.display = 'none'; } else { formCols.classList.remove('cdp-addr-form-cols--one'); billCol.style.display = 'block'; } }; } var read = function (p) { return stripContact({ address1: popup.querySelector('#' + p + '-address1').value.trim(), city: popup.querySelector('#' + p + '-city').value.trim(), country: popup.querySelector('#' + p + '-country').value.trim(), province: popup.querySelector('#' + p + '-province').value.trim(), zip: popup.querySelector('#' + p + '-zip').value.trim() }); }; popup.querySelector('#cdpAddrSubmit').onclick = function () { errEl.style.display = 'none'; var keys = [' address1', ' city', ' country', ' province', ' zip']; var shipping_address, billing_address; if (serviceShippingOnly) { shipping_address = read('ship'); if (cdpAddrValidateFields(popup, errEl, keys.map(function (k) { return 'ship-' + k; }))) return; billing_address = prefill && prefill.billing ? stripContact(norm(prefill.billing)) : null; } else if (serviceBillingOnly) { billing_address = read('bill'); if (cdpAddrValidateFields(popup, errEl, keys.map(function (k) { return 'bill-' + k; }))) return; shipping_address = prefill && prefill.shipping ? stripContact(norm(prefill.shipping)) : null; } else if (dualAddress) { var sameCb = popup.querySelector('#billing-same-as-shipping'); shipping_address = read('ship'); billing_address = sameCb.checked ? Object.assign({}, shipping_address) : read('bill'); if (cdpAddrValidateFields(popup, errEl, keys.map(function (k) { return 'ship-' + k; }).concat(sameCb.checked ? [] : keys.map(function (k) { return 'bill-' + k; })))) return; } else { billing_address = read('bill'); if (cdpAddrValidateFields(popup, errEl, keys.map(function (k) { return 'bill-' + k; }))) return; } close(); onSaved({ shippingAddress: dualAddress ? shipping_address : (isStandaloneAddon() ? getProductVenueShipping() : null), billingAddress: billing_address }); }; } function showConfirmPopup(options, customerId, onSelect, addrStatus) { addrStatus = addrStatus || {}; var venueIndices = []; var savedIndices = []; options.forEach(function (o, i) { if (o.reservationMeta) venueIndices.push(i); else savedIndices.push(i); }); var state = { options: options.slice(), activeType: savedIndices.length ? 'saved' : 'venue', selected: savedIndices.length ? savedIndices[0] : (venueIndices[0] || 0), venueListIdx: 0, venueOpen: false, venueIndices: venueIndices, savedIndices: savedIndices }; var service = isServiceVendor(); var hasVenueOpts = service && venueIndices.length > 0; var hasReservationOpts = hasVenueOpts || savedIndices.length > 1; var partialShipOnly = false; var partialBillOnly = false; if (service && savedIndices.length > 0 && !hasVenueOpts) { var soleOpt = state.options[savedIndices[0]]; var soleShip = norm(soleOpt && soleOpt.shippingAddress); var soleBill = norm(soleOpt && soleOpt.billingAddress); partialShipOnly = !!(soleShip && soleShip.address1 && !hasBillingAddr(soleOpt.billingAddress)); partialBillOnly = !!(soleBill && soleBill.address1 && !hasShippingAddr(soleOpt.shippingAddress)); } var confirmTitle = service ? ' Select a <span class="cdp-addr-accent">service delivery address</span>' : (typeof isStandaloneAddon === 'function' && isStandaloneAddon() ? 'Review shipping &amp; billing <span class="cdp-addr-accent">address</span>' : 'Review billing <span class="cdp-addr-accent">address</span>'); var confirmSub = partialShipOnly ? 'Your shipping address is on file. Add a billing address to continue.' : (partialBillOnly ? 'Your billing address is on file. Add a shipping address to continue.' : (service ? 'Choose a saved address, a reserved venue address, or add a new address for the delivery of your service.' : (typeof isStandaloneAddon === 'function' && isStandaloneAddon() ? 'Confirm your billing address. Shipping uses the venue address automatically.' : (savedIndices.length ? 'Confirm your billing address before continuing.' : 'Add your billing address to continue.')))); var popup = document.createElement('div'); popup.className = 'cdp-addr-overlay'; var modalClass = hasVenueOpts || savedIndices.length > 1 ? ' cdp-addr-modal--venues' : 'cdp-addr-modal--venue'; popup.innerHTML = '<div class="cdp-addr-modal' + modalClass + '"><button type="button" class="cdp-addr-close" id="cdpAddrClose" aria-label="Close">&times;</button><div class="cdp-addr-modal-inner"><div class="cdp-addr-header"><div class="cdp-addr-header-text"><h2>' + confirmTitle + '</h2><p class="cdp-addr-sub">' + confirmSub + '</p></div></div><div id="cdpAddrBody" class="cdp-addr-body"></div><div class="cdp-addr-modal-footer"><button type="button" id="cdpAddrAddNew" class="cdp-addr-link">Use a different address</button><button type="button" id="cdpAddrConfirm" class="cdp-addr-btn">Continue with reservation</button></div></div></div>'; document.body.appendChild(popup); var bodyEl = popup.querySelector('#cdpAddrBody'); var close = function () { popup.remove(); }; function getPicked() { if (state.activeType === 'venue' && state.venueIndices.length) return state.options[state.venueIndices[state.venueListIdx]]; return state.options[state.selected]; } function openEdit(idx) { var opt = state.options[idx]; showFormPopup(customerId, function (updated) { var newOpt = toOption(updated); if (opt.reservationMeta) newOpt.reservationMeta = opt.reservationMeta; else if (opt.label) newOpt.label = opt.label; state.options[idx] = newOpt; if (opt.reservationMeta) { state.activeType = 'venue'; state.venueListIdx = state.venueIndices.indexOf(idx); if (state.venueListIdx < 0) state.venueListIdx = 0; } else { state.activeType = 'saved'; state.selected = idx; } state.venueOpen = false; paint(); }, function () { paint(); }, { shipping: (opt.reservationMeta || isServiceVendor()) ? opt.shippingAddress : null, billing: opt.billingAddress }, true); } function openForm() { showFormPopup(customerId, function (updated) { if (typeof showLoaderFull === 'function') showLoaderFull(); close(); onSelect(isStandaloneAddon() ? (getProductVenueShipping() || norm(updated.shippingAddress)) : norm(updated.shippingAddress), norm(updated.billingAddress), null); }, function () { paint(); }, null, true); } function openAddBilling() { var picked = getPicked(); if (!picked || hasBillingAddr(picked.billingAddress)) return; showFormPopup(customerId, function (updated) { var idx = picked.reservationMeta ? state.venueIndices[state.venueListIdx] : state.selected; var newOpt = toOption({ shippingAddress: picked.shippingAddress, billingAddress: updated.billingAddress, reservationMeta: picked.reservationMeta, label: picked.label }); state.options[idx] = newOpt; if (picked.reservationMeta) { state.activeType = 'venue'; } else { state.activeType = 'saved'; state.selected = idx; } paint(); }, function () { paint(); }, { shipping: picked.shippingAddress, billing: null }, true, true); } function openAddShipping() { var picked = getPicked(); if (!picked || !isServiceVendor() || hasShippingAddr(picked.shippingAddress) || picked.reservationMeta) return; showFormPopup(customerId, function (updated) { var idx = state.selected; var newOpt = toOption({ shippingAddress: updated.shippingAddress, billingAddress: picked.billingAddress, label: picked.label }); state.options[idx] = newOpt; state.activeType = 'saved'; state.selected = idx; paint(); }, function () { paint(); }, { shipping: null, billing: picked.billingAddress }, true, false, true); } function paint() { var html = ''; var hasSaved = state.savedIndices.length > 0; var hasVenue = isServiceVendor() && state.venueIndices.length > 0; var split = hasSaved && hasVenue; if (split) html += '<div class="cdp-addr-split">'; if (hasSaved) { if (split) html += '<div class="cdp-addr-col cdp-addr-col--saved">'; html += '<div class="cdp-addr-col-head"><h3 class="cdp-addr-col-title">' + (isServiceVendor() ? (state.savedIndices.length > 1 ? 'Your saved addresses' : 'Your saved address') : 'Billing address') + '</h3>'; if (state.savedIndices.length > 1) html += '<span class="cdp-addr-col-badge">' + state.savedIndices.length + '</span>'; html += '</div>'; html += '<div class="cdp-addr-saved-list' + (state.savedIndices.length > 1 && !hasVenue ? ' cdp-addr-saved-list--row' : '') + '">'; state.savedIndices.forEach(function (i) { var opt = state.options[i]; var cardOn = state.activeType === 'saved' && state.selected === i; var cardLabel = opt.label; if (!isServiceVendor() && !opt.reservationMeta) { cardLabel = 'Billing address'; } else if (isServiceVendor() && !opt.reservationMeta) { if (!cardLabel || cardLabel === 'Saved address' || cardLabel === 'Saved billing address') { cardLabel = state.savedIndices.length > 1 ? ('Saved address ' + (state.savedIndices.indexOf(i) + 1)) : 'Saved address'; } else if (cardLabel === 'Billing address' && hasShippingAddr(opt.shippingAddress)) { cardLabel = state.savedIndices.length > 1 ? ('Saved address ' + (state.savedIndices.indexOf(i) + 1)) : 'Saved address'; } else if (cardLabel === 'Shipping Address/Place of Performance' && !hasBillingAddr(opt.billingAddress)) { cardLabel = 'Shipping Address/Place of Performance'; } else if (cardLabel === 'Billing address' && !hasShippingAddr(opt.shippingAddress)) { cardLabel = 'Billing address'; } } html += '<div class="cdp-addr-select-card' + (cardOn ? ' cdp-addr-select-card--on' : '') + '" data-saved-card="' + i + '">'; html += '<div class="cdp-addr-card-toolbar"><span class="cdp-addr-card-badge">' + escHtml(cardLabel) + '</span>' + editAddressBtn(i) + '</div>'; html += '<div class="cdp-addr-card-body">' + addressSectionsOnly(opt) + '</div>'; html += '</div>'; }); html += '</div>'; if (split) html += '</div>'; } if (hasVenue) { if (split) html += '<div class="cdp-addr-split-divider" aria-hidden="true"></div><div class="cdp-addr-col cdp-addr-col--venue">'; else if (hasSaved) html += '<div class="cdp-addr-divider"><span>Or use a venue reservation</span></div>'; html += '<div class="cdp-addr-col-head"><h3 class="cdp-addr-col-title">Venue reservations</h3>'; if (state.venueIndices.length > 1) html += '<span class="cdp-addr-col-badge">' + state.venueIndices.length + ' available</span>'; html += '</div>'; var vi = state.venueIndices[state.venueListIdx] || state.venueIndices[0]; var vopt = state.options[vi]; var meta = vopt.reservationMeta || {}; var pickerActive = state.activeType === 'venue'; var shipPrev = norm(vopt.shippingAddress); var locPrev = shipPrev ? [shipPrev.city, shipPrev.country].filter(Boolean).join(', ') : ''; var metaLine = [meta.date, locPrev].filter(Boolean).join(' · '); html += '<div class="cdp-addr-venue-panel cdp-addr-venue-picker' + (pickerActive ? 'cdp-addr-venue-panel--active cdp-addr-venue-picker--active' : '') + '">'; if (state.venueIndices.length > 1) { html += '<div class="cdp-addr-venue-dd-wrap"><label class="cdp-addr-venue-dd-label" id="cdpVenueDdLabel">Select reservation</label>'; html += '<button type="button" class="cdp-addr-venue-dd' + (state.venueOpen ? ' cdp-addr-venue-dd--open' : '') + '" id="cdpVenueDd" aria-expanded="' + (state.venueOpen ? 'true' : 'false') + '" aria-labelledby="cdpVenueDdLabel">'; html += '<div class="cdp-addr-venue-dd-left"><div class="cdp-addr-venue-dd-text">' + escHtml(meta.title || 'Choose a reservation') + '</div>'; if (metaLine) html += '<div class="cdp-addr-venue-dd-meta">' + escHtml(metaLine) + '</div>'; html += '</div><span class="cdp-addr-venue-dd-chevron" aria-hidden="true">&#9662;</span></button>'; if (state.venueOpen) { html += '<div class="cdp-addr-venue-dd-menu" id="cdpVenueMenu" role="listbox">'; state.venueIndices.forEach(function (idx, li) { var vo = state.options[idx]; var vm = vo.reservationMeta || {}; var sp = norm(vo.shippingAddress); var loc = sp ? [sp.city, sp.country].filter(Boolean).join(', ') : ''; var itemMeta = [vm.date, loc].filter(Boolean).join(' · '); html += '<button type="button" role="option" aria-selected="' + (state.venueListIdx === li ? 'true' : 'false') + '" class="cdp-addr-venue-dd-item' + (state.venueListIdx === li ? ' cdp-addr-venue-dd-item--on' : '') + '" data-venue-idx="' + li + '">'; html += '<div class="cdp-addr-venue-dd-item-main"><span class="cdp-addr-venue-dd-item-title">' + escHtml(vm.title || ' Venue') + '</span>'; if (itemMeta) html += '<span class="cdp-addr-venue-dd-item-date">' + escHtml(itemMeta) + '</span>'; html += '</div><span class="cdp-addr-venue-dd-item-check" aria-hidden="true">' + (state.venueListIdx === li ? '&#10003;' : '') + '</span></button>'; }); html += '</div>'; } html += '</div>'; } else { html += '<div class="cdp-addr-venue-single-head"><div class="cdp-addr-venue-dd-text">' + escHtml(meta.title || 'Venue reservation') + '</div>'; if (metaLine) html += '<div class="cdp-addr-venue-dd-meta">' + escHtml(metaLine) + '</div>'; html += '</div>'; } html += '<div class="cdp-addr-venue-detail">' + addressSectionsOnly(vopt) + '</div></div>'; if (split) html += '</div>'; } if (split) html += '</div>'; bodyEl.innerHTML = html; var dd = bodyEl.querySelector('#cdpVenueDd'); if (dd) dd.onclick = function (e) { e.stopPropagation(); state.activeType = 'venue'; state.venueOpen = !state.venueOpen; paint(); }; bodyEl.querySelectorAll('[data-venue-idx]').forEach(function (el) { el.onclick = function (e) { e.stopPropagation(); state.activeType = 'venue'; state.venueListIdx = parseInt(el.getAttribute('data-venue-idx'), 10); state.venueOpen = false; paint(); }; }); bodyEl.querySelectorAll('[data-edit-idx]').forEach(function (el) { el.onclick = function (e) { e.stopPropagation(); openEdit(parseInt(el.getAttribute('data-edit-idx'), 10)); }; }); bodyEl.querySelectorAll('.cdp-addr-add-billing-btn').forEach(function (el) { el.onclick = function (e) { e.stopPropagation(); openAddBilling(); }; }); bodyEl.querySelectorAll('.cdp-addr-add-shipping-btn').forEach(function (el) { el.onclick = function (e) { e.stopPropagation(); openAddShipping(); }; }); bodyEl.querySelectorAll('[data-saved-card]').forEach(function (el) { el.onclick = function (e) { if (e.target.closest('.cdp-addr-edit-btn') || e.target.closest('.cdp-addr-add-billing-btn') || e.target.closest('.cdp-addr-add-shipping-btn')) return; state.activeType = 'saved'; state.selected = parseInt(el.getAttribute('data-saved-card'), 10); state.venueOpen = false; paint(); }; }); bodyEl.querySelectorAll('.cdp-addr-venue-panel').forEach(function (el) { el.addEventListener(' click', function (e) { if (e.target.closest('.cdp-addr-venue-dd') || e.target.closest('.cdp-addr-venue-dd-menu') || e.target.closest('.cdp-addr-edit-btn') || e.target.closest('.cdp-addr-add-billing-btn') || e.target.closest('.cdp-addr-add-shipping-btn')) return; state.activeType = 'venue'; state.venueOpen = false; paint(); }); }); } popup.querySelector('#cdpAddrClose').onclick = close; popup.onclick = function (e) { if (e.target === popup) close(); if (state.venueOpen && !e.target.closest('.cdp-addr-venue-picker')) { state.venueOpen = false; paint(); } }; popup.querySelector('#cdpAddrAddNew').onclick = openForm; popup.querySelector('#cdpAddrConfirm').onclick = function () { var picked = getPicked(); if (!hasRequired(picked)) { if (isServiceVendor() && hasBillingAddr(picked.billingAddress) && !hasShippingAddr(picked.shippingAddress) && !picked.reservationMeta) { showFormPopup(customerId, function (updated) { if (typeof showLoaderFull === 'function') showLoaderFull(); close(); onSelect(norm(updated.shippingAddress), norm(picked.billingAddress), null); }, function () {}, { shipping: null, billing: picked.billingAddress }, true, false, true); return; } if (!hasBillingAddr(picked.billingAddress)) { var billOnlyForm = isServiceVendor() && (hasShippingAddr(picked.shippingAddress) || picked.reservationMeta); showFormPopup(customerId, function (updated) { if (typeof showLoaderFull === 'function') showLoaderFull(); close(); onSelect(norm(picked.shippingAddress), norm(updated.billingAddress), picked.reservationMeta || null); }, function () {}, { shipping: picked.shippingAddress, billing: picked.billingAddress }, true, billOnlyForm, false); return; } } if (typeof showLoaderFull === 'function') showLoaderFull(); close(); onSelect(norm(picked.shippingAddress), norm(picked.billingAddress), picked.reservationMeta || null); }; paint(); } function needsBothAddresses(requestData) { return !!(requestData && requestData._standaloneAddon) || isServiceVendor(); } function attachToRequest(requestData, shipping, billing) { if (requestData && requestData._standaloneAddon) { requestData.shippingAddress = getProductVenueShipping() || shipping || null; requestData.billingAddress = billing; return; } if (needsBothAddresses(requestData)) { requestData.shippingAddress = shipping; requestData.billingAddress = billing; } else { delete requestData.shippingAddress; requestData.billingAddress = billing; } } function applySelectedAddress(requestData, shipping, billing, meta) { if (meta) { requestData.shippingAddress = shipping; requestData.billingAddress = billing; requestData.reservationId = meta.id; return; } attachToRequest(requestData, shipping, billing); } window.ensureAddressBeforeReservation = function (requestData, onReady) { try { document.querySelectorAll('.cdp-standalone-modal').forEach(function(el){ el.remove(); }); document.body.style.overflow=''; } catch(e) {} var customerId = localStorage.getItem('customerId'); var authToken = localStorage.getItem('authToken'); if (!customerId || !authToken) { if (typeof showLoginPopups === 'function') showLoginPopups(requestData); return; } window.requestData = requestData || window.requestData; if (typeof showLoaderFull === 'function') showLoaderFull(); fetchStatus(customerId) .then(function (res) { if (typeof hideLoaderFull === 'function') hideLoaderFull(); var payload = res.status && res.data ? res.data : {}; var options = buildAddressOptions(payload); var standalone = !!(requestData && requestData._standaloneAddon); var venueShip = standalone ? getProductVenueShipping() : null; if (standalone && !venueShip) { if (typeof showNotification === 'function') showNotification('Venue address is missing for this product, so shipping cannot be set automatically.', 'error'); return; } var done = function (ship, bill, meta) { if (standalone) ship = venueShip || ship; applySelectedAddress(requestData, ship, bill, meta); if (typeof showLoaderFull === 'function') showLoaderFull(); onReady(); }; if (standalone && !hasRequired(payload)) { showFormPopup(customerId, function (updated) { if (typeof showLoaderFull === 'function') showLoaderFull(); done(venueShip, norm(updated.billingAddress)); }, null, { shipping: venueShip, billing: null }, true); return; } if (options.length) { showConfirmPopup(options, customerId, done, payload); } else { showFormPopup(customerId, function (updated) { if (typeof showLoaderFull === 'function') showLoaderFull(); done(standalone ? venueShip : norm(updated.shippingAddress), norm(updated.billingAddress)); }, null, standalone ? { shipping: venueShip, billing: null } : null, true); } }) .catch(function () { if (typeof hideLoaderFull === 'function') hideLoaderFull(); if (typeof showNotification === 'function') showNotification('We couldn\u2019t load your address details. Please try again.', 'error'); }); }; })();

/* --- showLoginPopups --- */
function showLoginPopups(requestData) {
let resendTimers = new Map();
const popup = document.createElement("div");
popup.className = "login-popup";
popup.style.cssText = `position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;z-index:99999;font-family:'Arial',sans-serif;`;
popup.innerHTML = `
<div class="login-modal"><button id="closePopup" class="close-btn cdp-modal-close" aria-label="Close">&times;</button><div class="tabs"><button class="tab-btn active" data-tab="coupleTab">Couple</button><button class="tab-btn" data-tab="guestTab">Guest</button></div>
${["coupleTab", "guestTab"].map(tab => `
<div id="${tab}" class="tab-content" style="${tab !=="coupleTab" ? "display:none" : ""}"><div class="login-header"><h2>Welcome</h2><p>Login to continue</p></div><div class="emailSection"><input type="email" class="loginEmail input" placeholder="Enter your email" /><button class="sendOtpBtn btn" style="margin-top:12px;">Send OTP</button><div class="msg sendMsg"></div></div><div class="otpSection" style="display:none;"><p style="font-size:13px;color:#666;text-align:center;">
Code sent to <br><span class="otpEmail" style="color:#e02f8a;font-weight:600;"></span></p><div class="otp-wrapper">
${[1,2,3,4,5,6].map(() => `<input class="otp-input" maxlength="1" />`).join("")}
</div><div class="msg otpMsg"></div><div class="resend">
Didn't receive?
<button class="resendOtpBtn" disabled>
Resend in <span class="countdown">30</span>s
</button></div><button class="verifyOtpBtn btn" style="margin-top:12px;">Verify</button><div class="msg verifyMsg"></div></div></div>
`).join("")}
</div>
`;
document.body.appendChild(popup);
popup.querySelector("#closePopup").onclick = () => {
resendTimers.forEach(t => clearInterval(t));
popup.remove();
};
popup.querySelectorAll(".tab-btn").forEach(btn => {
btn.onclick = () => {
popup.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
popup.querySelectorAll(".tab-content").forEach(t => t.style.display = "none");
btn.classList.add("active");
popup.querySelector(`#${btn.dataset.tab}`).style.display = "block";
};
});
popup.querySelectorAll(".tab-content").forEach(tab => {
let savedEmail = "";
const isGuest = tab.id === "guestTab";
const API_BASE = isGuest
? "https://ejuno.skylinxtech.co/api/guests"
: "https://ejuno.skylinxtech.co/api/couples";
const emailSection = tab.querySelector(".emailSection");
const otpSection = tab.querySelector(".otpSection");
const emailInput = tab.querySelector(".loginEmail");
const sendOtpBtn = tab.querySelector(".sendOtpBtn");
const verifyOtpBtn = tab.querySelector(".verifyOtpBtn");
const resendOtpBtn = tab.querySelector(".resendOtpBtn");
const countdown = tab.querySelector(".countdown");
const otpEmail = tab.querySelector(".otpEmail");
const otpInputs = tab.querySelectorAll(".otp-input");
const sendMsg = tab.querySelector(".sendMsg");
const verifyMsg = tab.querySelector(".verifyMsg");
function setMsg(el, type, text) {
el.style.display = "block";
el.className = `msg ${type}`;
el.textContent = text;
}
function startTimer() {
let time = 30;
resendOtpBtn.disabled = true;
countdown.textContent = time;
const timer = setInterval(() => {
time--;
countdown.textContent = time;
if (time <= 0) {
clearInterval(timer);
resendOtpBtn.disabled = false;
}
}, 1000);
resendTimers.set(tab, timer);
}
sendOtpBtn.onclick = async () => {
const email = emailInput.value.trim();
sendMsg.style.display = "none";
if (!email) return setMsg(sendMsg, "error", "Please enter email");
savedEmail = email;
try {
const res = await fetch(`${API_BASE}/send-login-otp`, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify({ contactEmail: email })
});
const data = await res.json();
if (!data.status) {
return setMsg(sendMsg, "error", data.message || "Failed to send OTP");
}
setMsg(sendMsg, "success", "OTP sent successfully");
emailSection.style.display = "none";
otpSection.style.display = "block";
otpEmail.textContent = email;
otpInputs.forEach(i => i.value = "");
otpInputs[0].focus();
startTimer();
} catch {
setMsg(sendMsg, "error", "Network error");
}
};
resendOtpBtn.onclick = () => sendOtpBtn.click();
async function verifyOTP() {
const otp = [...otpInputs].map(i => i.value).join("");
verifyMsg.style.display = "none";
if (otp.length !== 6) {
return setMsg(verifyMsg, "error", "Enter 6-digit OTP");
}
try {
const res = await fetch(`${API_BASE}/verify-login-otp`, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify({ contactEmail: savedEmail, otp })
});
const data = await res.json();
if (!data.status) {
otpInputs.forEach(i => i.value = "");
otpInputs[0].focus();
return setMsg(verifyMsg, "error", "Invalid OTP");
}
setMsg(verifyMsg, "success", "Login successful");
if (typeof window.persistCdpLoginSession === "function") {
window.persistCdpLoginSession(data);
} else {
const payload = data.data || {};
const user = payload.user || {};
const customerId = payload.customerId || user.customerId;
const authToken = payload.authToken || payload.token;
const contactEmail = payload.contactEmail || user.contactEmail;
const firstName = payload.firstName || user.firstName;
const lastName = payload.lastName || user.lastName;
const role = String(payload.role || user.role || "").toLowerCase();
if (customerId) localStorage.setItem("customerId", customerId);
if (authToken) localStorage.setItem("authToken", authToken);
if (contactEmail) localStorage.setItem("customerEmail", contactEmail);
if (firstName) localStorage.setItem("customerFirstName", firstName);
if (lastName) localStorage.setItem("customerLastName", lastName);
if (role) { localStorage.setItem("customerRole", role); localStorage.setItem("customerType", role === "guest" ? "guest" : "couple"); }
try { document.dispatchEvent(new CustomEvent("cdpAuthChanged")); } catch (e) {}
if (typeof window.syncCdpRegistryButtonVisibility === "function") window.syncCdpRegistryButtonVisibility();
}
setTimeout(() => {
popup.remove();
if (requestData) {
bookVenueOrService(requestData);
} else {
location.reload();
}
}, 1200);
} catch {
setMsg(verifyMsg, "error", "Network error");
}
}
otpInputs.forEach((input, i) => {
input.oninput = () => {
input.value = input.value.replace(/\D/g, "");
if (input.value && i < 5) {
otpInputs[i + 1].focus();
}
};
});
verifyOtpBtn.onclick = verifyOTP;
});
}
window.showLoginPopups = showLoginPopups;

/* --- showLoginPopupnew --- */
function showLoginPopupnew(requestData){let savedEmail="";const popup=document.createElement("div");popup.className="login-popup";popup.style.cssText= 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;z-index:99999;font-family:Arial,sans-serif;';popup.innerHTML=` <div style="background:#fff;padding:20px;border-radius:12px;width:380px;max-width:95%;text-align:center;position:relative;box-shadow:0 8px 30px rgba(0,0,0,0.2);animation:fadeInUp .3s ease;"><button id="closePopup" class="cdp-modal-close" aria-label="Close">&times;</button><h2 style="color:#e02f8a;margin-bottom:8px;">Welcome!</h2><p style="margin-bottom:20px;color:#555;">Sign in to your account</p><div id="emailSection"><label style="display:block;text-align:left;margin-bottom:6px;font-size:14px;color:#555;"><span style="color:#e02f8a;">✉</span> Email Address </label><input type="email" id="loginEmail" placeholder="Enter your email address" style="width:100%;padding:12px;border:1px solid #ddd;border-radius:6px;margin-bottom:16px;font-size:14px;" /><button id="sendOtpBtn" style="width:100%;padding:12px;font-size:15px;background:#e02f8a;color:#fff;border:none;border-radius:6px;cursor:pointer;transition:0.2s ease;">Send OTP →</button><p style="font-size:13px;color:#555;margin-top:20px;text-align:center;padding-top:16px;border-top:1px solid #eee;">Don' t have an account? <a href="https://app.ejuno.io/registration" target="_blank" rel="noopener noreferrer" style="color:#e02f8a;text-decoration:underline;font-weight:bold;margin-left:4px;">Register now</a></p></div><div id="otpSection" style="display:none;"><h3 style="color:#333;margin-bottom:10px;">Verify Your Email</h3><p style="font-size:13px;color:#666;margin-bottom:15px;"> We’ve sent a 6-digit verification code to <br><span id="otpEmail" style="color:#e02f8a;font-weight:bold;"></span></p><div style="display:flex;justify-content:space-between;margin-bottom:16px;"> ${[1,2,3,4,5,6].map(i => `<input type="text"maxlength="1" class="otp-input" id="otp-${i}" style="width:45px;height:50px;text-align:center;font-size:18px;border:1px solid#ccc;border-radius:6px;"/>`).join('')} </div><p style="font-size:13px;color:#666;"> Didn’t receive the code? <a href="#" id="resendOtp" style="color:#e02f8a;text-decoration:none;font-weight:bold;">Resend OTP</a></p><button id="verifyOtpBtn" style="width:100%;padding:12px;font-size:15px;background:#e02f8a;color:#fff;border:none;border-radius:6px;cursor:pointer;margin-top:12px;">Verify OTP</button></div></div> `;document.body.appendChild(popup);document.getElementById("closePopup").addEventListener("click",()=>{document.body.removeChild(popup);});function setLegacySendOtpLoading(btn,loading){if(!btn)return;if(loading){btn.disabled=true;btn.dataset.originalLabel=btn.dataset.originalLabel||btn.textContent.trim();btn.innerHTML='<span class="cdp-btn-spinner" aria-hidden="true" style="display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:cdpBtnSpin .7s linear infinite;vertical-align:middle;margin-right:8px;"></span> Sending…';}else{btn.disabled=false;btn.textContent=btn.dataset.originalLabel||"Send OTP →";}}document.getElementById("sendOtpBtn").addEventListener("click",()=>{const sendBtn=document.getElementById("sendOtpBtn");if(sendBtn.disabled)return;const email=document.getElementById("loginEmail").value.trim();if(!email){showNotification("Please enter your email","error");return;}savedEmail=email;setLegacySendOtpLoading(sendBtn,true);fetch("https://ejuno.skylinxtech.co/api/couples/send-login-otp",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({contactEmail:email})}).then(res=>res.json()).then(()=>{document.getElementById("emailSection").style.display="none";document.getElementById("otpSection").style.display="block";document.getElementById("otpEmail").innerText=email;showNotification("OTP sent to your email","success");}).catch(err=>{showNotification("Failed to send OTP","error");}).finally(()=>{setLegacySendOtpLoading(sendBtn,false);});});document.getElementById("resendOtp").addEventListener("click",(e)=>{e.preventDefault();if(!savedEmail){showNotification("Email not found. Please restart login.","error");return;}fetch("https://ejuno.skylinxtech.co/api/couples/send-login-otp",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({contactEmail:savedEmail})}).then(res=>res.json()).then(()=>{showNotification("OTP resent to your email","success");}).catch(err=>{showNotification("Failed to resend OTP","error");});});const otpInputs=popup.querySelectorAll(".otp-input");otpInputs.forEach((input,idx)=>{input.addEventListener("input",()=>{if(input.value.length===1&&idx<otpInputs.length-1){otpInputs[idx+1].focus();}});});document.getElementById("verifyOtpBtn").addEventListener("click",()=>{const otp=Array.from(otpInputs).map(inp=>inp.value).join("");if(otp.length!==6){showNotification("Please enter the full 6-digit OTP","error");return;}fetch("https://ejuno.skylinxtech.co/api/couples/verify-login-otp",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({contactEmail:savedEmail,otp})}).then(res=>res.json()).then(data=>{if(data.status){if(typeof window.persistCdpLoginSession==="function"){window.persistCdpLoginSession(data);}else{const payload=data.data||{};const user=payload.user||{};const customerId=payload.customerId||user.customerId;const authToken=payload.authToken||payload.token;const contactEmail=payload.contactEmail||user.contactEmail;const firstName=payload.firstName||user.firstName;const lastName=payload.lastName||user.lastName;const role=String(payload.role||user.role||"").toLowerCase();localStorage.setItem("customerId",customerId);localStorage.setItem("authToken",authToken);localStorage.setItem("customerEmail",contactEmail);localStorage.setItem("customerFirstName",firstName);localStorage.setItem("customerLastName",lastName);if(role){localStorage.setItem("customerRole",role);localStorage.setItem("customerType",role==="guest"?"guest":"couple");}try{document.dispatchEvent(new CustomEvent("cdpAuthChanged"));}catch(e){}if(typeof window.syncCdpRegistryButtonVisibility==="function")window.syncCdpRegistryButtonVisibility();}showNotification("Login successful","success");document.body.removeChild(popup);bookVenueOrService(requestData);}else{showNotification(data.message||"Invalid OTP","error");}}).catch(err=>{showNotification("Failed to verify OTP","error");});});}
window.showLoginPopupnew = showLoginPopupnew;

/* --- showOliversDatePopup --- */
function showOliversDatePopup(requestData){const popup=document.createElement("div");popup.className="olivers-date-popup";popup.style.cssText='position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:99999;font-family:Arial,sans-serif;';popup.innerHTML=` <div style="background:#fff;padding:20px;border-radius:12px;width:450px;max-width:95%;text-align:center;position:relative;box-shadow:0 8px 30px rgba(0,0,0,0.2);"><button id="closeOliversPopup" class="cdp-modal-close" aria-label="Close">&times;</button><h2 style="color:#e02f8a;margin-bottom:20px;">Select Your Dates</h2><div style="margin-bottom:20px;text-align:left;"><label style="display:block;margin-bottom:6px;font-size:14px;color:#555;font-weight:bold;"> Check-In Date <span style="color:#e02f8a;">*</span></label><input type="date" id="olivers-checkin" required style="width:100%;padding:12px;border:1px solid #ddd;border-radius:6px;font-size:14px;" /></div><div style="margin-bottom:25px;text-align:left;"><label style="display:block;margin-bottom:6px;font-size:14px;color:#555;font-weight:bold;"> Check-Out Date <span style="color:#e02f8a;">*</span></label><input type="date" id="olivers-checkout" required style="width:100%;padding:12px;border:1px solid #ddd;border-radius:6px;font-size:14px;" /></div><button id="confirmOliversBooking" style="width:100%;padding:12px;font-size:15px;background:#e02f8a;color:#fff;border:none;border-radius:6px;cursor:pointer;font-weight:600;">Confirm Booking</button></div> `;document.body.appendChild(popup);const checkinInput=document.getElementById('olivers-checkin');const checkoutInput=document.getElementById('olivers-checkout');const today=new Date().toISOString().split('T')[0];checkinInput.min=today;checkinInput.addEventListener('change',()=>{const selectedCheckin=new Date(checkinInput.value);const minCheckout=new Date(selectedCheckin);minCheckout.setDate(minCheckout.getDate()+1);checkoutInput.min=minCheckout.toISOString().split('T')[0];if(checkoutInput.value&&new Date(checkoutInput.value)<=selectedCheckin){checkoutInput.value='';}});document.getElementById('closeOliversPopup').addEventListener('click',()=>{document.body.removeChild(popup);});document.getElementById('confirmOliversBooking').addEventListener('click',()=>{const checkinDate=document.getElementById('olivers-checkin').value;const checkoutDate=document.getElementById('olivers-checkout').value;if(!checkinDate){showVenueValidationMessage('Please select a check-in date.','error');return;}if(!checkoutDate){showVenueValidationMessage('Please select a check-out date.','error');return;}const checkoutDateObj=new Date(checkoutDate);const checkinDateObj=new Date(checkinDate);if(checkoutDateObj<=checkinDateObj){showVenueValidationMessage('Check-out date must be after check-in date','error');return;}document.body.removeChild(popup);requestData.date=checkinDate;requestData.checkoutDate=checkoutDate;window.bookOliversTravel(requestData);});}
window.showOliversDatePopup = showOliversDatePopup;
